import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

import { View } from "react-native";
import FakeData from ".././fake-data";
import { Link } from "react-router-dom";
import { CommentCollection, TimeLineCollectionComment } from "./GAME";
import Geosuggest from "react-geosuggest";
import InputTrigger from 'react-input-trigger';
import convert from "convert-units";
import {
	Fixture,
	GmcFixture,
	AddPlayersForm,
	Stand,
	GameTeamsForm,
	GameVenueSportForm,
	GameDateTimeForm,
	GameAdminHalfForm,
	GameVenueTimeForm,
	GameAdminForm
} from "./GMC";
import CountryCodes from "./CountryCodes";
import { parse, format, asYouType, isValidNumber } from "libphonenumber-js";
import Remarkable from "remarkable";
import EmojiPicker from "./EmojiPicker";

import { ReactCSSTransitionGroup } from "react-transition-group";
import { EmbedMaterial, EmbedVideo } from "./Training";
import { window } from "d3-selection";
import VideoStreamTV, {
	VideoPlayer as StreamVideoPlayer,
	VideoItemOffline
} from "./VideoStreamTV";
import RichTextInputField from "./RichTextInputField";
import { ChatMessage } from "../pages/Chat";
import matchPhrase from "../words";
const moment = window.moment;
const $ = FakeData.$;
const angular = window.angular;
const Europa = window.Europa;
const { flvjs, FLVJSPlayback, Clappr } = FakeData;

if (window.emojify) {
	window.emojify.setConfig({ img_dir: "images/emojis" });
}
const EventSource = window.EventSource;

export const EmptyState = props => {
	if (props.isShown) {
		const { style } = props;
		return (
			<div style={{ ...style }} className="internal-notice-center-body-empty">
				<i className="material-icons">{props.icon}</i>
				<p>{props.text}</p>
				{props.onClick && (
					<button onClick={props.onClick}>{props.actionLabel}</button>
				)}
			</div>
		);
	} else {
		return null;
	}
};

export const InputField = props => {
	return (
		<div
			className="input-field"
			style={{ ...props.style }}
			tabIndex={props.tabIndex}
		>
			<span>{props.label}</span>
			{props.children}
		</div>
	);
};

export const LoadingState = props => {
	if (props.isShown) {
		const { style, spinnerStyle, text } = props;
		return (
			<div className="loading-holder" style={{ ...style }}>
				<div className="loading-spinner" style={{ ...spinnerStyle }} />
				{(text !== "" || !text) && <div className="loading-text">{text}</div>}
			</div>
		);
	} else {
		return null;
	}
};

export const Modal = props => {
	if (props.isOpen) {
		return <_Modal {...props} />;
	} else {
		return null;
	}
};

class _Modal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			class: "open"
		};
		this.thisClose = this.thisClose.bind(this);
		this.el = document.createElement("div");
		this.el.className = "root-modal";
	}

	componentDidMount() {
		if (window.SPToggleBody) {
			window.SPToggleBody();
		}

		if (window.toggleLeagueSplit) {
			window.toggleLeagueSplit();
		}

		document.getElementById("root").appendChild(this.el);
	}

	componentWillUnmount() {
		if (window.SPToggleBody) {
			window.SPToggleBody();
		}

		if (window.toggleLeagueSplit) {
			window.toggleLeagueSplit();
		}

		//this.props.onClose();
		document.getElementById("root").removeChild(this.el);
	}

	componentWillUpdate(nextProps, nextState) {
		if (
			(this.elem !== undefined || this.elem !== null) &&
			this.props.isOpen !== nextProps.isOpen
		) {
			const elem = $(this.elem);
			elem.fadeOut("fast");
		}
	}

	close = () => {
		const _that = this
		if (!_that.props.onClose) {
			return;
		}
		this.setState({ class: "close" });
		//_that.props.onClose();
		setTimeout(() => {
			_that.props.onClose();
		}, 500);
	};

	thisClose(e) {
		const elem = $(e.target);
		const _that = this;
		if (!_that.props.onClose) {
			return;
		}
		if (elem.attr("name") === "body") {
			elem.fadeOut("fast", function () {
				//_that.close();
				_that.props.onClose();
			});
		}
	}

	render() {
		const { isTransparent, classes, style, onClose } = this.props;
		if (this.props.isOpen) {
			return ReactDOM.createPortal(
				<div
					className={"modal open"}
					ref={ref => (this.elem = ref !== null ? ref : this.elem)}
					name="body"
					onClick={this.thisClose}
				>
					<div
						className={"modal-body " + classes}
						style={{ background: isTransparent ? "transparent" : "", ...style }}
						name="content"
						onClick={() => {
							return;
						}}
						tabIndex={0}
						ref={node => {
							if (node && isTransparent) {
								node.style.setProperty(
									"background",
									"transparent",
									"important"
								);
							}
						}}
					>
						{onClose && <button className="modal-close" onClick={this.close.bind(this)} />}
						<div
							style={{
								maxHeight: "90vh",
								overflowX: "hidden",
								overflowY: "auto"
							}}
						>
							{this.props.children}
						</div>
					</div>
				</div>,
				this.el
			);
		}
		return null;
	}
}

export class WeightHeightPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			list: this.props.type === "weight" ? ["kg", "lb"] : ["cm", "ft"],
			from: this.props.type === "weight" ? "kg" : "cm",
			isWeight: this.props.type === "weight" ? true : false,
			fromValue: 0,
			to: this.props.type === "weight" ? "lb" : "ft",
			toValue: 0
		};
	}

	setFrom(ms) {
		//console.log(ms)
		this.setState({
			from: ms,
			to: this.state.list[0] === ms ? this.state.list[1] : this.state.list[0]
		});
		this.fromField.blur();
		this.renderTo();
	}

	renderTo() {
		if (this.state.isWeight) {
			let valTo = convert(this.fromValue)
				.from(this.state.from)
				.to(this.state.to);
			let valFrom = this.fromValue;

			this.props.onChange(
				Math.floor(valFrom) +
				this.state.from +
				" (" +
				Math.floor(valTo) +
				this.state.to +
				")"
			);
		} else {
			if (this.state.from === "cm") {
				let valTo = this.fromValue * 0.1 / 3;
				let valFrom = this.fromValue;
				let inch = this.fromValue * 0.1 / 4;

				this.props.onChange(
					Math.floor(valFrom) +
					this.state.from +
					" (" +
					Math.floor(valTo) +
					this.state.to +
					" " +
					Math.floor(inch) +
					"in)"
				);
			} else {
				let valTo = this.fromValue * 0.1 / 3;
				let valFrom = this.fromValue;
				let inch = valTo * 0.1 / 4;

				this.setState({
					toValue: Math.floor(valTo),
					fromValue: Math.floor(valFrom)
				});

				this.props.onChange(
					Math.floor(valFrom) +
					this.state.from +
					" " +
					Math.floor(inch) +
					"in (" +
					Math.floor(valTo) +
					this.state.to +
					")"
				);
			}
		}
	}

	render() {
		return (
			<div className={"weight-height-picker " + this.props.className}>
				<div
					className="weight-height-picker-dl"
					tabIndex={0}
					ref={ref => {
						this.fromField = ref === null ? this.fromField : ref;
					}}
				>
					<span>{this.state.from}</span>
					<div>
						{this.state.list.map((item, i) => {
							if (item === this.state.from) {
								return null;
							}
							return (
								<span key={i} onClick={() => this.setFrom(item)}>
									{item}
								</span>
							);
						})}
					</div>
				</div>
				<input
					type="number"
					onChange={e => {
						const val = e.target.value;
						this.fromValue = val;
						this.setState({
							fromValue: val
						});

						this.renderTo();
					}}
				/>
				{/*<span>To</span>
        <input type="number" value={this.state.toValue} onChange={(e)=>{
          const val = e.target.value;
          this.setState({
            toValue:val
          });

          this.renderFrom()
        }}/>
        <div className="weight-height-picker-dl" tabIndex={0} ref={(ref)=>{
            this.toField = (ref===null)?this.toField :ref
          }}>
          <span>{this.state.to}</span>
          <div>
            {
              this.state.list.map((item,i)=>{
                if(item===this.state.from || item===this.state.to){
                  return null;
                }
                return(
                  <span key={i} onClick={()=>this.setTo(item)}>{item}</span>
                )
              })
            }
          </div>
        </div>*/}
			</div>
		);
	}
}

export class UserPicker extends Component {
	constructor(p) {
		super(p);
		this.state = {
			data: FakeData.listify(this.props.data),
			filteredData: [],
			value: "",
			isFocus: false,
			url: ""
		};
	}

	onTextChange(e) {
		const list = [];
		const val = e.target.value;
		this.setState({ value: val });
		this.state.data.forEach((item, i) => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
				list.push(item);
				this.setState({ filteredData: list });
			}
		});
	}

	selectItem(user) {
		this.setState({
			value: user.name,
			url: user.image
		});

		this.props.onUserSelect(user);
	}

	render() {
		return (
			<div className="user-picker-fb-like">
				<img src={this.state.url} />
				<div className="user-picker-fb-like-input">
					<input
						value={this.state.value}
						onFocus={() => {
							this.setState({ isFocus: true });
						}}
						onChange={this.onTextChange.bind(this)}
						onBlur={() => {
							const _that = this;
							setTimeout(() => {
								_that.setState({ isFocus: false });
							}, 1000);
						}}
					/>
					{this.state.isFocus && (
						<div>
							{this.state.filteredData.map((item, i) => {
								return (
									<span
										key={i}
										onClick={() => {
											this.selectItem(item);
											this.setState({ isFocus: false });
										}}
									>
										{item.name}
									</span>
								);
							})}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export class PublicityPicker extends Component {
	constructor(p) {
		super(p);
		this.state = {
			tags: this.props.tags
				? this.props.tags
				: [
					{ key: 1, icon: "public", name: "Public" },
					{ key: 2, icon: "group", name: "Friends" },
					{ key: 0, icon: "lock", name: "Only Me" }
				],
			selected:
				this.props.value === 2
					? { key: 2, icon: "group", name: "Friends" }
					: this.props.value === 0
						? { key: 0, icon: "lock", name: "Only Me" }
						: { key: 1, icon: "public", name: "Public" }
		};
	}

	select(item) {
		this.setState({
			selected: item
		});
		this.elem.blur();

		this.props.onChange(item.key);
	}

	render() {
		const { style } = this.props;
		return (
			<div
				className={"publicity-picker"}
				tabIndex={0}
				ref={ref => (this.elem = ref === null ? this.elem : ref)}
			>
				<span style={{ ...style }}>
					<i className="material-icons">{this.state.selected.icon}</i>{" "}
					{this.state.selected.name}
				</span>
				<div>
					{this.state.tags.map((item, i) => {
						return (
							<span
								className={item.key === this.state.selected.key ? "active" : ""}
								key={i}
								onClick={() => {
									this.select(item);
								}}
							>
								<i className="material-icons">{item.icon}</i> {item.name}
							</span>
						);
					})}
				</div>
			</div>
		);
	}
}

export class PhonePicker extends Component {
	constructor(p) {
		super(p);
		this.state = {
			data: CountryCodes,
			filteredData: CountryCodes,
			selected: CountryCodes[0],
			value: parse(this.props.value).phone,
			error: false
		};
	}

	componentDidMount() {
		this.getSelected();
	}

	getSelected() {
		const obj = parse(this.props.value);
		CountryCodes.forEach((item, i) => {
			if (item.iso2 === obj.country) {
				this.setState({ selected: item });
			}
		});
	}

	onChange(e) {
		if (e.target.value.length > 10) {
			return;
		}
		let val = e.target.value;
		let finalVal = null;
		if (val.charAt(0) === 0) {
			finalVal = val.slice(1); //.phoneFormat()
		} else {
			finalVal = val; //.phoneFormat()
		}
		this.setState({
			value: finalVal,
			error: isValidNumber(finalVal, this.state.selected.iso2) ? false : true
		});

		const num = format(finalVal, this.state.selected.iso2, "International");

		this.props.onChange(
			num,
			isValidNumber(num, this.state.selected.iso2) ? false : true
		);
	}

	render() {
		return (
			<div className={"phone-picker"}>
				<div
					className="phone-picker-btn"
					tabIndex={0}
					ref={ref => (this.elem = ref === null ? this.elem : ref)}
				>
					<span>
						{this.state.selected.iso2 +
							" ( +" +
							this.state.selected.code +
							" )"}
					</span>
					<div className="data_list">
						{this.state.filteredData.map((item, i) => {
							return (
								<span
									key={i}
									onClick={() => {
										this.setState({ selected: item });
										const num = format(
											this.state.value,
											item.iso2,
											"International"
										);
										this.elem.blur(); //(isValidNumber(num, this.state.selected.iso2)) ? false : true
										this.props.onChange(
											num,
											isValidNumber(num, this.state.selected.iso2)
												? false
												: true
										);
									}}
								>
									{item.name + " ( +" + item.code + " )"}
								</span>
							);
						})}
					</div>
				</div>
				<input
					onKeyPress={e => {
						if (isNaN(String.fromCharCode(e.which))) {
							e.preventDefault();
							return;
						}
					}}
					className={
						this.state.error || this.props.className === "error" ? "error" : ""
					}
					value={this.state.value}
					onChange={this.onChange.bind(this)}
				/>
			</div>
		);
	}
}

export class VideoPlayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			volume: 0.5,
			isPlaying: false,
			duration: 0,
			current: 0
		};
	}

	render() {
		if (this.props.isOpen) {
			return (
				<div className="video-player">
					<video
						ref={ref => (this.videoElem = ref === null ? this.videoElem : ref)}
					/>
					<canvas
						ref={ref =>
							(this.canvasElem = ref === null ? this.canvasElem : ref)
						}
					/>
					<div className="video-player" />
				</div>
			);
		}
		return null;
	}
}

export class ConfirmModal extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.isOpen) {
			return (
				<Modal isOpen={true} onClose={false}>
					<div className="confirm-box">
						<span dangerouslySetInnerHTML={{ __html: this.props.message }} />
						<div className="confirm-box-buttons">
							<button onClick={() => this.props.onOkay(this.props.data)}>
								OK
                </button>
							<button onClick={() => this.props.onCancel()}>Cancel</button>
						</div>
					</div>
				</Modal>
			);
		}
		return null;
	}
}

export class ItemPicker extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isFocus: false,
			data: Array.isArray(this.props.data) ? this.props.data : [],
			filteredData: Array.isArray(this.props.data) ? this.props.data : [],
			value: this.props.value ? this.props.value : "",
			nameTo: "",
			emailTo: "",
			emailError: false,
			nameError: false,
			isModalOpen: false
		};

		this.handleKeyup = this.handleKeyup.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.nameChange = this.nameChange.bind(this);
		this.emailChange = this.emailChange.bind(this);
		this.addAdmin = this.addAdmin.bind(this);
	}

	handleKeyup(e) {
		var bool = e.target.value === "" ? false : true;
		const val = e.target.value;
		const newList = [];
		this.state.data.forEach(item => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
				newList.push(item);
			}
		});

		this.setState({
			isFocus: bool,
			value: val,
			filteredData: newList
		});
	}

	selectItem(item) {
		if (item.id !== null) {
			this.setState({
				isFocus: false,
				value: item.name
			});
			this.props.onSelectedItem(item);
		}
	}

	nameChange(e) {
		this.setState({
			nameTo: e.target.value,
			nameError: false
		});
	}

	emailChange(e) {
		const val = e.target.value;
		if (val.indexOf("@") === -1 || val.indexOf(".") === -1) {
			this.setState({
				emailTo: e.target.value,
				emailError: true
			});
		} else {
			this.setState({
				emailTo: e.target.value,
				emailError: false
			});
		}
	}

	addAdmin() {
		const _that = this;

		if (this.state.emailTo === "" || this.state.emailTo === null) {
			this.setState({
				emailError: true
			});

			return;
		}

		if (this.state.nameTo === "" || this.state.nameTo === null) {
			this.setState({
				nameError: true
			});

			return;
		}

		const dataTo = {
			user: this.props.user,
			name: this.state.nameTo,
			email: this.state.emailTo
		};

		FakeData.post("/inviteAdmin.php?auth0", dataTo, {
			success: data => {
				_that.selectItem(data);
				_that.setState({
					isModalOpen: false
				});
			},
			error: err => { }
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ data: FakeData.listify(nextProps.data) });
	}

	render() {
		const items = Array.isArray(this.state.filteredData)
			? this.state.filteredData
			: [];
		const path = !this.props.path ? "" : this.props.path;
		return (
			<div
				id={this.props.id}
				className="item-picker"
				style={{
					width: this.props.parentWidth
						? this.props.parentWidth
						: this.props.isExtended
							? "100%"
							: "auto"
				}}
			>
				<div
					className="text-field"
					style={{ width: this.props.isExtended ? "100%" : "95%" }}
				>
					{this.props.label && <span>{this.props.label}</span>}
					<div
						className="input-for"
						onMouseLeave={() =>
							this.setState({
								isFocus: false
							})
						}
					>
						<input
							value={this.state.value}
							className={this.props.error ? "error" : ""}
							onChange={e => this.handleKeyup(e)}
						/>
						{this.state.isFocus && (
							<div className="list">
								<div
									onClick={() => this.selectItem(FakeData.getData("yoo"))}
									className="item"
								>
									<img src={FakeData.getData("yoo").image} />
									<span>{"You"}</span>
								</div>
								{items.map((i, pos) => (
									<div
										key={pos}
										onClick={() => this.selectItem(i)}
										className="item"
									>
										<img src={path + i.image} />
										<span>{i.name}</span>
									</div>
								))}
							</div>
						)}
						{items.length <= 0 &&
							this.state.isFocus && (
								<div className="no-results">
									<span>No Results</span>
									{!this.props.teamsOnly && (
										<a
											onClick={() =>
												this.setState({
													isModalOpen: true
												})
											}
										>
											Invite
                    </a>
									)}
								</div>
							)}
					</div>
				</div>
				<Modal
					isOpen={this.state.isModalOpen}
					onClose={() =>
						this.setState({
							isModalOpen: false
						})
					}
				>
					<div className="add-a-team">
						<h1>Invite User</h1>
						<div className="input-field">
							<span>Email</span>
							<input
								value={this.state.emailTo}
								onChange={this.emailChange}
								className={this.state.emailError ? "error" : ""}
							/>
						</div>
						<div className="input-field">
							<span>Name</span>
							<input
								value={this.state.nameTo}
								onChange={this.nameChange}
								className={this.state.nameError ? "error" : ""}
							/>
						</div>
						<button onClick={this.addAdmin}>Add</button>
					</div>
				</Modal>
			</div>
		);
	}
}

export class ComboBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isSelecting: false,
			selectedItem: this.props.placeholder,
			multiples: [],
			data: this.props.data
		};
		this.selectItem = this.selectItem.bind(this);
	}

	selectItem(item) {
		this.setState({
			selectedItem: item.name ? item.name : item,
			isSelecting: false
		});

		this.props.onSelectedItem(item);
	}

	selectMultiple(data) {
		this.state.data.forEach((item, i) => {
			if (item.name && item.name === data.name) {
				item.isSelected = true;
				const isAddedToMultiples =
					this.state.multiples.indexOf(item) > -1 ? true : false;
				if (isAddedToMultiples) {
					item.isSelected = false;
					const index = this.state.multiples.indexOf(item);
					this.state.multiples.splice(index, 1);
					this.setState({
						multiples: this.state.multiples,
						data: this.state.data
					});

					this.setSelected();
				} else {
					item.isSelected = true;
					this.state.multiples.push(item);
					this.setState({
						multiples: this.state.multiples,
						data: this.state.data
					});

					this.setSelected();
				}
			} else {
			}
		});
	}

	setSelected() {
		let str = "";
		if (this.state.multiples.length > 5) {
			this.props.onSelectedItem(this.state.multiples);
			return;
		}
		this.state.multiples.forEach((item, i) => {
			if (i === this.state.multiples.length - 1) {
				str += item.name + "..";
				this.setState({
					selectedItem: str
				});
			} else {
				str += item.name + ", ";
				this.setState({
					selectedItem: str
				});
			}
		});

		this.props.onSelectedItem(this.state.multiples);
	}

	focusContent() {
		const _that = this;
		setTimeout(() => {
			_that.content.focus();
		}, 300);
	}

	render() {
		const items = this.props.multiple ? this.state.data : this.props.data;
		const key = this.props.key ? this.props.key : "name";
		const { holderCss, boxCss, btnCss } = this.props;
		return (
			<div className="combo-holder">
				<span>{this.props.label}</span>
				<div
					className={this.props.error ? "combo-box error" : "combo-box"}
					style={{ ...holderCss }}
				>
					<div
						className="box-field"
						style={{ width: "100%", ...boxCss }}
						onClick={() => {
							this.setState({
								isSelecting: this.state.isSelecting ? false : true
							});

							if (this.state.isSelecting) {
								this.focusContent();
							}
						}}
					>
						<span style={{ whiteSpace: "pre", textOverflow: "ellipsis" }}>
							{!this.props.fixture
								? this.state.selectedItem
								: this.props.placeholder}
						</span>
						<span style={{ ...btnCss }} />
					</div>
					{this.state.isSelecting && (
						<div
							className="box-options"
							tabIndex="0"
							ref={ref => {
								this.content = ref === null ? this.content : ref;
							}}
							onMouseLeave={() =>
								this.setState({
									isSelecting: false
								})
							}
						>
							{FakeData.listify(items).map((item, i) => (
								<div
									className="box-option"
									style={{ backgroundColor: item.isSelected ? "#e3e6eb" : "" }}
									onClick={() => {
										if (this.props.multiple) {
											this.selectMultiple(item);
										} else {
											this.selectItem(item);
										}
									}}
									key={i}
								>
									{typeof item === "object" ? item[key] : item}
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export class PhotoAddModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			files: [],
			uploadedFiles: [],
			tags: [],
			desc: "",
			isLabel: false,
			isSending: false,
			loc: ""
		};

		this.onAddTag = this.onAddTag.bind(this);
	}

	onAddTag(tags) {
		this.setState({
			tags: tags
		});
	}

	onFilesPicked(files) {
		const _that = this;
		let _counter = 0;
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			const fileSize = file.size;
			if (fileSize > 10000000) {
				_counter++;
				continue;
			} else {
				let reader = new FileReader();
				reader.onloadend = () => {
					const newFile = {
						file: file,
						progress: 0,
						url: reader.result
					};

					_that.state.files.push(newFile);

					this.setState({
						files: _that.state.files
					});

					this.uploadFile(newFile);
				};
				reader.readAsDataURL(file);
			}
		}

		if (_counter > 0) {
			console.log("Some of your file were not uploaded due to size limit");
		}
	}

	uploadFile(file) {
		var formdata = new FormData();
		const _that = this;
		let tags = "";
		this.state.tags.forEach(tag => {
			tags += tag.id + "^F,";
		});

		for (let i = 0; i < this.state.tags.length; i++) {
			const tag = this.state.tags[i];
			if (i === this.state.tags.length - 1) {
				tags += tag.id + "^F";
			} else {
				tags += tag.id + "^F,";
			}
		}
		formdata.append("file", file.file);
		formdata.append("location", this.state.loc);
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("toId", this.props.toId);
		formdata.append("objType", "profile");
		const obj = {};
		formdata.forEach((item, i) => {
			obj[i] = item;
		});

		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.files.forEach(f => {
					if (f.url === file.url) {
						f.progress = percent;
						_that.setState({
							files: _that.state.files
						});
					}
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				if (data.id) {
					data.oldUrl = file.url;
					_that.state.uploadedFiles.push(data);
				}
			},
			false
		);

		if (obj["file"] instanceof File) {
			ajax.open(
				"POST",
				this.props.url +
				"&type=" +
				(this.props.isTeam ? this.props.toType : "G") + "&caption=" + this.state.desc
			);
			ajax.send(formdata);
		}
	}

	removeFile(url) {
		const _that = this;
		this.state.files.forEach(f => {
			if (f.url === url) {
				const file = f;
				const dataTo = {
					userId: FakeData.getData("yoo").id,
					img: file,
					tags: this.state.tags
				};

				FakeData.post(
					"/removeMedia.php?auth0",
					dataTo,
					{
						success: res => {
							const pos = _that.state.files.indexOf(f);
							_that.state.files.splice(pos, 1);
							_that.setState({
								files: _that.state.files
							});
						},
						error: err => { }
					},
					true,
					"File Was Removed",
					res => { }
				);
			}
		});

		this.state.uploadedFiles.forEach(f => {
			if (f.oldUrl === url) {
				const pos = this.state.uploadedFiles.indexOf(f);
				this.state.uploadedFiles.splice(pos, 1);
				this.setState({
					uploadedFiles: this.state.uploadedFiles
				});
			}
		});
	}

	onClose(withAction = true) {
		if (withAction) {
			this.state.uploadedFiles.forEach((item, i) => {
				if (item.is_video) {

				} else {
					if (item.is_video) {

					}
				}
			});
		}

		this.setState({
			files: [],
			uploadedFiles: [],
			desc: ""
		});

		this.props.onClose();
	}

	onPost() {
		this.onClose(false);
		this.props.onPost(this.state.desc, this.state.uploadedFiles);
	}

	onPost(item) {
		this.props.onPost(
			this.state.desc,
			this.state.uploadedFiles,
			item,
			this.state.loc
		);
		this.onClose(false);
		this.setState({
			isSending: false
		});
	}

	render() {
		const User = this.props.user;
		const sportsFollowed = User.sportsFollowed ? User.sportsFollowed : [];
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
				<div className="files-upload-holder">
					{this.state.files.length === 0 && (
						<div className="files-to-upload">
							<input
								type="file"
								accept="image/*,video/*"
								onFocus={(e) => {
									if (this.state.desc === "") {
										alert("Enter caption first!");
										e.preventDefault()
										return;
									}
								}}
								disabled={this.state.desc === "" ? true : false}
								onChange={e => this.onFilesPicked(e.target.files)}
								multiple="true"
								style={{ width: "100%", height: "100%", opacity: 0 }}
							/>
						</div>
					)}
					{this.state.files.length > 0 && (
						<div className="files-to-upload" style={{ background: "#fff" }}>
							{this.state.files.map((f, i) => (
								<div key={i} className="image">
									<RawMediaItem url={f.url} type={f.file.type} />
									{f.progress <= 99 && (
										<div className="progress-for">
											<div style={{ width: f.progress + "%" }} />
										</div>
									)}
									{f.progress >= 100 && (
										<div
											className="delete-me"
											onClick={() => this.removeFile(f.url)}
											style={{ cursor: "pointer" }}
										>
											Remove
                    </div>
									)}
								</div>
							))}
						</div>
					)}
					<div className="create_album_details upload-details">
						<div className="add_more_photos">
							<img src=".././images/add_wht.svg" alt="Add more photos" />Add
							more photos
              <input
								type="file"
								accept="image/*,video/*"
								onFocus={(e) => {
									if (this.state.desc === "") {
										alert("Enter caption first!");
										e.preventDefault()
										return;
									}
								}}
								disabled={this.state.desc === "" ? true : false}
								onChange={e => this.onFilesPicked(e.target.files)}
								multiple="true"
								style={{
									width: "112.5%",
									height: "100%",
									opacity: 0,
									margin: "-35px 0px 0px -25px"
								}}
							/>
						</div>
						Say something about these photos
            <textarea
							value={this.state.desc}
							className={this.state.desc === "" ? "error" : ""}
							onChange={e =>
								this.setState({
									desc: e.target.value
								})
							}
						/>
						Where was this taken?<br />
						<Geosuggest
							ref={ref => (this.placeElem = ref)}
							highlightMatch={true}
							onSuggestSelect={item => {
								this.setState({
									loc: item.label
								});
								if (this.placeElem !== null) {
									this.placeElem.blur();
								}
							}}
						/>
						Tag friends<br />
						<br />
						<br />
						<TagView
							user={this.props.user}
							onAddTag={this.onAddTag}
							isShown="true"
							isLabel={this.state.isLabel}
						/>
					</div>
				</div>

				{!this.props.isTeam && (
					<div className="post_to_holder">
						<div
							className="share_post_to_btn"
							style={{ margin: "0px 20px 20px 0px" }}
							onClick={() => this.onPost()}
						>
							Post
            </div>
					</div>
				)}

				{this.props.isTeam && (
					<div className="post_to_holder">
						<div
							className="post_to_sports"
							style={{ display: this.state.isSending ? "block" : "none" }}
						>
							{sportsFollowed.map((item, i) => {
								return (
									<div
										key={i}
										className="post_to_item"
										onClick={() => this.onPost(item)}
									>
										<img
											src={".././images/" + item.name + "_icon_drk.svg"}
											alt="Soccer"
										/>
									</div>
								);
							})}
						</div>
						<div
							className="share_post_to_btn"
							style={{ margin: "0px 20px 20px 0px" }}
							onClick={() =>
								this.setState({
									isSending: this.state.isSending ? false : true
								})
							}
						>
							Post to...
            </div>
					</div>
				)}
			</Modal>
		);
	}
}

export class AlbumAddModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			album: { id: null, title: "", content: "", place: "" },
			isSkippedLocation: false,
			isSkippedContent: false,
			files: [],
			uploadedFiles: [],
			tags: [],
			desc: "",
			isLabel: false,
			isSending: false
		};

		this.onAddTag = this.onAddTag.bind(this);
	}

	onAddTag(tags) {
		this.setState({
			tags: tags
		});
	}

	setTodo() {
		if (this.todoElem === null) {
			return;
		} else {
			this.todoElem.setAttribute("todo", "");
		}
	}

	onFilesPicked(files) {
		const _that = this;
		let _counter = 0;
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			const fileSize = file.size;
			if (fileSize > 10000000) {
				_counter++;
				continue;
			} else {
				let reader = new FileReader();
				reader.onloadend = () => {
					const newFile = {
						file: file,
						progress: 0,
						url: reader.result
					};

					_that.state.files.push(newFile);

					this.setState({
						files: _that.state.files
					});

					this.uploadFile(newFile);
				};
				reader.readAsDataURL(file);
			}
		}

		if (_counter > 0) {
			alert("Some of your file were not uploaded due to size limit");
		}
	}

	uploadFile(file) {
		if (!file.file) {
			return;
		}
		var formdata = new FormData();
		const _that = this;
		let tags = "";
		this.state.tags.forEach(tag => {
			tags += tag.id + "^F,";
		});

		for (let i = 0; i < this.state.tags.length; i++) {
			const tag = this.state.tags[i];
			if (i === this.state.tags.length - 1) {
				tags += tag.id + "^F";
			} else {
				tags += tag.id + "^F,";
			}
		}
		formdata.append("file", file.file);
		formdata.append("location", this.state.album.place);
		formdata.append("albumId", this.state.album.id);
		formdata.append("tags", "");
		formdata.append("toId", this.props.toId);
		formdata.append("objType", "profile");

		const obj = {};
		formdata.forEach((item, i) => {
			obj[i] = item;
		});

		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.files.forEach(f => {
					if (f.url === file.url) {
						f.progress = percent;
						_that.setState({
							files: _that.state.files
						});
					}
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				if (data.id) {
					data.oldUrl = file.url;
					_that.state.uploadedFiles.push(data);
				}
			},
			false
		);

		if (obj["file"] instanceof File) {
			ajax.open("POST", this.props.url + "&type=" + this.props.toType);
			ajax.send(formdata);
		}
	}

	removeFile(url) {
		const _that = this;
		this.state.files.forEach(f => {
			if (f.url === url) {
				const file = f;
				const dataTo = {
					userId: FakeData.getData("yoo").id,
					img: file,
					tags: this.state.tags
				};

				FakeData.post(
					"/removeMedia.php?auth0",
					dataTo,
					{
						success: res => {
							const pos = _that.state.files.indexOf(f);
							_that.state.files.splice(pos, 1);
							_that.setState({
								files: _that.state.files
							});
						},
						error: err => { }
					},
					true,
					"File Was Removed",
					res => { }
				);
			}
		});

		this.state.uploadedFiles.forEach(f => {
			if (f.oldUrl === url) {
				const pos = this.state.uploadedFiles.indexOf(f);
				this.state.uploadedFiles.splice(pos, 1);
				this.setState({
					uploadedFiles: this.state.uploadedFiles
				});
			}
		});
	}

	onClose() {
		this.setState({
			album: { id: null, title: "", content: "", place: "" },
			isSkippedLocation: false,
			isSkippedContent: false,
			files: [],
			uploadedFiles: [],
			tags: [],
			desc: "",
			isLabel: false,
			isSending: false
		});
		this.props.onClose();
	}

	addAlbum() {
		const _that = this;
		const dataTo = {
			userId: this.props.isAdmin ? this.props.toId : FakeData.getData("yoo").id,
			userType: this.props.isAdmin ? this.props.toType : "F",
			userToId: this.props.toId,
			userToType: this.props.toType,
			albumTitle: this.state.album.title,
			albumDesc: this.state.album.content,
			albumLocation: this.state.album.place,
			albumType: this.props.toType
		};

		FakeData.post("/createAlbum.php?auth0", dataTo, {
			success: res => {
				_that.setState({
					album: res
				});
			},
			error: err => { }
		});
	}

	onPost(item) {
		this.props.onPost(
			this.state.desc,
			this.state.uploadedFiles,
			item,
			this.state.album.place
		);
		this.onClose();
		this.setState({
			isSending: false
		});
	}

	render() {
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
				<div className="files-upload-holder">
					{this.state.album.id === null && (
						<div className="files-to-upload">
							<div
								ref={ref => {
									this.todoElem = ref;
									this.setTodo();
								}}
							>
								<h1>TODO</h1>
								<ul>
									<li className={this.state.album.title !== "" ? "done" : ""}>
										Enter Album title
                  </li>
									<li
										className={
											this.state.album.content !== "" ||
												this.state.isSkippedContent
												? "done"
												: ""
										}
									>
										Enter Album description (<a
											onClick={() => {
												this.setState({
													isSkippedContent: this.state.isSkippedContent
														? false
														: true
												});
											}}
										>
											skip
                    </a>)
                  </li>
									<li
										className={
											this.state.album.place !== "" ||
												this.state.isSkippedLocation
												? "done"
												: ""
										}
									>
										Enter Album location (<a
											onClick={() => {
												this.setState({
													isSkippedLocation: this.state.isSkippedLocation
														? false
														: true
												});
											}}
										>
											skip
                    </a>)
                  </li>
								</ul>
								<button
									onClick={() => this.addAlbum()}
									disabled={
										this.state.album.title === "" ||
											(this.state.album.place === "" &&
												!this.state.isSkippedLocation) ||
											(this.state.album.content === "" &&
												!this.state.isSkippedContent)
											? true
											: false
									}
								>
									Create
                </button>
							</div>
						</div>
					)}

					{this.state.files.length === 0 &&
						this.state.album.id !== null && (
							<div className="files-to-upload">
								<input
									type="file"
									accept="image/*,video/*"
									onChange={e => this.onFilesPicked(e.target.files)}
									multiple="true"
									style={{ width: "100%", height: "100%", opacity: 0 }}
								/>
							</div>
						)}
					{this.state.files.length > 0 &&
						this.state.album.id !== null && (
							<div className="files-to-upload" style={{ background: "#fff" }}>
								{this.state.files.map((f, i) => (
									<div key={i} className="image">
										<RawMediaItem url={f.url} type={f.file.type} />
										{f.progress <= 99 && (
											<div className="progress-for">
												<div style={{ width: f.progress + "%" }} />
											</div>
										)}
										{f.progress >= 100 && (
											<div
												className="delete-me"
												onClick={() => this.removeFile(f.url)}
												style={{ cursor: "pointer" }}
											>
												Remove
                      </div>
										)}
									</div>
								))}
							</div>
						)}

					<div className="create_album_details upload-details">
						<div className="add_more_photos">
							<img src=".././images/add_wht.svg" alt="Add more photos" />Add
							more photos
              <input
								type="file"
								accept="image/*,video/*"
								disabled={this.state.album.id === null ? true : false}
								onChange={e => this.onFilesPicked(e.target.files)}
								multiple="true"
								style={{
									width: "112.5%",
									height: "100%",
									opacity: 0,
									margin: "-35px 0px 0px -25px"
								}}
							/>
						</div>
						Album Title <br />
						{this.state.album.id === null && (
							<code style={{ fontSize: "9px" }}>
								(Create album before, uploading photos)
              </code>
						)}
						{this.state.album.id === null && <br />}
						<input
							type="text"
							placeholder="Enter Title"
							disabled={this.state.album.id === null ? false : true}
							onChange={e => {
								this.state.album.title = e.target.value;
								this.setState({
									album: this.state.album
								});
							}}
						/>
						Say something about these photos
            <textarea
							value={this.state.desc}
							onChange={e => {
								this.state.album.content = e.target.value;
								this.setState({
									desc: e.target.value,
									album: this.state.album
								});
							}}
						/>
						Where was this taken?<br />
						<Geosuggest
							ref={ref => (this.placeElem = ref)}
							highlightMatch={true}
							onSuggestSelect={item => {
								this.state.album.place = item.label;
								this.setState({
									album: this.state.album
								});
								if (this.placeElem !== null) {
									this.placeElem.blur();
								}
							}}
						/>
						Tag friends<br />
						<br />
						<br />
						<TagView
							user={FakeData.getData("yoo")}
							onAddTag={this.onAddTag}
							isShown="true"
							isLabel={this.state.isLabel}
						/>
					</div>
				</div>
				{this.state.album.id !== null && (
					<div className="post_to_holder">
						<div
							className="post_to_sports"
							style={{ display: this.state.isSending ? "block" : "none" }}
						>
							{FakeData.getData("yoo").sportsFollowed.map((item, i) => {
								return (
									<div
										key={i}
										className="post_to_item"
										onClick={() => this.onPost(item)}
									>
										<img
											src={".././images/" + item.name + "_icon_drk.svg"}
											alt="Soccer"
										/>
									</div>
								);
							})}
						</div>
						<div
							className="share_post_to_btn"
							style={{ margin: "0px 20px 20px 0px" }}
							onClick={() =>
								this.setState({
									isSending: this.state.isSending ? false : true
								})
							}
						>
							Post to...
            </div>
					</div>
				)}
			</Modal>
		);
	}
}

export class CheckInModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loc: "",
			coord: { lat: 0, lng: 0 },
			value: "",
			isSending: false,
			isLocErr: false,
			isValErr: false
		};
	}

	onClose() {
		this.setState({
			loc: "",
			coord: { lat: 0, lng: 0 },
			value: "",
			isSending: false,
			isLocErr: false,
			isValErr: false
		});
		this.props.onClose();
	}

	onPost(item) {
		if (this.state.loc === "") {
			this.setState({
				isLocErr: true
			});

			return;
		}

		if (this.state.value === "") {
			this.setState({
				isValErr: true
			});

			return;
		}

		this.props.onPost(
			this.state.value,
			[],
			item,
			this.state.loc,
			this.state.coord
		);
		this.onClose();
		this.setState({
			isSending: false
		});
	}

	render() {
		const User = FakeData.getData("yoo");
		const sportsFollowed = User.sportsFollowed ? User.sportsFollowed : [];
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
				<div className="add-place">
					<h1>Check In</h1>
					<div className={this.state.isLocErr ? "error" : ""}>
						<Geosuggest
							ref={ref => (this.placeElem = ref)}
							highlightMatch={true}
							onSuggestSelect={item => {
								this.setState({
									loc: item.label,
									coord: item.location,
									isLocErr: false
								});
								if (this.placeElem !== null) {
									this.placeElem.blur();
								}
							}}
						/>
					</div>
					<br />
					<textarea
						className={
							this.state.isValErr ? "check-in-input error" : "check-in-input"
						}
						value={this.state.value}
						placeholder="Write something..."
						onChange={e => {
							this.setState({
								value: e.target.value,
								isValErr: false
							});
						}}
					/>
					<div className="post_to_holder">
						<div
							className="share_post_to_btn"
							style={{ margin: "20px 0px 10px 0px" }}
							onClick={() =>
								this.setState({
									isSending: this.state.isSending ? false : true
								})
							}
						>
							Post to...
            </div>
						<div
							className="post_to_sports"
							style={{
								display: this.state.isSending ? "block" : "none",
								margin: "10px 0px 20px 0px"
							}}
						>
							{sportsFollowed.map((item, i) => {
								return (
									<div
										key={i}
										className="post_to_item"
										onClick={() => this.onPost(item)}
									>
										<img
											src={".././images/" + item.name + "_icon_drk.svg"}
											alt="Soccer"
										/>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export class TagView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dataList: this.props.data
				? this.props.data
				: FakeData.getData("yoo")
					? FakeData.getData("yoo").friends
					: [],
			dataListFiltered: this.props.data
				? this.props.data
				: FakeData.getData("yoo")
					? FakeData.getData("yoo").friends
					: [],
			isFocus: false,
			value: "",
			selected: [],
			withData: this.props.withData ? true : false,
			dataWith: this.props.withData ? this.props.withData : []
		};
	}

	componentDidMount() {
		const _that = this;
		this.getDataID = setInterval(() => {
			if (_that.state.dataList) {
				clearInterval(_that.getDataID);
			}

			_that.setState({
				dataList: this.props.data
					? this.props.data
					: FakeData.getData("yoo")
						? FakeData.getData("yoo").friends
						: []
			});
		}, 1000);
	}

	componentWillUnmount() {
		clearInterval(this.getDataID);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.isLabel && !this.state.withData) {
			this.setState({
				selected: this.props.selected.length > 0 ? this.props.selected : []
			});
		}

		if (nextProps.data) {
			this.setState({
				dataList: nextProps.data
			});
		}
	}

	onTextChange(e) {
		var bool = e.target.value === "" ? false : true;
		const val = e.target.value;
		const newList = [];
		this.state.dataList.forEach(item => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
				newList.push(item);
			}
		});

		this.setState({
			isFocus: bool,
			value: val,
			dataListFiltered: newList
		});
	}

	onSelectedItem(item) {
		item.isTagged = true;
		this.state.selected.push(item);
		this.setState({
			selected: this.state.selected,
			value: ""
		});

		this.state.dataList.forEach(x => {
			if (x.id === item.id) {
				x = item;
				this.setState({
					dataList: this.state.dataList
				});
			}
		});

		this.props.onAddTag(this.state.selected);
		this.setTaggedList();
	}

	setTaggedList() {
		const newList = [];
		this.state.dataList.forEach(item => {
			if (
				!item.isTagged &&
				item.name.toLowerCase().indexOf(this.state.value.toLowerCase()) > -1
			) {
				newList.push(item);
			}
		});

		this.setState({
			dataListFiltered: newList
		});
	}

	removeItem(item) {
		item.isTagged = false;

		this.state.selected.forEach(x => {
			if (x.id === item.id) {
				const index = this.state.selected.indexOf(x);
				this.state.selected.splice(index, 1);
				this.setState({
					dataList: this.state.dataList
				});
			}
		});

		this.state.dataList.forEach(x => {
			if (x.id === item.id) {
				x = item;
				this.setState({
					dataList: this.state.dataList
				});
			}
		});

		this.props.onAddTag(this.state.selected);
		this.setTaggedList();
	}

	render() {
		if (!this.props.isShown) {
			return null;
		}

		if (this.props.style) {
			return (
				<div
					className="tagView"
					style={{ margin: "0px 5px 0px 4px" }}
					onMouseLeave={() =>
						this.setState({
							isFocus: false
						})
					}
				>
					{this.props.isLabel && <div className="tagWithLabel">with</div>}
					<div
						className="tagInput"
						style={{
							margin:
								this.props.withTopElem && !this.props.withData
									? "0px 0px 0px -8px"
									: ""
						}}
					>
						<div className="tagTextBox">
							<div className="tagChips">
								{this.state.selected.map((item, i) => (
									<div
										className="tagChip"
										key={i}
										onClick={() => this.removeItem(item)}
									>
										<img src={item.image} />
										<span style={{ fontSize: "10pt" }}>{item.name}</span>
										<span>x</span>
									</div>
								))}
							</div>
							<input
								value={this.state.value}
								style={{
									border: !this.props.isLabel ? "1px solid #ccc" : "none",
									width: !this.props.isLabel ? "100%" : "auto",
									margin:
										!this.props.isLabel &&
											!this.props.withTopElem &&
											this.state.selected.length === 0
											? "0px 0px 0px -4px"
											: "0px 0px 0px 4px"
								}}
								placeholder="Enter name"
								onChange={e => this.onTextChange(e)}
							/>
						</div>
						{this.state.isFocus && (
							<div className="tagData">
								{this.state.dataListFiltered.map((item, i) => {
									if (item.isTagged) {
										return null;
									} else {
										return (
											<div
												key={i}
												className="dataItem"
												onClick={() => this.onSelectedItem(item)}
												style={{ background: "#4ac" }}
											>
												<img src={item.image} />
												<span>{item.name}</span>
											</div>
										);
									}
								})}
							</div>
						)}
					</div>
				</div>
			);
		}

		if (this.props.withData) {
			return (
				<div
					className="tagView"
					style={
						this.props.style
							? this.props.style
							: {
								margin: this.props.withTopElem
									? "0px 5px 10px 4px"
									: "-16px 5px 10px 4px"
							}
					}
					onMouseLeave={() =>
						this.setState({
							isFocus: false
						})
					}
				>
					{this.props.isLabel && <div className="tagWithLabel">with</div>}
					{this.props.withData && (
						<div
							className="tagInput"
							style={{
								margin: this.props.withTopElem ? "0px 0px 0px 0px" : ""
							}}
						>
							<div className="tagTextBox">
								<div className="tagChips">
									{this.props.withData.map((item, i) => (
										<div className="tagChip" key={i}>
											<img src={item.image} />
											<span style={{ fontSize: "10pt" }}>{item.name}</span>
											<span onClick={() => this.props.onItemRemove(item)}>
												x
                      </span>
										</div>
									))}
								</div>
							</div>
						</div>
					)}
				</div>
			);
		}
		return (
			<div
				className="tagView"
				style={{
					margin: this.props.withTopElem
						? "0px 5px 10px 4px"
						: "-16px 5px 10px 4px"
				}}
				onMouseLeave={() =>
					this.setState({
						isFocus: false
					})
				}
			>
				{this.props.isLabel && <div className="tagWithLabel">with</div>}
				<div
					className="tagInput"
					style={{
						margin:
							this.props.withTopElem && !this.props.withData
								? "0px 0px 0px -8px"
								: ""
					}}
				>
					<div className="tagTextBox">
						<div className="tagChips">
							{this.state.selected.map((item, i) => (
								<div
									className="tagChip"
									key={i}
									onClick={() => this.removeItem(item)}
								>
									<img src={item.image} />
									<span style={{ fontSize: "10pt" }}>{item.name}</span>
									<span>x</span>
								</div>
							))}
						</div>
						<input
							value={this.state.value}
							style={{
								border: !this.props.isLabel ? "1px solid #ccc" : "none",
								width: !this.props.isLabel ? "100%" : "auto",
								margin:
									!this.props.isLabel &&
										!this.props.withTopElem &&
										this.state.selected.length === 0
										? "0px 0px 0px -4px"
										: "0px 0px 0px 4px"
							}}
							placeholder="Enter name"
							onChange={e => this.onTextChange(e)}
						/>
					</div>
					{this.state.isFocus && (
						<div className="tagData">
							{this.state.dataListFiltered.map((item, i) => {
								if (item.isTagged) {
									return null;
								} else {
									return (
										<div
											key={i}
											className="dataItem"
											onClick={() => this.onSelectedItem(item)}
										>
											<img src={item.image} />
											<span>{item.name}</span>
										</div>
									);
								}
							})}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export class MomentPickerModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			reactions: [
				{ id: 0, image: ".././images/react_like.svg", value: "Like" },
				{ id: 0, image: ".././images/react_dislike.svg", value: "Dislike" },
				{ id: 0, image: ".././images/react_laugh.svg", value: "Haha" },
				{ id: 0, image: ".././images/react_wow.svg", value: "Wow" },
				{ id: 0, image: ".././images/react_sad.svg", value: "Sad" },
				{ id: 0, image: ".././images/react_angry.svg", value: "Angry" }
			],
			moments: [
				{
					id: 0,
					image: ".././images/goal_icon_drk.svg",
					value: "Goal",
					filler: "scored"
				},
				{
					id: 0,
					image: ".././images/red_card_icon.svg",
					value: "Red Card",
					filler: "given"
				},
				{
					id: 0,
					image: ".././images/yellow_card_icon.svg",
					value: "Yellow Card",
					filler: "given"
				},
				{
					id: 0,
					image: ".././images/substitution_icon_drk.svg",
					value: "Substitution",
					filler: "made"
				},
				{
					id: 0,
					image: ".././images/yellow_card_icon_ptn.svg",
					value: "Offside",
					filler: "charge"
				},
				{
					id: 0,
					image: ".././images/penalty_icon_drk.svg",
					value: "Penalty",
					filler: "given"
				}
			],
			activeTeam: this.props.game.teamOne.name,
			dataOne: this.props.game.teamOne.players,
			dataTwo: this.props.game.teamTwo.players,
			playersOne: this.props.game.teamOne.players,
			playersTwo: this.props.game.teamTwo.players,
			value: "",
			selectedPlayers: [],
			selectedMoment: {
				value: "",
				image: null
			},
			selectedReaction: {}
		};
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	onClose() {
		this.setState({
			activeTeam: this.props.game.teamOne.name,
			dataOne: this.props.game.teamOne.players,
			dataTwo: this.props.game.teamTwo.players,
			playersOne: this.props.game.teamOne.players,
			playersTwo: this.props.game.teamTwo.players,
			value: "",
			selectedPlayers: [],
			selectedMoment: {},
			selectedReaction: {}
		});

		this.props.onClose(
			this.state.selectedPlayers,
			this.state.selectedReaction,
			this.state.selectedMoment
		);
	}

	filter(e) {
		const val = e;
		const listOne = [];
		const listTwo = [];
		this.state.dataOne.forEach(item => {
			if (item.name.toLowerCase().indexOf(val) > -1) {
				listOne.push(item);
			}
		});

		this.state.dataTwo.forEach(item => {
			if (item.name.toLowerCase().indexOf(val) > -1) {
				listTwo.push(item);
			}
		});

		this.setState({
			playersOne: listOne,
			playersTwo: listTwo,
			value: val
		});
	}

	selectPlayer(team, player) {
		if (team === "one") {
			this.state.dataOne.forEach(item => {
				if (item.id === player.id) {
					item.isSelected = item.isSelected ? false : true;
					this.setState({
						dataOne: this.state.dataOne
					});
					this.filter(this.state.value);
				}
			});
		} else {
			this.state.dataTwo.forEach(item => {
				if (item.id === player.id) {
					item.isSelected = item.isSelected ? false : true;
					this.setState({
						dataTwo: this.state.dataTwo
					});
					this.filter(this.state.value);
				}
			});
		}

		this.addPlayer(player);
	}

	addPlayer(player) {
		if (this.state.selectedPlayers.indexOf(player) === -1) {
			this.state.selectedPlayers.push(player);
			this.setState({
				selectedPlayers: this.state.selectedPlayers
			});
		} else {
			const pos = this.state.selectedPlayers.indexOf(player);
			this.state.selectedPlayers.splice(pos, 1);
			this.setState({
				selectedPlayers: this.state.selectedPlayers
			});
		}
	}

	render() {
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
				<div className="moment-picker">
					<div className="headers">
						<div
							className={this.props.activeTab === "players" ? "active" : ""}
							onClick={() => this.props.setTab("players")}
						>
							<img src=".././images/who_sees_friends.svg" />
							<span>Player</span>
						</div>
						<div
							className={this.props.activeTab === "moment" ? "active" : ""}
							onClick={() => this.props.setTab("moment")}
						>
							<img src=".././images/moment_icon.svg" />
							<span>Key Moment</span>
						</div>
						<div
							className={this.props.activeTab === "reaction" ? "active" : ""}
							onClick={() => this.props.setTab("reaction")}
						>
							<img src=".././images/thumbs_icon.svg" />
							<span>Reaction</span>
						</div>
					</div>
					<div className="bodies">
						{this.props.activeTab === "players" ? (
							<div className="body">
								<div className="labels-for">
									<span
										className={
											this.state.activeTeam === this.props.game.teamOne.name
												? "active"
												: ""
										}
										onClick={() =>
											this.setState({
												activeTeam: this.props.game.teamOne.name
											})
										}
									>
										{this.props.game.teamOne.name}
									</span>
									<span
										className={
											this.state.activeTeam === this.props.game.teamTwo.name
												? "active"
												: ""
										}
										onClick={() =>
											this.setState({
												activeTeam: this.props.game.teamTwo.name
											})
										}
									>
										{this.props.game.teamTwo.name}
									</span>
								</div>
								<div className="player-lists">
									<div
										className={
											this.state.activeTeam === this.props.game.teamOne.name
												? "players-for active"
												: "players-for"
										}
									>
										{this.state.playersOne.map((item, i) => (
											<div
												key={i}
												className={
													item.isSelected ? "this-player active" : "this-player"
												}
												onClick={() => this.selectPlayer("one", item)}
											>
												<img src={item.image} />
												<span>{item.name}</span>
											</div>
										))}
									</div>
									<div
										className={
											this.state.activeTeam === this.props.game.teamTwo.name
												? "players-for active"
												: "players-for"
										}
									>
										{this.state.playersTwo.map((item, i) => (
											<div
												key={i}
												className={
													item.isSelected ? "this-player active" : "this-player"
												}
												onClick={() => this.selectPlayer("two", item)}
											>
												<img src={item.image} />
												<span>{item.name}</span>
											</div>
										))}
									</div>
								</div>
								<div className="search-box">
									<input
										value={this.state.value}
										onChange={e => this.filter(e.target.value)}
									/>
									<img src=".././images/search_friend_drk.svg" />
								</div>
							</div>
						) : this.props.activeTab === "moment" ? (
							<div className="body list">
								{this.state.moments.map((item, i) => (
									<div
										key={i}
										className={
											this.state.selectedMoment.value === item.value
												? "body-item active"
												: "body-item"
										}
										onClick={() =>
											this.setState({
												selectedMoment: item
											})
										}
									>
										<img src={item.image} />
										<span>{item.value}</span>
									</div>
								))}
							</div>
						) : (
									<div className="body list">
										{this.state.reactions.map((item, i) => (
											<div
												key={i}
												className={
													this.state.selectedReaction.value === item.value
														? "body-item active"
														: "body-item"
												}
												onClick={() =>
													this.setState({
														selectedReaction: item
													})
												}
											>
												<img src={item.image} />
												<span>{item.value}</span>
											</div>
										))}
									</div>
								)}

						<button onClick={() => this.onClose()}>Submit</button>
					</div>
				</div>
			</Modal>
		);
	}
}

export class WhoToSeePicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			active: this.props.active,
			tabs: [
				{
					key: "F",
					val: "Friends",
					img: ".././images/who_sees_friends.svg",
					bg: ""
				},
				{
					key: "Q",
					val: "Groups",
					img: ".././images/facebook-group.svg",
					bg: "#58CC66",
					withPadding: true
				},
				{
					key: "T",
					val: "Teams",
					img: ".././images/who_sees_game.svg",
					bg: ""
				},
				{
					key: "C",
					val: "Clubs",
					img: ".././images/club.svg",
					bg: "#f43",
					withPadding: true
				},
				{
					key: "L",
					val: "Tournaments",
					img: ".././images/who_sees_league.svg",
					bg: ""
				},
				{
					key: "I",
					val: "Institutions",
					img: ".././images/institution_icon.svg",
					bg: "#888",
					withPadding: true
				}
			],
			teamSport: "Select Sport",
			tournsSport: "Select Sport",
			gamesSport: "Select Sport",
			user: FakeData.getData("yoo"),
			friends: [],
			tourns: [],
			teams: [],
			games: [],
			clubs: [],
			groups: [],
			institutions: [],
			friendsData: [],
			tournsData: [],
			teamsData: [],
			gamesData: [],
			clubsData: [],
			groupsData: [],
			institutionsData: [],
			playersData: [],
			players: [],
			sub: {
				name: "",
				position: "",
				jersey: 0,
				jerError: false,
				posError: false,
				nameError: false
			},
			newPlayers: [],
			canRecieveActiveTab: true,
			isLoading: true
		};
	}

	componentDidMount() {
		this._isMounted = true;
		if (this.props.isEvent) {
			const data = [];
			this.state.teamsData.forEach((item, i) => {
				if (item.players && item.players.length) {
					item.players.forEach((player, x) => {
						data.push(player);
					});
				}

				/**/
			});

			this.setState({
				playersData: data,
				players: data,
				isLoading: false
			});
		}

		const _that = this;
		if (!this._isMounted) {
			return;
		}
		setTimeout(() => {
			_that.setState({
				friends: FakeData.getData("yoo") ? FakeData.getData("yoo").friends : [],
				tourns: FakeData.getData("yoo") ? FakeData.getData("yoo").leagues : [],
				teams: FakeData.getData("yoo") ? FakeData.getData("yoo").ownTeams : [],
				games: FakeData.getData("yoo") ? FakeData.getData("yoo").games : [],
				groups: FakeData.getData("yoo") ? FakeData.getData("yoo").groups : [],
				clubs: FakeData.getData("yoo") ? FakeData.getData("yoo").clubs : [],
				institutions: FakeData.getData("yoo")
					? FakeData.getData("yoo").institutions
					: [],
				friendsData: FakeData.getData("yoo")
					? FakeData.getData("yoo").friends
					: [],
				tournsData: FakeData.getData("yoo")
					? FakeData.getData("yoo").leagues
					: [],
				teamsData: FakeData.getData("yoo")
					? FakeData.getData("yoo").ownTeams
					: [],
				gamesData: FakeData.getData("yoo") ? FakeData.getData("yoo").games : [],
				clubsData: FakeData.getData("yoo") ? FakeData.getData("yoo").clubs : [],
				groupsData: FakeData.getData("yoo")
					? FakeData.getData("yoo").groups
					: [],
				institutionsData: FakeData.getData("yoo")
					? FakeData.getData("yoo").institutions
					: [],
				isLoading: false
			});
		}, 2000);
	}

	componentWillUnmount() {
		this.setState({ canRecieveActiveTab: false });
		this._isMounted = false;
	}

	componentWillReceiveProps(nextProps) {
		if (!this._isMounted) {
			return;
		}
		if (this.state.canRecieveActiveTab) {
			this.setState({ active: nextProps.active });
		}
	}

	onClose() {
		const arr = [];

		this.state.friendsData.forEach((item, i) => {
			if (item.isSelected) {
				item.type = "F";
				arr.push(item);
			}
		});

		this.state.teamsData.forEach((item, i) => {
			if (item.isSelected) {
				item.type = "T";
				arr.push(item);
			}
		});

		this.state.tournsData.forEach((item, i) => {
			if (item.isSelected) {
				item.type = "L";
				arr.push(item);
			}
		});

		this.state.clubsData.forEach((item, i) => {
			if (item.isSelected) {
				item.type = "C";
				arr.push(item);
			}
		});

		this.state.institutionsData.forEach((item, i) => {
			if (item.isSelected) {
				item.type = "I";
				arr.push(item);
			}
		});

		this.state.groupsData.forEach((item, i) => {
			if (item.isSelected) {
				item.type = "Q";
				arr.push(item);
			}
		});

		this.state.newPlayers.forEach((item, i) => {
			item.type = "P";
			arr.push(item);
		});

		this.setState({
			value: "",
			active: "",
			teamSport: "Select Sport",
			tournsSport: "Select Sport",
			gamesSport: "Select Sport",
			user: FakeData.getData("yoo"),
			friends: FakeData.getData("yoo") ? FakeData.getData("yoo").friends : [],
			tourns: FakeData.getData("yoo") ? FakeData.getData("yoo").leagues : [],
			teams: FakeData.getData("yoo") ? FakeData.getData("yoo").ownTeams : [],
			games: FakeData.getData("yoo") ? FakeData.getData("yoo").games : [],
			groups: FakeData.getData("yoo") ? FakeData.getData("yoo").groups : [],
			clubs: FakeData.getData("yoo") ? FakeData.getData("yoo").clubs : [],
			institutions: FakeData.getData("yoo")
				? FakeData.getData("yoo").institutions
				: [],
			friendsData: FakeData.getData("yoo")
				? FakeData.getData("yoo").friends
				: [],
			tournsData: FakeData.getData("yoo")
				? FakeData.getData("yoo").leagues
				: [],
			teamsData: FakeData.getData("yoo")
				? FakeData.getData("yoo").ownTeams
				: [],
			gamesData: FakeData.getData("yoo") ? FakeData.getData("yoo").games : [],
			clubsData: FakeData.getData("yoo") ? FakeData.getData("yoo").clubs : [],
			groupsData: FakeData.getData("yoo") ? FakeData.getData("yoo").groups : [],
			institutionsData: FakeData.getData("yoo")
				? FakeData.getData("yoo").institutions
				: [],
			isLoading: true,
			sub: {
				name: "",
				position: "",
				jersey: 0,
				jerError: false,
				posError: false,
				nameError: false
			},
			newPlayers: [],
			canRecieveActiveTab: true
		});

		if (!this._isMounted) {
			return;
		}

		this.props.onClose(arr);
	}

	setPlayerVals(key, e) {
		if (key === "name") {
			this.state.sub.name = e.target.value;
			this.state.sub.nameError = false;
			this.setState({
				sub: this.state.sub
			});
		} else if (key === "pos") {
			this.state.sub.position = e.target.value;
			this.state.sub.posError = false;
			this.setState({
				sub: this.state.sub
			});
		} else {
			const val = e.target.value;
			if (val <= 0) {
				this.state.sub.jerError = true;
				this.state.sub.jersey = val;
				this.setState({
					sub: this.state.sub
				});
			} else {
				this.state.sub.jersey = val;
				this.state.sub.jerError = false;
				this.setState({
					sub: this.state.sub
				});
			}
		}
	}

	addPlayer() {
		if (this.state.sub.name === "") {
			this.state.sub.nameError = true;
			this.setState({
				sub: this.state.sub
			});
			return;
		}

		if (this.state.sub.position === "") {
			this.state.sub.posError = true;
			this.setState({
				sub: this.state.sub
			});
			return;
		}

		if (this.state.sub.jersey <= 0) {
			this.state.sub.jerError = true;
			this.setState({
				sub: this.state.sub
			});
			return;
		}

		const _that = this;
		const dataTo = {
			name: this.state.sub.name,
			position: this.state.sub.position,
			jersey: this.state.sub.jersey,
			teamId: this.props.team.id,
			squadId: this.props.team.squadId
		};

		FakeData.post("/createNewPlayer.php?auth0", dataTo, {
			success: data => {
				const newPlayer = data;
				_that.onPlayerAdd(newPlayer);

				_that.setState({
					isPlayerModal: false,
					sub: {
						name: "",
						position: "",
						jersey: 0,
						jerError: false,
						posError: false,
						nameError: false
					}
				});
			},
			error: err => { }
		});
	}

	onPlayerAdd(newPlayer) {
		this.state.newPlayers.push(newPlayer);
		this.setState({
			newPlayers: this.state.newPlayers
		});
	}

	onTextChange(val) {
		const newFriends = [];
		const newTeams = [];
		const newGames = [];
		const newTourns = [];
		const newPlayers = [];
		const friendsData = this.state.friendsData ? this.state.friendsData : [];
		const teamsData = this.state.teamsData ? this.state.teamsData : [];
		const tournsData = this.state.tournsData ? this.state.tournsData : [];

		this.setState({
			value: val
		});

		const clubs = this.state.clubsData.filter(item => {
			return item.name.toLowerCase().indexOf(val.toLowerCase()) >= 0;
		});

		const groups = this.state.groupsData.filter(item => {
			return item.name.toLowerCase().indexOf(val.toLowerCase()) >= 0;
		});

		const institutions = this.state.institutionsData.filter(item => {
			return item.name.toLowerCase().indexOf(val.toLowerCase()) >= 0;
		});

		this.setState({ clubs, groups, institutions });

		friendsData.forEach((item, i) => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
				newFriends.push(item);
				this.setState({
					friends: newFriends
				});
			}
		});

		teamsData.forEach((item, i) => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
				newTeams.push(item);
				this.setState({
					teams: newTeams
				});
			}
		});

		tournsData.forEach((item, i) => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
				newTourns.push(item);
				this.setState({
					tourns: newTourns
				});
			}
		});
	}

	selectFriends(data) {
		this.state.friendsData.forEach((item, i) => {
			if (item.id === data.id) {
				item.isSelected = item.isSelected ? false : true;
				this.setState({
					friendsData: this.state.friendsData
				});
				this.onTextChange(this.state.value);
			}
		});
	}

	selectTeams(data) {
		this.state.teamsData.forEach((item, i) => {
			if (item.id === data.id && item.squadId === data.squadId) {
				item.isSelected = item.isSelected ? false : true;
				this.setState({
					teamsData: this.state.teamsData
				});
				this.onTextChange(this.state.value);
			}
		});
	}

	selectTourns(data) {
		this.state.tournsData.forEach((item, i) => {
			if (item.id === data.id) {
				item.isSelected = item.isSelected ? false : true;
				this.setState({
					tournsData: this.state.tournsData
				});
				this.onTextChange(this.state.value);
			}
		});
	}

	selectClubs(data) {
		this.state.clubsData.forEach((item, i) => {
			if (item.id === data.id) {
				item.isSelected = item.isSelected ? false : true;
				this.setState({
					clubsData: this.state.clubsData
				});
				this.onTextChange(this.state.value);
			}
		});
	}

	selectGroups(data) {
		this.state.groupsData.forEach((item, i) => {
			if (item.id === data.id) {
				item.isSelected = item.isSelected ? false : true;
				this.setState({
					groupsData: this.state.groupsData
				});
				this.onTextChange(this.state.value);
			}
		});
	}

	selectInstitutions(data) {
		this.state.institutionsData.forEach((item, i) => {
			if (item.id === data.id) {
				item.isSelected = item.isSelected ? false : true;
				this.setState({
					institutionsData: this.state.institutionsData
				});
				this.onTextChange(this.state.value);
			}
		});
	}

	onSelectedItem(data, key) {
		if (key === "T") {
			const items = [];
			this.state.teamsData.forEach((item, i) => {
				if (item.sport === null) {
				} else if (item.sport.toLowerCase() === data.toLowerCase()) {
					items.push(item);
					this.setState({
						teamsData: items,
						teamSport: data
					});
				}
			});

			this.onTextChange(this.state.value);
		} else if (key === "L") {
			const items = [];
			this.state.tournsData.forEach((item, i) => {
				if (item.sport === null) {
				} else if (item.sport.toLowerCase() === data.toLowerCase()) {
					items.push(item);
					this.setState({
						tournsData: items,
						tournsSport: data
					});

					this.onTextChange(this.state.value);
				}
			});
		}
	}

	getSportsName(arr) {
		const array = [];
		arr.forEach((item, i) => {
			if (item.name === null) {
			} else {
				array.push(item.name);
			}
		});
		return array;
	}

	render() {
		const sports = this.getSportsName(
			this.state.user.mySport ? this.state.user.mySport : []
		);
		if (!this.props.isOpen) {
			return null;
		}
		const { filters, isVideo } = this.props;
		const _filters = filters
			? FakeData.listify(filters)
			: ["F", "I", "C", "L", "Q", "P", "T"];
		return (
			<Modal
				isOpen={this.props.isOpen}
				onClose={() => this.onClose()}
				style={{
					borderRadius: isVideo ? "1.3em" : ""
				}}
			>
				{this.state.isLoading && (
					<LoadingState
						style={{ width: "20vw", height: "20vw" }}
						isShown={this.state.isLoading}
						text={"Loading..."}
					/>
				)}
				{!this.state.isLoading && (
					<div
						className="who-to-see"
						style={{
							width: "50vw",
							borderRadius: isVideo ? "1.3em" : "",
							overflow: isVideo ? "hidden" : ""
						}}
					>
						<div
							className="who-to-see-tabs"
							style={{
								borderBottom: isVideo ? "1px solid #eee" : ""
							}}
						>
							{this.state.tabs.map((item, i) => {
								if (item.key === "G") {
									return null;
								}

								if (
									this.props.isEvent &&
									(item.key === "G" || item.key === "L")
								) {
									return null;
								}

								if (!this.props.isEvent && item.key === "P") {
									return null;
								}

								if (!FakeData.inArray(item.key, _filters)) {
									return null;
								}

								return (
									<div
										key={i}
										className={
											item.key === this.state.active
												? isVideo
													? "active-video"
													: "active"
												: ""
										}
										onClick={() => {
											this.setState({
												active: item.key,
												canRecieveActiveTab: false
											});
										}}
										style={{
											background: isVideo
												? item.key === this.state.active
													? "#4ea3c9"
													: "#fff"
												: "",
											color: isVideo
												? item.key === this.state.active
													? "#fff"
													: "#000"
												: ""
										}}
									>
										<img
											src={item.img}
											style={{
												background: item.bg,
												borderRadius: "100px",
												padding: item.withPadding ? "2px" : ""
											}}
										/>
										<span>{item.val}</span>
									</div>
								);
							})}
						</div>
						<div className="who-to-see-views">
							{this.state.active === "F" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view to-friends-picker">
										{this.state.friends.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectFriends(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										{this.state.friends.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return !item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectFriends(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										<EmptyState
											isShown={this.state.friends.length > 0 ? false : true}
											style={{
												width: "100%",
												height: "auto",
												padding: "10px 0px"
											}}
											text="No results were found!"
										/>
									</div>
								)}

							{this.state.active === "T" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view to-friends-picker">
										{this.state.teams.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectTeams(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										{this.state.teams.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return !item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectTeams(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										<EmptyState
											isShown={this.state.teams.length > 0 ? false : true}
											style={{
												width: "100%",
												height: "auto",
												padding: "10px 0px"
											}}
											text="No results were found!"
										/>
									</div>
								)}

							{this.state.active === "G" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view to-teams-picker">
										<ComboBox
											placeholder={this.state.teamSport}
											onSelectedItem={item => this.onSelectedItem(item, "G")}
											data={sports}
										/>
									</div>
								)}

							{this.state.active === "L" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view to-friends-picker">
										{this.state.tourns.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectTourns(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										{this.state.tourns.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return !item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectTourns(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										<EmptyState
											isShown={this.state.tourns.length > 0 ? false : true}
											style={{
												width: "100%",
												height: "auto",
												padding: "10px 0px"
											}}
											text="No results were found!"
										/>
									</div>
								)}

							{this.state.active === "C" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view to-friends-picker">
										{this.state.clubs.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectClubs(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										{this.state.clubs.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return !item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectClubs(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										<EmptyState
											isShown={this.state.clubs.length > 0 ? false : true}
											style={{
												width: "100%",
												height: "auto",
												padding: "10px 0px"
											}}
											text="No results were found!"
										/>
									</div>
								)}

							{this.state.active === "I" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view to-friends-picker">
										{this.state.institutions.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectInstitutions(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										{this.state.institutions.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return !item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectInstitutions(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										<EmptyState
											isShown={
												this.state.institutions.length > 0 ? false : true
											}
											style={{
												width: "100%",
												height: "auto",
												padding: "10px 0px"
											}}
											text="No results were found!"
										/>
									</div>
								)}

							{this.state.active === "Q" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view to-friends-picker">
										{this.state.groups.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectGroups(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										{this.state.groups.filter((item, i) => {
											const block = FakeData.getBlocked({ props: {} }, false, [this.state.active]);
											return !FakeData.inArray(item.id, block)
										})
											.filter(item => {
												return !item.isSelected;
											})
											.filter((item, i) => {
												return i < 50;
											})
											.map((item, i) => (
												<div
													key={i}
													className={item.isSelected ? "selected" : ""}
													onClick={() => this.selectGroups(item)}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											))}
										<EmptyState
											isShown={this.state.groups.length > 0 ? false : true}
											style={{
												width: "100%",
												height: "auto",
												padding: "10px 0px"
											}}
											text="No results were found!"
										/>
									</div>
								)}

							{this.state.active === "P" &&
								FakeData.inArray(this.state.active, _filters) && (
									<div className="who-to-see-view">
										<div className="input-field">
											<span>Player Name</span>
											<input
												style={{ padding: "0.5em", lineHeight: "16px" }}
												className={this.state.sub.nameError ? "error" : ""}
												onChange={e => this.setPlayerVals("name", e)}
												value={this.state.sub.name}
											/>
										</div>
										<div className="split-input">
											<div className="input-field">
												<span>Position</span>
												<input
													style={{ padding: "0.5em", lineHeight: "16px" }}
													className={this.state.sub.posError ? "error" : ""}
													onChange={e => this.setPlayerVals("pos", e)}
													value={this.state.sub.position}
												/>
											</div>
											<div className="input-field">
												<span>Jersey</span>
												<input
													style={{ padding: "0.5em", lineHeight: "16px" }}
													type="number"
													className={this.state.sub.jerError ? "error" : ""}
													onChange={e => this.setPlayerVals("jer", e)}
													value={this.state.sub.Jersey}
												/>
											</div>
										</div>
										<button
											className="button"
											onClick={() => {
												this.addPlayer();
											}}
										>
											Add Player
                    </button>
									</div>
								)}

							<div className="who-to-see-filter-bottom">
								<input onChange={e => this.onTextChange(e.target.value)} />
								<span />
								<button onClick={() => this.onClose()}>Add Selected</button>
							</div>
						</div>
					</div>
				)}
			</Modal>
		);
	}
}

export class AddNewPlayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isSubModal: false,
			isPlayerModal: false,
			sub: {
				name: "",
				position: "",
				jersey: 0,
				jerError: false,
				posError: false,
				nameError: false
			},
			team: { id: null },
			teamError: false
		};

		this.setPlayerVals = this.setPlayerVals.bind(this);
		this.addPlayer = this.addPlayer.bind(this);
	}

	setPlayerVals(key, e) {
		if (key === "name") {
			this.state.sub.name = e.target.value;
			this.state.sub.nameError = false;
			this.setState({
				sub: this.state.sub
			});
		} else if (key === "pos") {
			this.state.sub.position = e.target.value;
			this.state.sub.posError = false;
			this.setState({
				sub: this.state.sub
			});
		} else {
			const val = e.target.value;
			if (val <= 0) {
				this.state.sub.jerError = true;
				this.state.sub.jersey = val;
				this.setState({
					sub: this.state.sub
				});
			} else {
				this.state.sub.jersey = val;
				this.state.sub.jerError = false;
				this.setState({
					sub: this.state.sub
				});
			}
		}
	}

	addPlayer() {
		if (this.state.team.id === null) {
			this.setState({
				teamError: true
			});

			return;
		}

		if (this.state.sub.name === "") {
			this.state.sub.nameError = true;
			this.setState({
				sub: this.state.sub
			});
			return;
		}

		if (this.state.sub.position === "") {
			this.state.sub.posError = true;
			this.setState({
				sub: this.state.sub
			});
			return;
		}

		if (this.state.sub.jersey <= 0) {
			this.state.sub.jerError = true;
			this.setState({
				sub: this.state.sub
			});
			return;
		}

		const _that = this;
		const dataTo = {
			name: this.state.sub.name,
			position: this.state.sub.position,
			jersey: this.state.sub.jersey,
			teamId: this.state.team.id,
			squadId: this.state.team.squadId
		};

		FakeData.post("/createNewPlayer.php?auth0", dataTo, {
			success: data => {
				const newPlayer = data;

				_that.setState({
					sub: {
						name: "",
						position: "",
						jersey: 0,
						jerError: false,
						posError: false,
						nameError: false
					},
					team: { id: null },
					teamError: false
				});
				_that.props.onClose(newPlayer);
			},
			error: err => { }
		});
	}

	onCloseWithData(data) {
		this.setState({
			sub: {
				name: "",
				position: "",
				jersey: 0,
				jerError: false,
				posError: false,
				nameError: false
			},
			team: { id: null },
			teamError: false
		});
		this.props.onClose(data);
	}

	render() {
		return (
			<Modal
				isOpen={this.props.isOpen}
				onClose={() => {
					this.setState({
						sub: {
							name: "",
							position: "",
							jersey: 0,
							jerError: false,
							posError: false,
							nameError: false
						},
						team: { id: null },
						teamError: false
					});
					this.props.onClose(null);
				}}
				borderRadius="1.3em"
			>
				<div className="add-place">
					<h1>Add Player</h1>

					<ComboBox
						data={this.props.teams}
						error={this.state.teamError}
						placeholder="Select a team..."
						onSelectedItem={item => {
							this.setState({
								team: item
							});
						}}
					/>
					<br />

					<div className="input-field">
						<span>Player Name</span>
						<input
							className={this.state.sub.nameError ? "error" : ""}
							onChange={e => this.setPlayerVals("name", e)}
							value={this.state.sub.name}
						/>
					</div>
					<div className="split-input">
						<div className="input-field">
							<span>Position</span>
							<input
								className={this.state.sub.posError ? "error" : ""}
								onChange={e => this.setPlayerVals("pos", e)}
								value={this.state.sub.position}
							/>
						</div>
						<div className="input-field">
							<span>Jersey</span>
							<input
								type="number"
								className={this.state.sub.jerError ? "error" : ""}
								onChange={e => this.setPlayerVals("jer", e)}
								value={this.state.sub.jersey}
							/>
						</div>
					</div>

					{this.state.team.id !== null && (
						<div className="input-field">
							<span>Select From List</span>
							<ComboBox
								data={this.state.team.players}
								error={this.state.teamError}
								placeholder="Select a player..."
								onSelectedItem={item => {
									this.onCloseWithData(item);
								}}
							/>
						</div>
					)}
					<button onClick={this.addPlayer}>Add</button>
				</div>
			</Modal>
		);
	}
}

export class ChatTextBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			media: {},
			file: {},
			val: ""
		};
	}

	onFilePicked(file) {
		console.log(file);
		const _that = this;
		let reader = new FileReader();
		reader.onloadend = () => {
			const newFile = {
				file: file,
				progress: 0,
				url: reader.result
			};

			_that.setState({
				file: newFile
			});

			_that.uploadFile(newFile);
		};
		reader.readAsDataURL(file);
	}

	uploadFile(file) {
		var formdata = new FormData();
		const _that = this;
		formdata.append("file", file.file);
		formdata.append("location", "");
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("userId", FakeData.getData("yoo").id);
		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.file.progress = percent;
				_that.setState({
					files: _that.state.files
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				if (data.id) {
					data.oldUrl = file.url;
					_that.setState({
						media: data
					});
					this.props.onFileChange(data);
				} else {
					_that.setState({ media: {}, file: {} });
					alert("Error uploading file...");
				}
			},
			false
		);
		ajax.open(
			"POST",
			FakeData.URL +
			"/uploadMedia.php?auth0&userId=" +
			FakeData.getData("yoo").id
		);
		ajax.send(formdata);
	}

	deleteMedia() {
		const file = this.state.media;
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			img: file,
			tags: this.state.tags
		};

		FakeData.post(
			"/removeMedia.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						media: {},
						file: {}
					});

					this.props.onFileChange({});
				},
				error: err => { }
			},
			true,
			"File Was Removed",
			res => { }
		);
	}

	onKeyUp(e) {
		const key = e.keyCode;
		if (key === 13) {
			this.props.onEnter(() => {
				//console.log("FFFF")
				this.setState({
					media: {},
					file: {},
					val: ""
				});
			});
		}
		//console.log(e);
	}

	render() {
		return (
			<div className="chat-text-box-holder">
				{this.state.file.url && (
					<div className="image">
						<RawMediaItem
							url={this.state.file.url}
							type={this.state.file.file.type}
						/>
						<i className="material-icons" onClick={() => this.deleteMedia()}>
							delete
            </i>
					</div>
				)}
				<div
					className={this.props.error ? "chat-text-box error" : "chat-text-box"}
					style={{ background: this.props.isPublic ? "#fff" : "" }}
				>
					<input
						placeholder="Write a message"
						value={this.state.val}
						onChange={e => {
							this.props.onBodyChange(e.target.value);
							this.setState({
								val: e.target.value
							});
						}}
						onKeyPress={e => {
							if (
								(e.keyCode === 13 || e.which === 13) &&
								this.props.sendOnEnter
							) {
								e.preventDefault();
							}
						}}
						onKeyUp={e => {
							if (this.props.sendOnEnter) {
								this.onKeyUp(e);
							}
						}}
					/>
					{this.is && <i className="material-icons">insert_emoticon</i>}
					<i className="material-icons">
						camera_alt<input
							type="file"
							accept="image/*,video/*"
							onChange={e => this.onFilePicked(e.target.files[0])}
							style={{
								position: "absolute",
								margin: "-25px 0px 0px -10px",
								height: "30px",
								width: "30px",
								opacity: 0
							}}
						/>
					</i>
				</div>
			</div>
		);
	}
}

export class ChatBoxList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpenMore: false,
			limit: 5,
			chats: FakeData.chats
		};
	}

	componentDidMount() {
		FakeData.shared("chatWidget", this);
	}

	getData() {
		this.setState({ chats: FakeData.chats });
	}

	replace = (newIndex, oldIndex) => {
		const _chats = FakeData.chats;
		const _newChat = FakeData.chats[FakeData.numify(newIndex)];
		const _oldChat = FakeData.chats[FakeData.numify(oldIndex)];
		_chats[newIndex] = _oldChat;
		_chats[(oldIndex = _newChat)];
		FakeData.chats = _chats;
		this.setState({
			chats: _chats,
			isOpenMore: false,
			limit: 5
		});
	};

	render() {
		if (this.state.chats.length === 0) {
			return null;
		}

		return (
			<div className="chat-box-list">
				{this.state.chats.map((item, i) => {
					if (i >= this.state.limit) {
						return null;
					}
					return <ChatBox key={i} chat={item} />;
				})}
				{this.state.chats.length > this.state.limit && (
					<div className="more-chats">
						{this.state.isOpenMore && (
							<div className="more-chat-list">
								{this.state.chats.map((item, i) => {
									if (i < this.state.limit) {
										return null;
									}
									return (
										<div
											className="more-chat-list-item"
											key={i}
											onClick={() => {
												this.replace(i, 4);
											}}
										>
											<img src={item.otherUser.image} />
											<span>
												{item.unread > 0
													? item.unread
													: item.otherUser.name.charAt(0)}
											</span>
										</div>
									);
								})}
							</div>
						)}
						<i
							className="material-icons"
							style={
								this.state.isOpenMore
									? { backgroundColor: "#4EA3C9" }
									: { borderRadius: "5px 5px 0px 0px" }
							}
							onClick={() => {
								this.setState({
									isOpenMore: this.state.isOpenMore ? false : true,
									limit: this.state.isOpenMore ? 5 : 4
								});
							}}
						>
							forum
            </i>
					</div>
				)}
			</div>
		);
	}
}

export class ChatBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: this.props.isOverLay ? false : true,
			msg: {
				body: "",
				media: {}
			},
			newMessages: [],
			conversation:
				this.props.chat === null
					? {
						id: null,
						userOne: {},
						userTwo: {},
						otherUser: {},
						messages: [],
						last_msg: null,
						unread: 0,
						isYou: true,
						date: null,
						removedByUserOne: false,
						removedByUserTwo: false,
						type: "timeline"
					}
					: this.props.chat
		};
	}

	leaveChat = () => {
		const { conversation } = this.state;
		let chat = conversation;
		const isYou = FakeData.getData("yoo").id === chat.userOne.id ? true : false;
		//console.log(isYou ? "User one leaving" : "User two leaving")
		const _that = this;
		const _data = {
			isUserOne: isYou,
			userId: FakeData.getData("yoo").id,
			convoId: chat.id
		}

		console.log(_data)
		const url = "/createGroup.php?auth0&isLeaveChat";
		FakeData.post(url, _data, {
			success(res) {
				const str = "chat" + chat.id + "you";
				FakeData.shared("mainThread").removeChat(str);
			},
			error(e) {
				const str = "chat" + chat.id + "you";
				FakeData.shared("mainThread").removeChat(str);
			}
		}, true, "", () => { })
	}

	componentDidMount() {
		const str = "chat" + this.props.chat.id + "you";
		FakeData.mountState(str, true);
		this._isMounted = true
		if (this.props.chat.id !== null) {
			this.initSystem();
			this.setChatSocket();
		}
	}

	componentWillUnmount() {
		const str = "chat" + this.props.chat.id + "you";
		FakeData.mountState(str, false);
		this._isMounted = false
		if (this.chat) {
			this.chat.emit("leave_chat", { id: this.state.conversation.id });
			this.chat.disconnect();
			this.chat = false
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.chat.isOpen) {
			this.setState({
				isOpen: nextProps.chat.isOpen
			});
		}
	}

	setChatSocket = () => {
		const _that = this;
		const { conversation, msg, newMessages } = this.state;

		try {
			this.chat = FakeData.socket_connect(_that.state.conversation.id);
			let _user = FakeData.getData("yoo");
			delete _user.settings;
			delete _user.hash_key;
			this.chat.on("chat_open", (data) => {
				_that.setState({ chatSystem: data });
				_that.chat.emit("join_chat", { id: _that.state.conversation.id });
			})

			this.chat.on("message", (data) => {
				let _msg = data;
				let isYourPage = false;
				if (this.state.conversation.isPage) {
					const isPage = this.state.conversation.isPage;
					const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i) => {
						return isPage && (page.id === this.state.conversation.user.id && page.type === this.state.conversation.user.type || page.id === this.state.conversation.otherUser.id && page.type === this.state.conversation.otherUser.type)
					});

					isYourPage = pageMatch[0] ? true : false
				}

				_msg['isYou'] = isYourPage ? isYourPage : FakeData.getData("yoo").id === data.user.id ? true : false;

				//_msg['isYou'] = FakeData.getData("yoo").id === data.user.id?true:false;
				if (_msg['isYou']) {
					const _elem = _that.refs.messages;
					FakeData.$(_elem).animate({ scrollTop: FakeData.$(_elem).prop("scrollHeight") }, 1000);
				} else {
					const _elem = _that.refs.messages
					if (FakeData.$(_elem).scrollTop() < FakeData.$(_elem).prop("scrollHeight")) {
						newMessages.push(_msg);
					}
				}
				conversation.messages.push(_msg);

				_that.setState({ conversation, newMessages });
			})
		} catch (error) {
			this.chat = false;
		}
	}

	getConversation() {
		const str = "chat" + this.props.chat.id + "you";
		if (this.state.conversation.id === null) {
			return;
		} else if (!FakeData.isMounted(str)) {
			return;
		}

		const isPage = this.state.conversation.isPage;
		const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i) => {
			return isPage && (page.id === this.state.conversation.user.id && page.type === this.state.conversation.user.type || page.id === this.state.conversation.otherUser.id && page.type === this.state.conversation.otherUser.type)
		});
		const userFrom = pageMatch[0] ? pageMatch[0] : {
			type: FakeData.getData("yoo").type,
			id: FakeData.getData("yoo").id
		};

		const dataTo = {
			user: userFrom,
			id: this.state.conversation.id
		};
		const _that = this;

		FakeData.post("/getChat.php?auth0", dataTo, {
			success: res => {
				if (!_that._isMounted) {
					return;
				}
				if (_that.state.conversation.messages.length > res.messages.length) {
					return;
				}
				_that.setState({
					conversation: res
				});

				setTimeout(() => {
					_that.getConversation();
				}, 1500);
			},
			error: err => { }
		});
	}

	onSend(cb) {
		const _that = this;
		const isPage = this.state.conversation.isPage;
		const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i) => {
			return isPage && (page.id === this.state.conversation.user.id && page.type === this.state.conversation.user.type || page.id === this.state.conversation.otherUser.id && page.type === this.state.conversation.otherUser.type)
		});

		const userFrom = pageMatch[0] ? pageMatch[0] : {
			type: FakeData.getData("yoo").type,
			id: FakeData.getData("yoo").id
		};

		const forDummy = pageMatch[0] ? true : false;
		const dataTo = {
			userFrom,
			userTo: this.props.chat.isGroup
				? {
					id: this.state.conversation.groupID,
					type: "GC"
				}
				: {
					id: this.state.conversation.otherUser.id,
					type: this.state.conversation.otherUser.id
				},
			msg: this.state.msg,
			id: this.state.conversation.id,
			isGroup: this.props.chat.isGroup ? true : false,
			users: this.props.chat.users
		};

		if (this.state.msg.body === "" && !this.state.msg.media.id) {
			this.setState({
				msgError: true
			});
			return;
		}

		const _dummyMsg = {
			"id": null,
			"user": forDummy ? this.state.conversation.user : FakeData.getData("yoo"),
			"isYou": true,
			"body": this.state.msg.body,
			"date": FakeData.getFullDateString(),
			"media": this.state.msg.media.url ? this.state.msg.media : null,
			"status": "",
			"type": "timeline",
			"timestamp": Math.floor(Date.now() / 1000)
		}

		if (this.chat) {
			this.chat.emit("send_msg", {
				id: this.state.conversation.id,
				data: _dummyMsg
			});

			_that.setState({
				msg: {
					body: "",
					media: {}
				},
				isSending: false
			});
		} else {
			this.state.conversation.messages.push(_dummyMsg);
			this.setState({ conversation: this.state.conversation, isSending: true });
		}

		//console.log(dataTo);
		FakeData.post("/replyToChat.php?auth0", dataTo, {
			success: res => {
				_that.state.conversation.messages.unshift(res);
				_that.setState({
					conversation: _that.state.conversation,
					msg: {
						body: "",
						media: {}
					}
				});
				//cb.apply(_that)
				cb.apply(this);
				//console.log(res);
			},
			error: err => { }
		});
	}

	startConversation(cb) {
		if (this.state.conversation.id !== null) {
			return;
		}
		const _that = this;
		const dataTo = {
			userFrom: {
				type: FakeData.getData("yoo").type,
				id: FakeData.getData("yoo").id
			},
			userTo: {
				id: this.state.conversation.otherUser.id,
				type: this.state.conversation.otherUser.type
			},
			type: "timeline",
			isGroup: FakeData.listify(this.state.conversation.users).length > 0 ? true : false,
			msg: this.state.msg,
			users: FakeData.listify(this.state.conversation.users)
		};

		if (this.state.msg.body === "" && !this.state.msg.media.id) {
			this.setState({
				msgError: true
			});
			return;
		}

		const _dummyMsg = {
			"id": null,
			"user": FakeData.getData("yoo"),
			"isYou": true,
			"body": this.state.msg.body,
			"date": FakeData.getFullDateString(),
			"media": this.state.msg.media.url ? this.state.msg.media : null,
			"status": "",
			"type": "timeline",
			"timestamp": Math.floor(Date.now() / 1000)
		}

		this.state.conversation.messages.push(_dummyMsg);
		this.setState({ conversation: this.state.conversation, isSending: true });

		FakeData.post("/startNewchat.php?auth0", dataTo, {
			success: res => {
				//console.log(res);
				if (res.error) {
					alert("Conversation Already Exists!!");
					return;
				}
				_that.setState({
					conversation: res,
					msg: {
						body: "",
						media: {}
					}
				});

				//cb.apply(_that)
				cb.apply(this);
				_that.getConversation();
				this.setChatSocket();
			},
			error: err => { }
		});
	}

	initSystem = () => {
		if (EventSource) {
			const isPage = this.state.conversation.isPage;
			const pageMatch = FakeData.listify(FakeData.getData("yoo").pages).filter((page, i) => {
				return isPage && (page.id === this.state.conversation.user.id && page.type === this.state.conversation.user.type || page.id === this.state.conversation.otherUser.id && page.type === this.state.conversation.otherUser.type)
			});
			const userFrom = pageMatch[0] ? pageMatch[0] : {
				type: FakeData.getData("yoo").type,
				id: FakeData.getData("yoo").id
			};
			this.system = new EventSource(FakeData.fetchURL + '/getChat.php?auth0&isStream&userId=' + userFrom.id + '&userType=' + userFrom.type + '&id=' + this.state.conversation.id);
			const _that = this;
			if (this.system !== null) {
				//this.system.addEventListener()
				this.system.onmessage = function (e) {
					if (_that._isMounted) {
						this.setState({
							_that: JSON.parse(e.data)
						});
					}
				};

				this.system.addEventListener('open', function (e) {
					// Connection was opened.
					//console.log(e)
				}, false);

				this.system.addEventListener('chat_update', function (e) {
					// Connection was opened.
					if (_that._isMounted) {
						let data = JSON.parse(e.data)
						if (_that.state.conversation.messages.length > data.messages.length) {
							return;
						}
						_that.setState({
							conversation: data
						});

						if (!_that.state.isSending) {
							FakeData.loaderElement().style.marginBottom = "-2cm";
						}
					}
				}, false);

				this.system.addEventListener('error', function (e) {
					if (e.readyState == EventSource.CLOSED) {
						// Connection was closed.
					}
				}, false);
			}
		} else {
			console.warn("EventSource Streams not supoorted by browser")
			this.getConversation()
		}
	}

	readAll() {
		const str = "chat" + this.props.chat.id + "you";
		if (this.state.conversation.id === null) {
			return;
		} else if (!FakeData.isMounted(str)) {
			return;
		}

		const dataTo = {
			user: FakeData.getData("yoo"),
			conversationId: this.state.conversation.id
		};
		const _that = this;

		FakeData.post("/readConversation.php?auth0", dataTo, {
			success: res => { },
			error: err => { }
		});
	}

	parseMessages = (msgs = []) => {
		const timeList = [];
		const messageTimeList = {};
		msgs.forEach((m, i) => {
			var ago = FakeData.moment(m.date).calendar();
			if (!FakeData.inArray(ago, timeList)) {
				timeList.push(ago);
				messageTimeList[ago] = [];
			}
		});

		msgs.forEach((m, i) => {
			var ago = FakeData.moment(m.date).calendar();
			FakeData.listify(messageTimeList[ago]).push(m);
		});

		return {
			times: timeList,
			messages: messageTimeList
		};
	}

	getSettings = (settings = []) => {
		const _ = {
			send_instant_reply: true,
			send_instant_respond: true,
			send_instant_greeting: true
		}

		const keys = Object.keys(_);

		keys.forEach((item, i) => {
			let _let = settings.filter((set, o) => {
				return set.sub === item;
			});

			_[item] = _let.length === 0 ? true : _let[0].value;
		})

		return _;
	}

	render() {
		const chat = this.props.chat;
		const { times, messages } = this.parseMessages(this.state.conversation.messages);
		const showAssistMSg = (this.state.conversation.isPage && times.length < 2) ? true : false;
		const _settings = this.getSettings(this.state.conversation.otherUser._);
		return (
			<div
				className="chat-box"
				style={{
					height: this.state.isOpen ? "300px" : "40px",
					width: this.state.isOpen ? "250px" : "150px"
				}}
				tabIndex="0"
				onFocus={() => {
					this.readAll();
				}}
			>
				<div
					className="chat-box-head"
					onClick={() => {
						if (!this.state.isOpen) {
							const _elem = this.refs.messages;
							FakeData.$(_elem).animate({ scrollTop: FakeData.$(_elem).prop("scrollHeight") }, 1000);
						}

						this.setState({
							isOpen: this.state.isOpen ? false : true
						});
					}}
				>
					{this.state.isOpen &&
						!chat.isGroup && <img src={chat.otherUser.image} />}
					{this.state.isOpen &&
						chat.isGroup && (
							<div
								className="notification-tray-item-icon group"
								style={{ width: "20px!important", height: "20px!important" }}
							>
								{chat.otherUser.members.map((item, i) => {
									if (i > 1) {
										return null;
									} else {
										return <img src={item.image} key={i} />;
									}
								})}
							</div>
						)}
					<a style={{ textOverflow: "ellipsis" }}>{chat.name}</a>
					{this.state.isOpen && this.state.conversation.id !== null && <i className="material-icons" onClick={() => {
						var isSure = window.confirm("Are you sure you want to close this chat?");
						if (isSure) {
							this.leaveChat();
						}
					}}>delete</i>}
					<i
						className="material-icons"
						onClick={() => {
							const str = "chat" + chat.id + "you";
							FakeData.shared("mainThread").removeChat(str);
						}}
					>
						close
          </i>
				</div>
				{this.state.isOpen &&
					this.state.conversation.id === null && (
						<div className="chat-right-view-body-chats-list">
							<div className="chat-right-view-body-chats-list-items">
								{chat.otherUser && chat.otherUser.name && <span className={"chat-msg-time"}>Chat with {chat.otherUser.name}</span>}
								<span className={"chat-msg-log"}>{chat.messages.length === 0 ? "No messages yet!" : "Chat created : " + FakeData.moment(chat.date).calendar()}</span>
							</div>
						</div>
					)}
				{this.state.isOpen &&
					this.state.conversation.id !== null && (
						<div className="chat-right-view-body-chats-list" ref={"messages"}>
							<div className="chat-right-view-body-chats-list-items">
								{chat.otherUser && chat.otherUser.name && <span className={"chat-msg-time"}>Chat with {chat.otherUser.name}</span>}
								<span className={"chat-msg-log"}>{chat.messages.length === 0 ? "No messages yet!" : "Chat created : " + FakeData.moment(chat.date).calendar()}</span>
							</div>
							{this.is && this.state.conversation.messages.map((item, i) => {
								return <ChatBoxMSG key={i} msg={item} />;
							})}
							{
								times.map((date, d) => {
									return (
										<div key={date} className="chat-right-view-body-chats-list-items">
											<span className={"chat-msg-time"}>{date}</span>
											{
												FakeData.listify(messages[date]).map((item, i) => {
													if (item.isLog) {
														return (
															<span key={item.id} className={"chat-msg-log"}>{item.body}</span>
														)
													} else {
														return (
															<ChatMessage
																canScroll={i === FakeData.listify(messages[date]).length - 1 ? true : false}
																hasScrolled={this.state.hasScrolled}
																isGroup={chat.isGroup}
																classThem={(!item.isYou && FakeData.listify(messages[date])[i + 1] && (!FakeData.listify(messages[date])[i + 1].isYou && !FakeData.listify(messages[date])[i + 1].isLog)) ? ((!item.isYou && FakeData.listify(messages[date])[i - 1] && (!FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog) && FakeData.listify(messages[date])[i + 1] && (!FakeData.listify(messages[date])[i + 1].isYou) && !FakeData.listify(messages[date])[i + 1].isLog) ? "middle-them" : (!item.isYou && FakeData.listify(messages[date])[i - 1] && (!FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog)) ? "" : "start-them") : "end-them"}
																classYou={(item.isYou && FakeData.listify(messages[date])[i + 1] && (FakeData.listify(messages[date])[i + 1].isYou && !FakeData.listify(messages[date])[i + 1].isLog)) ? ((item.isYou && FakeData.listify(messages[date])[i - 1] && (FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog) && FakeData.listify(messages[date])[i + 1] && (FakeData.listify(messages[date])[i + 1].isYou) && !FakeData.listify(messages[date])[i + 1].isLog) ? "middle-you" : (item.isYou && FakeData.listify(messages[date])[i - 1] && (FakeData.listify(messages[date])[i - 1].isYou && !FakeData.listify(messages[date])[i - 1].isLog)) ? "" : "start-you") : "end-you"}
																msg={item}
																key={item.timestamp} />
														)
													}
												})
											}
										</div>
									)
								})
							}
							{showAssistMSg && _settings.send_instant_greeting &&
								<span className={"chat-msg-log"}>{"Thanks for messaging us. We try to be as responsive as possible. We'll get back to you soon"}</span>
							}
							{showAssistMSg && _settings.send_instant_reply &&
								<span className={"chat-msg-log"}>{}</span>
							}
							{showAssistMSg && _settings.send_instant_greeting &&
								<span className={"chat-msg-log"}>{}</span>
							}
						</div>
					)}
				{this.state.isOpen && (
					<ChatTextBox
						error={this.state.msgError}
						isPublic="true"
						onBodyChange={text => {
							this.state.msg.body = text;
							this.setState({
								msg: this.state.msg,
								msgError: false
							});
						}}
						onFileChange={file => {
							this.state.msg.media = file;
							this.setState({
								msg: this.state.msg,
								msgError: false
							});
						}}
						onEnter={cb => {
							if (this.state.conversation.id === null) {
								this.startConversation(cb);
							} else {
								this.onSend(cb);
							}
						}}
						sendOnEnter="true"
					/>
				)}
			</div>
		);
	}
}

class ChatBoxMSG extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const item = this.props.msg;
		return (
			<div className={item.isYou ? "chat-box-msg you" : "chat-box-msg"}>
				{item.media !== null && (
					<MediaItem
						key={"file-msg-" + 0}
						file={item.media}
						onMediaClick={() => { }}
					/>
				)}
				<span className="msg">{item.body}</span>
			</div>
		);
	}
}

export class EditGameModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: {},
			item: this.props.game
		};

		this.selectHalfTime = this.selectHalfTime.bind(this);
		this.selectMatchPlace = this.selectMatchPlace.bind(this);
		this.selectMatchTime = this.selectMatchTime.bind(this);
		this.selectMatchDate = this.selectMatchDate.bind(this);
		this.selectAdmin = this.selectAdmin.bind(this);
		this.selectTeamOne = this.selectTeamOne.bind(this);
		this.selectTeamTwo = this.selectTeamTwo.bind(this);
	}

	componentDidMount() {
		this.setState({
			item: this.props.game
		});
	}

	onClose() {
		this.setState({
			item: {}
		});
		this.props.onClose();
	}

	selectTeamOne(team) {
		this.state.item.teamOne = team;
		this.state.errors["teamOneError"] =
			this.state.item.teamTwo.id === team.id ? true : false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectTeamTwo(team) {
		this.state.item.teamTwo = team;
		this.state.errors["teamTwoError"] =
			this.state.item.teamOne.id === team.id ? true : false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectHalfTime(e) {
		if (e <= 0) {
			this.state.errors["halfTimeError"] = true;
			this.state.item.matchHalf = e;
			this.setState({
				errors: this.state.errors,
				item: this.state.item
			});
		} else {
			this.state.errors["halfTimeError"] = false;
			this.state.item.matchHalf = e;
			this.setState({
				errors: this.state.errors,
				item: this.state.item
			});
		}
	}

	selectMatchPlace(item) {
		this.state.item.matchPlace = item;
		this.state.errors["matchError"] = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectMatchTime(item) {
		this.state.item.matchTime = item;
		this.state.errors["timeError"] = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectMatchDate(item) {
		//console.log(item);
		this.state.item.matchDate = item;
		this.state.errors["dateError"] = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectAdmin(item) {
		this.state.item.matchAdmin = item;
		this.state.errors.matchAdminError = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	saveGame() {
		const game = this.state.item;
		const isLeague = this.props.game.matchType !== "Friendly" ? true : false;

		if (game.teamOne.id === null) {
			this.state.errors["teamOneError"] = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.teamTwo.id === null) {
			this.state.errors["teamTwoError"] = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchHalf <= 0) {
			this.state.errors.halfTimeError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchPlace === "") {
			this.state.errors.matchError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchDate === "") {
			this.state.errors.dateError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchTime === "") {
			this.state.errors.timeError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchAdmin.id === null) {
			this.state.errors.matchAdminError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		const date = new Date(game.matchDate + " " + game.matchTime + ":00");
		date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
		game["fullTimestamp"] = date.toUTCString();

		if (this.state.errors.teamTwoError || this.state.errors.teamTwoError) {
			return;
		}

		const _that = this;
		const dataTo = {
			game: this.state.item
		};

		FakeData.post(
			"/saveTournGame.php?auth0",
			dataTo,
			{
				success: data => {
					if (data.status) {
						_that.onClose();
					}
				},
				error: err => { }
			},
			true,
			"",
			() => { }
		);
	}

	render() {
		const User = this.props.user;
		const isLeague = this.props.game.matchType !== "Friendly" ? true : false;
		const isPlayOff = this.props.isPlayOff ? true : false;
		const data = isPlayOff ? this.props.teams : FakeData.getData("all_teams");
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
				<div className="add-place" style={{ width: "850px" }}>
					<h1>Edit Game</h1>
					{(!isLeague || isPlayOff) && (
						<GameTeamsForm
							user={User}
							pickerData={User.friends}
							game={this.props.game}
							errors={this.state.errors}
							onTeamOneSelected={this.selectTeamOne}
							onTeamTwoSelected={this.selectTeamTwo}
							data={data}
						/>
					)}
					<GameVenueTimeForm
						user={User}
						places={User.placesLived.others}
						game={this.props.game}
						errors={this.state.errors}
						onSetHalf={this.selectHalfTime}
						onSetPlace={this.selectMatchPlace}
					/>
					<GameDateTimeForm
						user={User}
						game={this.props.game}
						onSetTime={this.selectMatchTime}
						onSetDate={this.selectMatchDate}
						errors={this.state.errors}
					/>
					<GameAdminForm
						user={User}
						game={this.props.game}
						matchAdminError={this.state.errors.matchAdminError}
						onPersonSelected={this.selectAdmin}
						data={User.friends}
					/>
					<button
						className="odd-button"
						style={{
							lineHeight: "40px",
							width: "100%",
							border: "none",
							background: "#4EA3C9",
							color: "#fff"
						}}
						onClick={() => {
							this.saveGame();
						}}
					>
						Save
          </button>
				</div>
			</Modal>
		);
	}
}

export class SetTournGameModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			valueTwo: "Select A Game",
			items: [],
			item: {},
			isEditting: false,
			game: {
				id: null
			},
			errors: {}
		};

		this.selectHalfTime = this.selectHalfTime.bind(this);
		this.selectMatchPlace = this.selectMatchPlace.bind(this);
		this.selectMatchTime = this.selectMatchTime.bind(this);
		this.selectMatchDate = this.selectMatchDate.bind(this);
		this.selectAdmin = this.selectAdmin.bind(this);
	}

	componentWillMount() { }

	onClose() {
		this.setState({
			item: {},
			isEditting: false
		});

		this.props.onClose();
	}

	selectHalfTime(e) {
		if (e <= 0) {
			this.state.errors["halfTimeError"] = true;
			this.state.item.matchHalf = e;
			this.setState({
				errors: this.state.errors,
				item: this.state.item
			});
		} else {
			this.state.errors["halfTimeError"] = false;
			this.state.item.matchHalf = e;
			this.setState({
				errors: this.state.errors,
				item: this.state.item
			});
		}
	}

	selectMatchPlace(item) {
		this.state.item.matchPlace = item;
		this.state.errors["matchError"] = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectMatchTime(item) {
		this.state.item.matchTime = item;
		this.state.errors["timeError"] = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectMatchDate(item) {
		//console.log(item);
		this.state.item.matchDate = item;
		this.state.errors["dateError"] = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	selectAdmin(item) {
		this.state.item.matchAdmin = item;
		this.state.errors.matchAdminError = false;
		this.setState({
			item: this.state.item,
			errors: this.state.errors
		});
	}

	saveGame() {
		const game = this.state.item;
		if (game.matchHalf <= 0) {
			this.state.errors.halfTimeError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchPlace === "") {
			this.state.errors.matchError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchDate === "") {
			this.state.errors.dateError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchTime === "") {
			this.state.errors.timeError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		if (game.matchAdmin.id === null) {
			this.state.errors.matchAdminError = true;
			this.setState({
				errors: this.state.errors
			});

			return;
		}

		const _that = this;
		const dataTo = {
			game: this.state.item
		};

		FakeData.post(
			"/saveTournGame.php?auth0",
			dataTo,
			{
				success: data => {
					if (data.status) {
						_that.setState({
							isEditting: false
						});
						FakeData.alert("Game Set!");
					}
				},
				error: err => { }
			},
			true,
			"",
			() => { }
		);
	}

	render() {
		const User = this.props.user;
		this.props.games.sort((a, b) => {
			return a.leg - b.leg;
		});

		this.props.games.sort((a, b) => {
			return a.title - b.title;
		});
		if (!this.props.isOpen) {
			return null;
		}
		return (
			<Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
				<div className="add-place" style={{ width: "850px" }}>
					<h1>Manage Games of {this.props.group.name}</h1>
					{!this.state.isEditting && (
						<div className="manage-edits">
							<div className="manage-edit">
								<span>
									<strong>Game</strong>
								</span>
								<span>
									<strong>Action</strong>
								</span>
							</div>

							{this.props.games.map((item, i) => (
								<div className="manage-edit" key={i}>
									<span>
										{item.teamOne.name} vs {item.teamTwo.name}{" "}
										{"Leg " + item.leg}
									</span>
									<span
										className="action"
										onClick={() => {
											this.setState({
												item: item,
												isEditting: true
											});
										}}
									>
										Edit
                  </span>
								</div>
							))}
						</div>
					)}

					{this.state.isEditting && (
						<div className="manage-edit-form">
							<div className="manage-edit-form-head">
								<i
									className="material-icons"
									onClick={() => this.setState({ isEditting: false })}
								>
									arrow_back
                </i>
								<span>{this.state.item.title}</span>
							</div>
							<div className="manage-edit-form-body">
								<GameVenueTimeForm
									user={User}
									places={User.placesLived.others}
									game={this.state.game}
									errors={this.state.errors}
									onSetHalf={this.selectHalfTime}
									onSetPlace={this.selectMatchPlace}
								/>
								<GameDateTimeForm
									user={User}
									game={this.state.item}
									onSetTime={this.selectMatchTime}
									onSetDate={this.selectMatchDate}
									errors={this.state.errors}
									errors={this.state.errors}
								/>
								<GameAdminForm
									user={User}
									game={this.state.item}
									matchAdminError={this.state.errors.matchAdminError}
									onPersonSelected={this.selectAdmin}
									data={User.friends}
								/>
								<button
									className="add-game-save"
									onClick={() => this.saveGame()}
								>
									Save
                </button>
							</div>
						</div>
					)}
				</div>
			</Modal>
		);
	}
}

export class PlayOffView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isEditting: false,
			item: {}
		};

		//console.log(this.props.playOffs.round.length);
	}

	componentWillMount() { }

	setGame(item) {
		const _that = this;
		this.setState({
			item: item
		});

		setTimeout(() => {
			_that.setState({
				isModalOpen: true
			});
		}, 1000);
	}

	render() {
		const isRound = this.props.playOffs.round.length > 0 ? true : false;
		return (
			<div className="play-offs">
				{this.props.playOffs.round.length > 0 && (
					<div className="play-off" style={{ color: "#4EA3C9" }}>
						<div className="play-head">Round Of 16</div>
						{this.props.playOffs.round.map((item, i) => (
							<div
								className={"match-for round " + this.props.className}
								key={i}
							>
								<span
									style={{
										position: "absolute",
										marginTop: "-18px",
										fontSize: "10px"
									}}
								>
									{item.matchDate === "" ? "No Date" : item.matchDate} -{" "}
									{item.matchPlace === "" ? "No Venue" : item.matchPlace}
									{this.props.isAdmin &&
										(item.teamOne.id === 0 && item.teamTwo.id === 0) && (
											<i
												className="material-icons"
												style={{
													fontSize: "10px",
													margin: "0px 20px",
													cursor: "pointer"
												}}
												onClick={() => this.setGame(item)}
											>
												settings
                      </i>
										)}
								</span>
								<div className="team-match">
									<span>
										{item.teamOne.name === null
											? "No Team Set"
											: item.teamOne.name}
									</span>
									<span>{item.isFinished ? item.res.teamOneGoals : "-"}</span>
								</div>
								<div className="team-match">
									<span>
										{item.teamTwo.name === null
											? "No Team Set"
											: item.teamTwo.name}
									</span>
									<span>{item.isFinished ? item.res.teamTwoGoals : "-"}</span>
								</div>
							</div>
						))}
					</div>
				)}
				<div className="play-off" style={{ color: "#4a5" }}>
					<div className="play-head" style={{ margin: "0px 0px 0px" }}>
						Quarter Finals
          </div>
					{this.props.playOffs.quarter.map((item, i) => (
						<div
							className={
								isRound
									? "match-for q " + this.props.className
									: "match-for q no-round " + this.props.className
							}
							key={i}
						>
							<span
								style={{
									position: "absolute",
									marginTop: "-18px",
									fontSize: "10px",
									marginLeft: "55px"
								}}
							>
								{item.matchDate === "" ? "No Date" : item.matchDate} -{" "}
								{item.matchPlace === "" ? "No Venue" : item.matchPlace}
								{this.props.isAdmin &&
									(item.teamOne.id === 0 && item.teamTwo.id === 0) && (
										<i
											className="material-icons"
											style={{
												fontSize: "10px",
												margin: "0px 20px",
												cursor: "pointer"
											}}
											onClick={() => this.setGame(item)}
										>
											settings
                    </i>
									)}
							</span>
							<div className="team-match">
								<span>
									{item.teamOne.name === null
										? "No Team Set"
										: item.teamOne.name}
								</span>
								<span>{item.isFinished ? item.res.teamOneGoals : "-"}</span>
							</div>
							<div className="team-match">
								<span>
									{item.teamTwo.name === null
										? "No Team Set"
										: item.teamTwo.name}
								</span>
								<span>{item.isFinished ? item.res.teamTwoGoals : "-"}</span>
							</div>
						</div>
					))}
				</div>
				<div className="play-off" style={{ color: "#f43" }}>
					<div className="play-head" style={{ position: "absolute" }}>
						Semi Finals
          </div>
					{this.props.playOffs.semi.map((item, i) => (
						<div
							className={
								isRound
									? "match-for s " + this.props.className
									: "match-for s no-round " + this.props.className
							}
							key={i}
						>
							<span
								style={{
									position: "absolute",
									marginTop: "-18px",
									fontSize: "10px",
									marginLeft: "55px"
								}}
							>
								{item.matchDate === "" ? "No Date" : item.matchDate} -{" "}
								{item.matchPlace === "" ? "No Venue" : item.matchPlace}
								{this.props.isAdmin &&
									(item.teamOne.id === 0 && item.teamTwo.id === 0) && (
										<i
											className="material-icons"
											style={{
												fontSize: "10px",
												margin: "0px 20px",
												cursor: "pointer"
											}}
											onClick={() => this.setGame(item)}
										>
											settings
                    </i>
									)}
							</span>
							<div className="team-match">
								<span>
									{item.teamOne.name === null
										? "No Team Set"
										: item.teamOne.name}
								</span>
								<span>{item.isFinished ? item.res.teamOneGoals : "-"}</span>
							</div>
							<div className="team-match">
								<span>
									{item.teamTwo.name === null
										? "No Team Set"
										: item.teamTwo.name}
								</span>
								<span>{item.isFinished ? item.res.teamTwoGoals : "-"}</span>
							</div>
						</div>
					))}
				</div>
				<div className="play-off" style={{ color: "#FFBD1E" }}>
					<div className="play-head">Finals</div>
					{this.props.playOffs.final.map((item, i) => (
						<div
							className={
								isRound
									? "match-for f " + this.props.className
									: "match-for f no-round " + this.props.className
							}
							key={i}
						>
							<span
								style={{
									position: "absolute",
									marginTop: "-18px",
									fontSize: "10px",
									marginLeft: "55px"
								}}
							>
								{item.matchDate === "" ? "No Date" : item.matchDate} -{" "}
								{item.matchPlace === "" ? "No Venue" : item.matchPlace}
								{this.props.isAdmin &&
									(item.teamOne.id === 0 && item.teamTwo.id === 0) && (
										<i
											className="material-icons"
											style={{
												fontSize: "10px",
												margin: "0px 20px",
												cursor: "pointer"
											}}
											onClick={() => this.setGame(item)}
										>
											settings
                    </i>
									)}
							</span>
							<div className="team-match">
								<span>
									{item.teamOne.name === null
										? "No Team Set"
										: item.teamOne.name}
								</span>
								<span>{item.isFinished ? item.res.teamOneGoals : "-"}</span>
							</div>
							<div className="team-match">
								<span>
									{item.teamTwo.name === null
										? "No Team Set"
										: item.teamTwo.name}
								</span>
								<span>{item.isFinished ? item.res.teamTwoGoals : "-"}</span>
							</div>
						</div>
					))}
				</div>
				<div
					className={"play-off third-place " + this.props.className}
					style={{ color: "#607D8B" }}
				>
					<div className="play-head">Third Place</div>
					<div className="match-for t">
						<span
							style={{
								position: "absolute",
								marginTop: "-18px",
								fontSize: "10px",
								marginLeft: "0px"
							}}
						>
							{this.props.playOffs.losers[0].matchDate === ""
								? "No Date"
								: this.props.playOffs.losers[0].matchDate}{" "}
							-{" "}
							{this.props.playOffs.losers[0].matchPlace === ""
								? "No Venue"
								: this.props.playOffs.losers[0].matchPlace}
							{this.props.isAdmin &&
								(this.props.playOffs.losers[0].teamOne.id === 0 &&
									this.props.playOffs.losers[0].teamTwo.id === 0) && (
									<i
										className="material-icons"
										style={{
											fontSize: "10px",
											margin: "0px 20px",
											cursor: "pointer"
										}}
										onClick={() => this.setGame(this.props.playOffs.losers[0])}
									>
										settings
                  </i>
								)}
						</span>
						<div className="team-match">
							<span>
								{this.props.playOffs.losers[0].teamOne.name === null
									? "No Team Set"
									: this.props.playOffs.losers[0].teamOne.name}
							</span>
							<span>
								{this.props.playOffs.losers[0].isFinished
									? this.props.playOffs.losers[0].res.teamOneGoals
									: "-"}
							</span>
						</div>
						<div className="team-match">
							<span>
								{this.props.playOffs.losers[0].teamTwo.name === null
									? "No Team Set"
									: this.props.playOffs.losers[0].teamTwo.name}
							</span>
							<span>
								{this.props.playOffs.losers[0].isFinished
									? this.props.playOffs.losers[0].res.teamTwoGoals
									: "-"}
							</span>
						</div>
					</div>
				</div>
				{this.props.isAdmin &&
					this.state.isModalOpen && (
						<EditGameModal
							teams={this.props.teams}
							isPlayOff="true"
							isOpen={this.state.isModalOpen}
							user={FakeData.getData("yoo")}
							game={this.state.item}
							onClose={() => {
								this.setState({
									isModalOpen: false,
									item: {}
								});
							}}
						/>
					)}
			</div>
		);
	}
}

export class FilterView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: FakeData.getData("yoo"),
			active: ""
		};
	}

	componentDidMount() {
		this.setState({
			user: FakeData.getData("yoo")
		});
	}

	getItems(arr) {
		const newArr = [];
		arr.forEach(item => {
			if (item.name !== null) {
				newArr.push(item.name);
			}
		});

		return newArr;
	}

	selectFilter(item) {
		this.setState({
			active: item
		});

		this.props.onSelectedFilter(item);
	}

	render() {
		const data = this.getItems(this.state.user.mySport);
		return (
			<div className="filter-view">
				<ComboBox
					data={data}
					placeholder="Select Sport"
					onSelectedItem={item => this.props.onSelectSport(item)}
				/>
				<div className="radio-filters">
					<span
						className={this.state.active === "" ? "active" : ""}
						onClick={() => this.selectFilter("")}
					>
						All
          </span>
					{this.props.data.map((item, i) => (
						<span
							key={i}
							className={this.state.active === item ? "active" : ""}
							onClick={() => this.selectFilter(item)}
						>
							{item.toUpperCase().replace("_", " ")}
						</span>
					))}
				</div>
			</div>
		);
	}
}

export class LeagueSplitView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			game: { timestamp: "0000-00-00 00:00:00" },
			d: 0,
			h: 0,
			m: 0,
			s: 0,
			isShown: true
		};
	}

	componentDidMount() {
		FakeData.mountState("up-coming", true);
		this.right = 1300
		const _that = this;
		window.toggleLeagueSplit = (context = false) => {
			_that.setState({
				isShown: !_that.state.isShown
			});
		};
		this.countDown();
		this.getNextGame();
	}

	componentWillUnmount() {
		FakeData.mountState("up-coming", false);
		window.toggleLeagueSplit = false;
	}

	getNextGame() {
		const _that = this;
		if (!FakeData.isMounted("up-coming")) {
			return;
		}

		this.setState({
			game: FakeData.getData("nextGame")
				? FakeData.getData("nextGame")
				: { timestamp: "0000-00-00 00:00:00" }
		});
		setTimeout(() => {
			_that.getNextGame();
		}, 1000);
	}

	countDown() {
		const _that = this;
		if (!FakeData.isMounted("up-coming")) {
			return;
		}
		if (this.state.game.timestamp === "0000-00-00 00:00:00") {
			setTimeout(() => {
				_that.countDown();
			}, 1000);
			return;
		}

		const timestamp = new Date(this.state.game.timestamp).getTime();
		var now = Date.now();
		var distance = timestamp - now;

		// Time calculations for days, hours, minutes and seconds
		var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor(
			(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
		);
		var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((distance % (1000 * 60)) / 1000);

		this.setState({
			d: days,
			h: hours,
			m: minutes,
			s: seconds
		});

		if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
			//remind gmc admin
			this.setState({ game: { timestamp: "0000-00-00 00:00:00" } });
		} else {
			setTimeout(() => {
				_that.countDown();
			}, 1000);
		}
	}

	renderNextGameView = (styleToo={}) => {
		const { style, isLeague, profile } = this.props;
		const _int = isLeague ? 500 : 490;

		return (
			<div
				className="next-game-view"
				style={
					this.props.isPostView
						? { top: "70px",
						...style,
							...styleToo
					 }
						: {
							top:
								_int - this.props.offset <= 40
									? "50px"
									: _int - this.props.offset + "px",
							...style,
							...styleToo
						}
				}
			>
				{!this.props.isUser && <FanListView fans={profile.fans} />}
				<div className="next_game_header custom_bgcolor">
					Next Game Countdown
          </div>
				<div className="next_game_counter">
					<div>
						<span>{this.state.d <= 0 ? 0 : this.state.d}</span>
						<span>Days</span>
					</div>
					<div>
						<span>{this.state.h <= 0 ? 0 : this.state.h}</span>
						<span>Hours</span>
					</div>
					<div>
						<span>{this.state.m <= 0 ? 0 : this.state.m}</span>
						<span>Min</span>
					</div>
					<div>
						<span>{this.state.s <= 0 ? 0 : this.state.s}</span>
						<span>Secs</span>
					</div>
				</div>
				<UpcominComingGames class={"league"} />
				<img
					src="http://darylglass.co.za/mijsports/images/adverts/bet_now_advert.jpg"
					alt=""
				/>
			</div>
		)
	}

	render() {
		const { style, isLeague, profile } = this.props;
		const _int = isLeague ? 500 : 490;
		if (this.props.isUser) {
			return (
				<div
					className={"league-split-view user sp-flex-width"}
					style={{ zIndex: this.state.isShown ? 0 : -1 }}
					ref={(ref)=>{
						if(ref){
							//console.log()
							this.right = FakeData.$(ref).offset().left + FakeData.$(ref).width();
						}
					}}
				>
					<div className={"league-split-view-main"} style={{width: "calc(100% - 420px)"}}>
					{this.props.children}
					</div>
					{this.renderNextGameView({left:this.right-420})}
				</div>
			)
		}
		return (
			<div
				className={"league-split-view sp-flex-width"}
				style={{ zIndex: this.state.isShown ? 0 : -1 }}
			>
				{this.renderNextGameView()}
				
				<div className={"league-split-view-main"} style={{width: "calc(100% - 420px)"}}>
					{this.props.children}
				</div>
			</div>
		);
	}
}

export class FanListView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShown: false
		};
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		FakeData.mountState("up-coming-games", false);
		this._isMounted = false;
	}

	getFans = (fans = [{}]) => {
		const list = [];
		fans.forEach((item, i) => {
			const keys = Object.values(item);
			const _obj = {
				points: keys[0]["points"],
				user: keys[0]["user"]
			};
			list.push(_obj);
		});

		return list.sort((a, b) => {
			return b.points - a.points;
		});
	};

	render() {
		const { fans } = this.props;
		const { isShown } = this.state;
		const _fans = this.getFans(fans);
		return (
			<div style={{ width: "100%", background: "#fff", marginBottom: "10px" }}>
				<div className="next_game_header custom_bgcolor">Top 10 Fans</div>
				<div className={"fan-list"}>
					{_fans.map((item, i) => {
						if (!isShown && i >= 5) {
							return null;
						}

						if (isShown && i > 9) {
							return null;
						}

						return (
							<div className={"fan-list-item"} key={i}>
								<img src={item.user.image} style={{ width: "100%" }} />
								<div className={"fan-list-item-count"}>{i + 1}</div>
							</div>
						);
					})}
				</div>
				{_fans.length > 5 && (
					<button
						className={"button"}
						style={{ margin: "0px" }}
						onClick={() => {
							this.setState({ isShown: !isShown });
						}}
					>
						{isShown ? "Show Less" : "Show All"}
					</button>
				)}
			</div>
		);
	}
}

export class UpcominComingGames extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: "fix",
			filter: "",
			fix: [],
			filFix: [],
			res: [],
			filRes: [],
			arr: ["a", "aa"]
		};
	}

	componentDidMount() {
		FakeData.mountState("up-coming-games", true);
		this._isMounted = true;
		this.getData();
	}

	componentWillUnmount() {
		FakeData.mountState("up-coming-games", false);
		this._isMounted = false;
	}

	getData() {
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			leagues: FakeData.getData("leagueIds"),
			teams: FakeData.getData("teamIds")
		};

		if (!_that._isMounted) {
			return;
		}

		FakeData.post("/getFixRes.php?auth0", dataTo, {
			success: res => {
				//console.log(res);
				if (!_that._isMounted) {
					return;
				}
				_that.setState({
					fix: res.fix,
					filFix: _that.filterFix(res.fix),
					res: res.res,
					filRes: _that.filterRes(res.res)
				});
				FakeData.setData("nextGame", res.fix[0]);
				setTimeout(() => {
					_that.getData();
				}, 1500);
			},
			error: err => { }
		});
	}

	filterFix = fix => {
		const list = [];
		fix.forEach((item, i) => {
			if (
				item.sport.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1
			) {
				list.push(item);
			}
		});

		return list;
	};

	filterRes = res => {
		const list = [];
		res.forEach((item, i) => {
			if (
				item.sport.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1
			) {
				list.push(item);
			}
		});

		return list;
	};

	setFilter = fil => {
		if (!this._isMounted) {
			return;
		}
		this.setState({
			filter: fil,
			filFix: this.filterFix(this.state.fix),
			filRes: this.filterRes(this.state.res)
		});
	};

	render() {
		const User = FakeData.getData("yoo");
		return (
			<div
				className="upcoming-games-view"
				style={this.props.style ? this.props.style : {}}
			>
				<div className={"upcoming-games-view-tabs " + this.props.class}>
					<span
						className={this.state.active === "fix" ? "active" : ""}
						onClick={() => this.setState({ active: "fix" })}
					>
						Fixtures
          </span>
					<span
						className={this.state.active === "res" ? "active" : ""}
						onClick={() => this.setState({ active: "res" })}
					>
						Results
          </span>
				</div>
				<div className={"upcoming-games-view-head " + this.props.class}>
					<span
						className={this.state.filter === "" ? "active" : ""}
						onClick={() => this.setFilter("")}
					>
						All
          </span>
					{FakeData.listify(FakeData.getData("yoo").mySport).map((item, i) => {
						return (
							<img
								key={i}
								src={item.image.replace("_wht", "")}
								className={this.state.filter === item.name ? "active" : ""}
								onClick={() => this.setFilter(item.name)}
							/>
						);
					})}
				</div>
				<div className="upcoming-games-view-lists">
					{this.state.active === "fix" && (
						<div className={"upcoming-games-view-list " + this.props.class}>
							{this.state.filFix.map((item, i) => {
								return (
									<Link to={"/game/" + item.id} key={i} className="list-game">
										<div className="list-game-date">
											<span>{item.matchDate}</span>
											<span>{item.matchTime}</span>
										</div>
										<div className="list-game-match">
											<img src={item.teamOne.image} />
											<div
												dangerouslySetInnerHTML={{
													__html:
														'<marquee scrollamount="2">' +
														item.teamOne.name +
														" vs " +
														item.teamTwo.name +
														"</marquee><span>" +
														item.title +
														"</span>"
												}}
											/>
											<img src={item.teamOne.image} />
										</div>
										<img
											src={
												item.currentTime === 0
													? "/images/calendar_icon_gry.svg"
													: "/images/calendar_icon_grn.svg"
											}
											style={{
												margin: "0px 15px 0px 5px",
												width: "15px",
												height: "15px"
											}}
										/>
									</Link>
								);
							})}
						</div>
					)}
					{this.state.active === "res" && (
						<div className={"upcoming-games-view-list " + this.props.class}>
							{this.state.filRes.map((item, i) => {
								return (
									<Link to={"/game/" + item.id} key={i} className="list-game">
										<div className="list-game-date">
											<span>{item.matchDate}</span>
											<span>{item.matchTime}</span>
										</div>
										<div className="list-game-match">
											<img src={item.teamOne.image} />
											<div
												dangerouslySetInnerHTML={{
													__html:
														'<marquee scrollamount="2">' +
														item.teamOne.name +
														" " +
														item.teamOneGoals.length +
														"-" +
														item.teamTwoGoals.length +
														" " +
														item.teamTwo.name +
														"</marquee><span>" +
														item.title +
														"</span>"
												}}
											/>
											<img src={item.teamOne.image} />
										</div>
										<img
											src={
												item.currentTime === 0
													? "/images/calendar_icon_gry.svg"
													: "/images/calendar_icon_grn.svg"
											}
											style={{
												margin: "0px 15px 0px 5px",
												width: "15px",
												height: "15px"
											}}
										/>
									</Link>
								);
							})}
						</div>
					)}
				</div>
				<div className={"load-more " + this.props.class}>Load More</div>
			</div>
		);
	}
}

export class LiveGames extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: "fix",
			filter: "",
			fix: [],
			filFix: [],
			res: [],
			filRes: [],
			arr: ["a", "aa"],
			isExtended: false
		};
	}
	componentDidMount() {
		FakeData.mountState("live-games", true);
		this._isMounted = true;
		this.getData();
	}

	componentWillUnmount() {
		FakeData.mountState("live-games", false);
		this._isMounted = false;
	}

	getData() {
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			leagues: FakeData.listify(FakeData.getData("leagueIds")),
			teams: FakeData.listify(FakeData.getData("teamIds"))
		};

		FakeData.post("/getLiveGames.php?auth0", dataTo, {
			success: res => {
				//console.log(res);
				if (!_that._isMounted) {
					return;
				}
				_that.setState({
					fix: res,
					filFix: _that.filterFix(res)
				});

				setTimeout(() => {
					_that.getData();
				}, 1050);
			},
			error: err => { }
		});
	}

	filterFix = fix => {
		const list = [];
		fix.forEach((item, i) => {
			if (
				item.game.sport.toLowerCase().indexOf(this.state.filter.toLowerCase()) >
				-1
			) {
				list.push(item);
			}
		});

		return list;
	};

	setFilter = fil => {
		if (!this._isMounted) {
			return;
		}
		this.setState({
			filter: fil,
			filFix: this.filterFix(this.state.fix)
		});
	};

	render() {
		const User = FakeData.getData("yoo");
		const date = new Date();
		const { isExtended, filFix } = this.state;
		return (
			<div
				className="upcoming-games-view"
				style={this.props.style ? this.props.style : {}}
			>
				<div className={"upcoming-games-view-tabs " + this.props.class}>
					<span
						style={{
							color: "#fff",
							background: "#4EA3C9",
							position: "relative",
							lineHeight: "33px",
							height: "33px"
						}}
						onClick={() =>
							this.setState({ isExtended: isExtended ? false : true })
						}
					>
						Live Games
            <i
							className="material-icons"
							style={{
								position: "absolute",
								right: 0,
								fontSize: "20px",
								marginRight: "20px",
								lineHeight: "33px"
							}}
						>
							{!isExtended ? "keyboard_arrow_down" : "keyboard_arrow_up"}
						</i>
					</span>
				</div>
				{isExtended && (
					<div className={"upcoming-games-view-head " + this.props.class}>
						<span
							className={this.state.filter === "" ? "active" : ""}
							onClick={() => this.setFilter("")}
						>
							All
            </span>
						{FakeData.listify(FakeData.getData("yoo").mySport).map(
							(item, i) => {
								return (
									<img
										key={i}
										src={item.image.replace("_wht", "")}
										className={this.state.filter === item.name ? "active" : ""}
										onClick={() => this.setFilter(item.name)}
									/>
								);
							}
						)}
					</div>
				)}
				{isExtended && (
					<div className="live-game-list" style={{ width: "100%" }}>
						{filFix.length > 0 && (
							<span className="live-game-card-footer">
								{FakeData.today().fullDate}
							</span>
						)}
						{filFix.map((item, i) => {
							return (
								<div key={i} className="live-game-card">
									<div className="live-game-card-body">
										<img src="server/media/blank_emblem.png" />
										<div
											className="live-game-card-body-ctx"
											dangerouslySetInnerHTML={{
												__html:
													'<marquee scrollamount="2">' +
													item.game.teamOne.name +
													' <span style="color: #f54; font-size: 1.05em ">' +
													item.results.teamOneGoals.length +
													'</span> - <span style="color: #f54; font-size: 1.05em ">' +
													item.results.teamTwoGoals.length +
													"</span> " +
													item.game.teamTwo.name +
													"</marquee><h4>" +
													Math.round(item.game.currentTime / 60) +
													"'</h4><span>" +
													FakeData.toMyTimezone(item.game.fullDate).getHours() +
													":" +
													FakeData.toMyTimezone(
														item.game.fullDate
													).getMinutes() +
													", " +
													item.game.tournament +
													"</span>"
											}}
										/>
										<img src="server/media/blank_emblem.png" />
										<Link to={{ pathname: "/game/" + item.game.id }}>
											View<br />Game
                    </Link>
									</div>
								</div>
							);
						})}
						<EmptyState
							style={{ background: "#fff", padding: "10px" }}
							isShown={FakeData.listify(filFix).length === 0 ? true : false}
							text="No live games were found!"
							icon=""
						/>
					</div>
				)}
				{isExtended && (
					<div className={"load-more " + this.props.class}>Load More</div>
				)}
			</div>
		);
	}
}

export class GlobalTMForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			audienceKey: "T",
			postToken: Date.now(),
			isError: false,
			isPosting: false,
			canAddLinkImages: false,
			words: props.words ? props.words() : [],
			post: {
				content: "",
				rawContent: "",
				postType: "normal",
				media: [],
				links: [],
				tags: [],
				audienceList: [],
				place: { name: "" },
				coord: { lat: 0, lng: 0 }
			},
			linkImages: [
				{
					url: false
				},
				{
					url: false
				},
				{
					url: false
				},
				{
					url: false
				},
				{
					url: false
				}
			],
			commentID: 0,
			isModalOpen: false,
			isTagging: false,
			isWhoToSee: false,
			isSending: false,
			isModalAlbumOpen: false,
			isCheckingIn: false,
			isGoingLive: false,
			tags: []
		};

		this.onTextChange = this.onTextChange.bind(this);
		this.onPost = this.onPost.bind(this);
		this.onAddFiles = this.onAddFiles.bind(this);
		this.onAddTag = this.onAddTag.bind(this);
	}

	onTextChange(e, isError = false) {
		this.state.post.content = e.target.value;
		this.setState({
			post: this.state.post,
			isError
		});

		this.getUrls(e.target.value);
	}

	getUrls = (text = "") => {
		const links = [];
		const { post } = this.state;
		text.split(" ").forEach((item, i) => {
			if (FakeData.isWebsite(item)) {
				links.push(item);
			}
		});

		post.links = links;
		this.setState({ post });
	};

	onPost(type) {

		if(this.state.isError){
			alert('Please check your post content before submitting');
			return;
		}

		if (this.state.post.content === "" && this.state.post.media.length === 0) {
			return;
		}

		this.setState({ isPosting: true, isSending: false });

		const _that = this;
		const _user = {
			id: this.props.isAdmin ? this.props.postToId : FakeData.getData("yoo").id,
			type: this.props.isAdmin ? this.props.postToType : "F"
		};

		const linkImages = [];
		this.state.linkImages
			.filter((item, i) => {
				return item.id;
			})
			.forEach((item, id) => {
				linkImages.push(item.url);
			});

		const newPost = {
			user: _user,
			userTo: {
				name: this.props.postToName,
				image: this.props.postToImage,
				id: this.props.postToId,
				type: this.props.postToType
			},
			type: 1,
			postType: "normal",
			sport: type,
			isError: false,
			isEvent: false,
			content: this.state.post.content,
			rawContent: this.state.post.rawContent,
			media: this.state.post.media,
			timeAgo: new Date(),
			isLiked: false,
			likes: [],
			links: this.state.post.links.join(","),
			linkImages: linkImages.join(","),
			place: this.state.post.place,
			shares: [],
			commentType: "post",
			audience: "friends",
			tagged: this.state.post.tags,
			audienceList: this.state.post.audienceList,
			tagsLen: this.state.post.tags.length,
			comments: []
		};

		this.setState((state, props) => {
			return { isPosting: true };
		});

		FakeData.post(
			"/createPost.php?auth0",
			newPost,
			{
				success: res => {
					_that.setState({
						isPosting: false,
						postToken: Date.now(),
						canAddLinkImages: false,
						post: {
							content: "",
							postType: "normal",
							media: [],
							links: [],
							tags: [],
							audienceList: [],
							place: { name: "" },
							coord: { lat: 0, lng: 0 }
						},
						linkImages: [
							{
								url: false
							},
							{
								url: false
							},
							{
								url: false
							},
							{
								url: false
							},
							{
								url: false
							}
						],
						isModalOpen: false,
						isTagging: false,
						isWhoToSee: false,
						isSending: false,
						isModalAlbumOpen: false
					});

					_that.props.onPostAdded(res);
					if (FakeData.shared("_feeds")) {
						FakeData.shared("_feeds").refreshContent();
					}
				},
				error: err => { }
			},
			true,
			"Post was added to Timeline!",
			data => { }
		);
	}

	onAddFiles(cap, files, type, place, coord) {
		this.state.post.content = cap;
		this.state.post.media = files;
		const placeFor = {
			name: place
		};

		coord = coord ? coord : { lat: 0, lng: 0 };

		this.state.post.place = placeFor;
		this.state.post.coord = coord;

		this.setState({
			post: this.state.post
		});

		this.onPost(type);
	}

	onAddTag(tags) {
		this.state.post.tags = tags;
		this.setState({
			post: this.state.post
		});
	}

	whoToSeeThisPost(key) {
		this.setState({
			isTaggingAudience: true,
			audienceKey: key
		});
	}

	onClose(arr) {
		this.state.post.audienceList = arr;
		this.setState({
			isTaggingAudience: false,
			post: this.state.post
		});
	}

	showVideoButton = (type = false) => {
		if (!type) {
			return true;
		}

		const { profile, userToType, postToType } = this.props;

		if (profile.isAdmin) {
			return true;
		}

		let bool = true;
		FakeData.listify(profile.settings).forEach((item, i) => {
			if (item.sub === "can_post_media") {
				bool = item.value;
			}
		})

		return bool;
	}

	canPost = (type = false) => {
		if (!type) {
			return true;
		}

		const { profile, userToType, postToType } = this.props;

		if (profile.isAdmin) {
			return true;
		}

		let bool = true;
		FakeData.listify(profile.settings).forEach((item, i) => {
			if (item.sub === "can_post") {
				bool = item.value;
			}
		})

		return bool;
	}

	render() {
		const User = FakeData.getData("yoo");
		const sportsFollowed = User.sportsFollowed ? User.sportsFollowed : [];
		const { style, label, withoutCheckIn, direct, withoutAlbum } = this.props;
		const {
			isPosting,
			post,
			linkImages,
			canAddLinkImages,
			isGoingLive,
			postToken,
			words
		} = this.state;

		const postErrorWords = post.content.split(" ").filter((word, i) => {
			return FakeData.inArray(word, words);
		});

		if (!this.canPost(this.props.postToType)) {
			return null;
		}

		return (
			<div
				className="timeline-form"
				style={{ width: "100%", marginLeft: "0px", ...style }}
			>
				<div className="this-form">
					<div className="header-for">
						<h4>{label ? label : "Share"}</h4>
						{this.is && (
							<div
								className="share-btn"
								onClick={() =>
									this.setState({
										isModalOpen: true
									})
								}
							>
								<img src=".././images/photo_icon_gry.svg" alt="Share Photo" />Photo/Video
              </div>
						)}
						{this.is &&
							!withoutAlbum && (
								<div
									className="share-btn"
									onClick={() =>
										this.setState({
											isModalAlbumOpen: true
										})
									}
								>
									<img src=".././images/album_icon_gry.svg" alt="Share Photo" />Album
                </div>
							)}
						{this.is &&
							!withoutCheckIn && (
								<div
									className="share-btn"
									onClick={() =>
										this.setState({
											isCheckingIn: true
										})
									}
								>
									<img
										src=".././images/checkin_gry.svg"
										alt="Where were you?"
									/>Check in
                </div>
							)}
						{this.is && (
							<div
								className="share-btn"
								onClick={() =>
									this.setState({
										isTagging: this.state.isTagging ? false : true
									})
								}
							>
								<img
									src=".././images/tag_icon_gry.svg"
									alt="Who were you with?"
								/>Tag
              </div>
						)}
						{this.showVideoButton(this.props.postToType) &&
							<div
								className={"new-form-action"}
								onClick={() => {
									this.setState({
										isGoingLive: true
									});
								}}
								style={{
									marginRight: "20px"
								}}
							>
								<i className={"material-icons"} style={{ color: "#4ac" }}>
									panorama_fish_eye
                </i>

								<span>Live Video</span>
							</div>
						}
					</div>
					{this.is &&
						<InputTrigger
							trigger={{
								keyCode: 50,
								shiftKey: true,
							}}
							onStart={(metaData) => { console.log(metaData); }}

						>
							<textarea
								value={this.state.post.content}
								placeholder="Write something..."
								onChange={e => this.onTextChange(e)}
							/>
						</InputTrigger>}
					<RichTextInputField type="emoji" disabled={!this.canPost(this.props.postToType)} noStyle={true} onRawTextChange={(text, rawText, isError) => {
						this.state.post.rawContent = rawText;
						this.state.post.content = text;
						this.setState({ post: this.state.post, isError });
					}} placeholder={"Write something..."} key={postToken} value={this.state.post.content} onTextChange={(e) => this.onTextChange(e)} />
					<div className={"add-image-to-link"}>
						{post.links &&
							post.links.length > 0 &&
							canAddLinkImages &&
							linkImages.map((item, i) => {
								return (
									<LinkImageAdd
										key={i}
										image={item}
										className={"add-image-to-link-item"}
										onChange={image => {
											linkImages[i] = image;
											this.setState({ linkImages });
										}}
									/>
								);
							})}
					</div>
					{post.links &&
						post.links.length > 0 && (
							<LinkView
								user={this.props.user}
								beforPost={true}
								key={"link-" + post.links[0]}
								userType={this.props.userType}
								links={post.links}
								setPicAdd={bool => {
									this.setState({ canAddLinkImages: bool });
								}}
							/>
						)}
					<TagView
						selected={this.state.post.tags}
						user={FakeData.getData("yoo")}
						onAddTag={this.onAddTag}
						isShown={this.state.isTagging}
						isLabel="true"
					/>
					<div className="actions-for" style={{ justifyContent: "flex-end" }}>
						{!this.state.isWhoToSee && !this.state.isSending && !isPosting&& this.canPost(this.props.postToType) && (
							<div className={"new-form-actions"}>
								{this.showVideoButton(this.props.postToType) &&
									<div
										className={"new-form-action"}
										onClick={() => {
											this.setState({
												isModalOpen: true
											});
										}}
									>
										<i className={"material-icons"} style={{ color: "#75c538" }}>
											photo_library
                    </i>
										<span>Media</span>
									</div>
								}
								<div
									className={"new-form-action"}
									onClick={() => {
										this.setState({
											isCheckingIn: true
										});
									}}
								>
									<i className={"material-icons"} style={{ color: "#ff006b" }}>
										location_on
                  </i>
									<span>Check in</span>
								</div>
								<div
									className={"new-form-action"}
									onClick={() => {
										this.setState({
											isTagging: this.state.isTagging ? false : true
										});
									}}
								>
									<i className={"material-icons"} style={{ color: "#4ac" }}>
										person_add
                  </i>
									<span>Tag</span>
								</div>
							</div>
						)}
						{!this.state.isSending && !isPosting &&
							<div className="who_sees_this">
								<div
									className="post_to_title"
									onClick={() => {
										if (!this.canPost(this.props.postToType)) {
											return;
										}
										this.setState({
											isWhoToSee: this.state.isWhoToSee ? false : true
										})
									}}
								>
									Who should see this?
                </div>
								<div
									className="who_sees_item post_to_initial"
									id="post_to_friends"
									onClick={() => {
										if (!this.canPost(this.props.postToType)) {
											return;
										}
										this.whoToSeeThisPost("F")
									}}
								>
									<a className="post_to_friends">
										<img src="images/who_sees_friends.svg" alt="Friends" />
									</a>
								</div>
							</div>
						}
						{!this.state.isSending && this.canPost(this.props.postToType) &&
							<div
								className="who_sees_this_icons"
								style={{ display: this.state.isWhoToSee ? "block" : "none" }}
							>
								<div
									className="who_sees_item"
									onClick={() => this.whoToSeeThisPost("Q")}
								>
									<a>
										<img
											src="images/facebook-group.svg"
											alt="League"
											style={{
												background: "#58CC66",
												borderRadius: "100px",
												padding: "2px"
											}}
										/>
									</a>
								</div>
								<div
									className="who_sees_item"
									onClick={() => this.whoToSeeThisPost("T")}
								>
									<a>
										<img src="images/who_sees_game.svg" alt="Team" />
									</a>
								</div>
								<div
									className="who_sees_item"
									onClick={() => this.whoToSeeThisPost("C")}
								>
									<a>
										<img
											src="images/club.svg"
											alt="Clubs"
											style={{
												background: "#f43",
												borderRadius: "100px",
												padding: "2px"
											}}
										/>
									</a>
								</div>
								<div
									className="who_sees_item"
									onClick={() => this.whoToSeeThisPost("L")}
								>
									<a>
										<img src="images/who_sees_league.svg" alt="League" />
									</a>
								</div>
								<div
									className="who_sees_item"
									onClick={() => this.whoToSeeThisPost("I")}
								>
									<a>
										<img
											src="images/institution_icon.svg"
											alt=""
											style={{
												background: "#888",
												borderRadius: "100px",
												padding: "2px"
											}}
										/>
									</a>
								</div>
							</div>
						}
						<div
							className="button-of"
							style={{ flex: "none" }}
							onClick={() => {
								if (!this.canPost(this.props.postToType)) {
									return;
								}
								if (direct) {
									this.onPost({ id: null, name: "" });
								} else {
									this.setState({
										isSending: this.state.isSending ? false : true
									});
								}
							}}
						>
							<button>{isPosting ? "Posting.." : "Post"}</button>
						</div>
						<div
							className="post_to_sports"
							style={{ display: this.state.isSending ? "block" : "none" }}
						>
							{sportsFollowed.map((item, i) => {
								return (
									<div
										key={i}
										className="post_to_item"
										onClick={() => this.onPost(item)}
									>
										<img
											src={".././images/" + item.name.toLowerCase() + "_icon_drk.svg"}
											alt="Soccer"
										/>
									</div>
								);
							})}
						</div>
					</div>
				</div>
				{this.state.isModalOpen && (
					<PhotoAddModal
						isAdmin={this.props.isAdmin}
						toId={this.props.postToId}
						toType={this.props.postToType}
						isTeam={true}
						onPost={this.onAddFiles}
						url={
							FakeData.URL +
							"/uploadMedia.php?auth0&userType=" +
							(this.props.isAdmin ? this.props.postToType : "F") +
							"&userId=" +
							this.props.postToId
						}
						user={User}
						isOpen={this.state.isModalOpen}
						onClose={() =>
							this.setState({
								isModalOpen: false
							})
						}
					/>
				)}

				{this.state.isModalAlbumOpen && (
					<AlbumAddModal
						isAdmin={this.props.isAdmin}
						toId={this.props.postToId}
						toType={this.props.postToType}
						onPost={this.onAddFiles}
						url={
							FakeData.URL +
							"/uploadMedia.php?auth0&userType=" +
							(this.props.isAdmin ? this.props.postToType : "F") +
							"&userId=" +
							this.props.postToId
						}
						user={User}
						isOpen={this.state.isModalAlbumOpen}
						onClose={() =>
							this.setState({
								isModalAlbumOpen: false
							})
						}
					/>
				)}

				{this.state.isTaggingAudience && (
					<WhoToSeePicker
						active={this.state.audienceKey}
						isOpen={this.state.isTaggingAudience}
						onClose={arr => this.onClose(arr)}
					/>
				)}

				{this.state.isCheckingIn && (
					<CheckInModal
						isOpen={this.state.isCheckingIn}
						onPost={this.onAddFiles}
						onClose={data => {
							this.setState({
								isCheckingIn: false
							});
						}}
					/>
				)}

				{isGoingLive && (
					<VideoStreamTV
						onClose={() => {
							this.setState({ isGoingLive: false });
						}}
						user={{
							name: this.props.user ? this.props.user.name : this.props.postToName,
							image: this.props.user ? this.props.user.image : this.props.postToImage,
							id: this.props.user ? this.props.user.id : this.props.postToId,
							type: this.props.user ? this.props.userType : this.props.postToType
						}}
						isLive={true}
						style={{
							zIndex: 9999,
							background: 'url(".././images/stadium_background.jpg")'
						}}
					/>
				)}
			</div>
		);
	}
}

class LinkImageAdd extends Component {
	constructor(props) {
		super(props);
		this.state = {
			file: {
				progress: 0,
				file: null
			},
			isUploading: false
		};
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	uploadFile(file) {
		this.setState({ isUploading: true });
		var formdata = new FormData();
		const _that = this;
		formdata.append("file", file);
		formdata.append("location", "");
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("toId", FakeData.getData("yoo").id);

		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.file.progress = percent;
				_that.setState({
					file: _that.state.file
				});
			},
			false
		);

		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.currentTarget.responseText);
				_that.state.file.file = data;
				_that.setState({
					file: _that.state.file,
					isUploading: false
				});

				_that.props.onChange(data);
			},
			false
		);

		ajax.open(
			"POST",
			FakeData.URL +
			"/uploadMedia.php?auth0&userId=" +
			FakeData.getData("yoo").id +
			"&type=" +
			"F" +
			"&userType=F"
		);
		ajax.send(formdata);
	}

	removeFile(file) {
		//const file = f
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			img: file,
			tags: []
		};

		FakeData.post(
			"/removeMedia.php?auth0",
			dataTo,
			{
				success: res => {
					_that.state.file.file = null;
					_that.state.file.progress = 0;

					_that.setState({
						file: _that.state.file
					});

					_that.props.onChange({ url: false });
				},
				error: err => {
					_that.props.onChange({ url: false });
				}
			},
			true,
			"File Was Removed",
			res => { }
		);
	}

	render = () => {
		const { image } = this.props;
		const { file, isUploading } = this.state;

		return (
			<div
				className={"add-image-to-link-item"}
				style={{ position: "relative" }}
			>
				{!image.url && (
					<div
						style={{
							width: "100%",
							height: "100%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							position: "relative"
						}}
					>
						<input
							type={"file"}
							onChange={e => {
								const _that = this;
								file.file = e.target.files[0];
								this.uploadFile(e.target.files[0]);
								this.setState({ file });
							}}
							accept={"image/*"}
							style={{
								width: "100%",
								height: "100%",
								display: "block",
								position: "absolute",
								zIndex: 1,
								opacity: 0
							}}
						/>
						{!isUploading && (
							<i
								className={"material-icons"}
								style={{
									display: "block",
									position: "relative",
									fontSize: "40pt",
									color: "#ccc"
								}}
							>
								camera_alt
              </i>
						)}
						{isUploading && (
							<i
								className={"material-icons"}
								style={{
									display: "block",
									position: "relative",
									fontSize: "40pt",
									color: "#ccc"
								}}
							>
								hourglass_empty
              </i>
						)}
					</div>
				)}
				{image.id && (
					<div
						style={{
							width: "100%",
							height: "100%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							position: "relative"
						}}
					>
						<img
							src={image.url}
							style={{
								width: "100%",
								height: "100%",
								display: "block",
								position: "absolute",
								opacity: 0.7
							}}
						/>
						<i
							className={"material-icons"}
							style={{
								display: "block",
								position: "relative",
								zIndex: 1,
								fontSize: "40pt",
								color: "red"
							}}
							onClick={() => {
								this.removeFile(image);
							}}
						>
							delete
            </i>
					</div>
				)}
			</div>
		);
	};
}

export class GlobalTMFeeds extends Component {
	constructor(props) {
		super(props);
		this.state = {
			posts: [],
			words: props.words ? props.words() : [],
			isLoadingPosts: true,
			isLoadingMorePosts: false,
			isNoMore: false,
			settins: [],
			limit: 25
		};

		this.onScrollCallBack = this.onScrollCallBack.bind(this);
		this.onScrollEndCallBack = this.onScrollEndCallBack.bind(this);
	}

	deletePost(index) { }

	getUser = (pUser, oUser) => {
		if (pUser.admin && pUser.admin.id === oUser.id) {
			return pUser;
		} else {
			const i = FakeData.listify(pUser.roles).findIndex(
				data => data.user.id == oUser.id
			);
			if (i === -1) {
				return oUser;
			} else {
				return pUser;
			}
		}
	};

	getSettings = () => {
		const _that = this;

		FakeData.post('https://supotsu.com:8080/api/settings/get', {
			id: this.props.page.id,
			type: this.props.page.type
		}, {
				headers: {
					'Content-Type': 'application/json'
				},
				success(settings) {
					_that.setState({ settings });
				}
			})
	}

	onScrollEndCallBack = e => {
		const { posts, isLoadingPosts, limit } = this.state;
		if (posts.length < limit) {
			this.setState({ isNoMore: true });
			return;
		}

		this.setState({
			isLoadingMorePosts: true,
			limit: limit + 25
		});

		if (this.props.isHome) {
			this.getHomePosts();
		} else {
			this.getPosts();
		}
	};

	onScrollCallBack = e => { };

	componentDidMount() {
		this._isMounted = true;
		if (this.props.isHome) {
			this.getHomePosts();
		} else {
			this.getPosts();
		}

		this.getSettings();
		FakeData.shared("_feeds", this);
	}

	refreshContent = () => {
		if (this.props.isHome) {
			this.getHomePosts();
		} else {
			this.getPosts();
		}
	};

	componentWillUnmount() {
		this._isMounted = false;
	}

	getPosts = () => {
		const _that = this;
		const dataTo = {
			user: {
				id: FakeData.getData("yoo").id,
				type: "F"
			},
			userTo: {
				id: this.props.page.id,
				type: this.props.page.type
			},
			clubs: this.props.clubs,
			leagues: this.props.leagues,
			teams: this.props.teams,
			blocked: FakeData.getBlocked(this, false, ["post"]).join(","),
			limit: this.state.limit
		};

		if (!_that._isMounted) {
			return;
		}

		FakeData.post("/getPosts.php?auth0", dataTo, {
			success: _res => {
				if (!_that._isMounted) {
					return;
				}
				const blocked = FakeData.getBlocked(this);
				let res = _res.filter((post, i) => {
					const _bool = !FakeData._getBlocked(post.id, post.commentType, blocked.BlockedBySystem) && !FakeData._getBlocked(post.id, post.commentType, blocked.BlockedByYou) && !FakeData._getBlocked(post.id, post.commentType, blocked.BlockedForYou);
					const _onwer = !FakeData._getBlocked(post.user.id, post.user.type, blocked.BlockedBySystem) && !FakeData._getBlocked(post.user.id, post.user.type, blocked.BlockedByYou) && !FakeData._getBlocked(post.user.id, post.user.type, blocked.BlockedForYou);
					return _bool && _onwer;
				})
				_that.setState({
					posts: res,
					isLoadingPosts: false,
					isLoadingMorePosts: false,
					isNoMore: false
				});

				setTimeout(() => {
					//_that.getPosts()
				}, 1000);
			},
			error: err => {
				if (!_that._isMounted) {
					return;
				}
				console.log(err);
			}
		});
	};

	getHomePosts = () => {
		const _that = this;
		const dataTo = {
			user: {
				id: FakeData.getData("yoo").id,
				type: "F"
			},
			userTo: {
				id: this.props.page.id,
				type: this.props.page.type
			},
			clubs: this.props.clubs,
			leagues: this.props.leagues,
			teams: this.props.teams,
			inst: this.props.institutions,
			blocked: FakeData.getBlocked(this, false, ["post"]).join(","),
			blocked_gmc: FakeData.getBlocked(this, false, ["gmc-post"]).join(","),
			blocked_game: FakeData.getBlocked(this, false, ["game-post"]).join(","),
			friends: this.props.friends,
			limit: this.state.limit
		};

		if (!_that._isMounted) {
			return;
		}

		FakeData.post("/getTest.php?auth0", dataTo, {
			success: _res => {
				if (!_that._isMounted) {
					return;
				}

				const blocked = FakeData.getBlocked(this);
				let res = _res.filter((post, i) => {
					const _bool = !FakeData._getBlocked(post.id, post.commentType, blocked.BlockedBySystem) && !FakeData._getBlocked(post.id, post.commentType, blocked.BlockedByYou) && !FakeData._getBlocked(post.id, post.commentType, blocked.BlockedForYou);
					const _onwer = !FakeData._getBlocked(post.user.id, post.user.type, blocked.BlockedBySystem) && !FakeData._getBlocked(post.user.id, post.user.type, blocked.BlockedByYou) && !FakeData._getBlocked(post.user.id, post.user.type, blocked.BlockedForYou);
					return _bool && _onwer;
				})

				res.sort((a, b) => {
					return b.timestamp - a.timestamp;
				});

				_that.preparePosts({
					posts: res
				})

				_that.setState({
					isLoadingPosts: false,
					isLoadingMorePosts: false,
					isNoMore: false
				});

				if (this.props.onPostsChange) {
					this.props.onPostsChange(res);
				}

				setTimeout(() => {
					//_that.getHomePosts()
				}, 1000);
			},
			error: err => {
				console.log(err);
			}
		});
	};

	preparePosts = ({posts = []}) => {
		const _posts = this.state.posts;
		const _postsIds = _posts.map((post, id)=>{
			return post.id;
		});

		posts.forEach((post, i)=>{
			if(!FakeData.inArray(post.id, _postsIds)){
				_posts.push(post);
			}
		})

		this.setState({ posts: _posts });
	}

	canSeePosts = (type = false) => {
		if (!type) {
			return {
				canSeePost: true,
				canSeeTagged: true
			};
		}

		this.canSee();

		const { profile, userToType, postToType } = this.props;

		if (profile.isAdmin) {
			return {
				canSeePost: true,
				canSeeTagged: true
			};
		}

		let canSeePost = true;
		let canSeeTagged = true;
		FakeData.listify(profile.settings).forEach((item, i) => {
			if (item.sub === "can_see_tagged_posts") {
				canSeeTagged = item.value;
			}
		})

		if (!FakeData.inArray(type, ["F", "P"])) {
			return {
				canSeePost: true,
				canSeeTagged
			};
		}

		FakeData.listify(profile.settings).forEach((item, i) => {
			if (item.sub === "can_see_posts" || item.sub === "who_to_see_posts") {
				canSeePost = (!profile.isFriend && item.value === "Friends") ? false : (item.value === "Public") ? true : false;
			}
		})

		return {
			canSeeTagged,
			canSeePost
		};
	}

	canSee = () => {
		const _ = FakeData.___(this.props.postToType, {
			"can_see_posts": "Friends",
			"can_see_tagged_posts": true,
			"who_to_see_posts": "Friends"
		}, this.props.profile, []);

		return _;
	}

	render() {
		const { isLoadingPosts, isLoadingMorePosts, words } = this.state;
		const { styles, hideSportLabel, userFilter } = this.props;
		const profile = this.props.profile ? this.props.profile : FakeData.getData("yoo");
		const _can_see = this.canSee();
		const posts = this.state.posts.filter((item, i) => {
			if (!userFilter) {
				return true;
			} else {
				return (
					(item.user.id === userFilter.id &&
						item.user.type === userFilter.type) ||
					(item.userTo.id === userFilter.id &&
						item.userTo.type === userFilter.type)
				);
			}
		});

		if (!_can_see.can_see_posts || !_can_see.who_to_see_posts) {
			return (
				<EmptyState isShown={true} icon="block" style={{
					background: "#fff",
					height: 200
				}} text="Content preview has been disabled by user!" />
			)
		}

		if (isLoadingPosts) {
			return (
				<div className="posts">
					{FakeData.getDummy(10).map((item, i) => {
						return <ShimmerView key={i} />;
					})}
				</div>
			);
		}

		return (
			<InfiniteScrollView
				key={
					"feed-" +
					this.props.page.id +
					"-" +
					(this.props.isHome ? "home" : "profile")
				}
				onScrollCallBack={this.onScrollCallBack}
				onScrollEndCallBack={this.onScrollEndCallBack}
			>
				<div className="posts">
					{posts.map((item, i) => {
						if (item.isGAME || item.isGMC) {
							return (
								<TimeLineCollectionComment words={words}
									external={true}
									profile={profile}
									style={styles ? styles.gmcPosts : {}}
									gmcStyle={{ borderRadius: "0px 0px", ...styles.gmcPosts }}
									key={item.isGMC ? "gmc_" + item.id : "game_" + item.id}
									isOdd={false}
									post={item}
									user={this.props.user}
									userType="F"
								/>
							);
						} else {
							return (
								<PostItem
									key={"post-" + item.id}
									profile={profile}
									shimmerStyle={i === 0 ? { margin: "0px 0px 5px 0px" } : { margin: "10px 0px 5px 0px" }}
									words={words}
									hideSportLabel={hideSportLabel ? hideSportLabel : false}
									style={styles ? styles.normalPosts : {}}
									post={item}
									key={"post_" + item.id}
									user={
										item.user.type !== "F" || item.user.type !== "P"
											? this.getUser(item.user, this.props.user)
											: this.props.user
									}
									userType={
										item.user.type !== "F" || item.user.type !== "P"
											? this.getUser(item.user, this.props.user).type
											: this.props.userType
									}
								/>
							);
						}
					})}
					{isLoadingMorePosts && (
						<div className="posts">
							{FakeData.getDummy(3).map((item, i) => {
								return <ShimmerView key={i} />;
							})}
						</div>
					)}
					{posts.length === 0 && !isLoadingMorePosts &&
						<EmptyState isShown={true} style={{
							marginTop: "10px",
							background: "#fff"
						}} text={"No Posts Found"} />
					}
				</div>
			</InfiniteScrollView>
		);
	}
}

export class ChangePictureIcon extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			media: {},
			file: {}
		};
	}

	changePhoto(img) {
		const _that = this;
		const isKey = this.props.propKey ? true : false;
		const dataTo = {
			tbl: this.props.table,
			fld: this.props.field,
			value: isKey
				? img[this.props.propKey].replace(FakeData.apiURL+"/", "")
				: img.url.replace(FakeData.apiURL+"/", ""),
			idField: this.props.idField,
			idFor: this.props.toId
		};

		FakeData.post(
			"/updateProfilePhoto.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						isOpen: false
					});
				},
				error: e => { }
			},
			true,
			"Data Saved!",
			r => { }
		);
	}

	onFilePicked(file) {
		const _that = this;
		let reader = new FileReader();
		reader.onloadend = () => {
			const newFile = {
				file: file,
				progress: 0,
				url: reader.result
			};

			_that.setState({
				file: newFile
			});

			_that.uploadFile(newFile);
		};
		reader.readAsDataURL(file);
	}

	uploadFile(file) {
		var formdata = new FormData();
		const _that = this;
		formdata.append("file", file.file);
		formdata.append("location", "");
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("toId", this.props.toId);
		formdata.append("objType", "profile");

		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.file.progress = percent;
				_that.setState({
					file: _that.state.file
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				if (data.id) {
					data.oldUrl = file.url;
					_that.setState({
						media: data
					});
					_that.changePhoto(data);
				} else {
					_that.setState({ media: {}, file: {} });
					alert("Error uploading file...");
				}
			},
			false
		);
		ajax.open(
			"POST",
			FakeData.URL +
			"/uploadMedia.php?auth0&userId=" +
			FakeData.getData("yoo").id +
			"&type=" +
			this.props.toType
		);
		ajax.send(formdata);
	}

	render() {
		return (
			<div className="change-picture-icon">
				<i
					className="material-icons"
					onClick={() => {
						this.setState({
							isOpen: true
						});
					}}
				>
					camera_alt
        </i>
				<Modal
					isOpen={this.state.isOpen}
					onClose={() => {
						this.setState({
							isOpen: false
						});
					}}
				>
					<div
						className="add-place"
						style={{
							width: "70vw"
						}}
					>
						<div className="photos-to-add-btn">
							<span>Upload File</span>
							<input
								type="file"
								accept="image/*"
								onChange={e => this.onFilePicked(e.target.files[0])}
							/>
						</div>
						<div className="photos-to-add">
							{this.props.pictures.map((item, i) => {
								return (
									<div
										key={i}
										className="photos-to-add-item"
										onClick={() => this.changePhoto(item)}
									>
										<img src={item.url} />
									</div>
								);
							})}
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

export class PostItem extends Component {
	constructor(props) {
		super(props);
		const _list = FakeData.getBlocked({ props: {} }, false, ["post"]);
		const _isBlocked = (FakeData.inArray(props.post.id, _list)) ? true : false;
		this.state = {
			isShowingComments: false,
			hasContent: false,
			isBlocked: false,
			rawContent: "",
			postEditToken: Date.now() + "-edit",
			postToken: Date.now(),
			isEditting: false,
			content: "",
			rawEditContent: "",
			value: "",
			removed: _isBlocked,
			media: {},
			file: {},
			settings: [],
			isDeleting: false,
			isSharing: false,
			post: this.props.post
		};
	}

	componentWillMount() {
		this.getBlockState();
	}

	componentDidMount() {
		this._isMounted = true;
		this.initSystem();
		this.getSettings();
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this.system) {
			this.system.close()
		}
	}

	getSettings = () => {
		const _that = this;

		FakeData.post('https://supotsu.com:8080/api/settings/get', {
			id: this.props.post.user.id,
			type: this.props.post.user.type
		}, {
				headers: {
					'Content-Type': 'application/json'
				},
				success(settings) {
					_that.setState({ settings });
				}
			})
	}

	getBlockState = () => {
		const _that = this;

		const dataTo = {
			userId: this.props.post.id,
			userType: "post",
			userToType: this.props.user.type,
			userToId: this.props.user.id
		}

		FakeData.post(FakeData.apiURL+"/admin/block/get", dataTo, {
			headers: {
				'Content-Type': 'application/json'
			},
			method: "POST",
			success(res) {
				const { isBlocked, data } = res;

				_that.setState({
					error: isBlocked,
					isBlocked,
					removed: isBlocked
				})

				if (!isBlocked) {
					setTimeout(() => {
						_that.getBlockState();
					}, 1500);
				}
			},
			error(error) {

			}
		});
	}

	like() {
		const item = this.state.post;
		const inRoles = this.inRoleIds((item.user.roles ? item.user.roles : []), (!item.user.roles ? false : item.user));
		const _user = inRoles ? item.user : this.props.user;
		const dataTo = {
			user: _user,
			type: "post",
			contentId: this.props.post.id,
			userOne: this.props.post.user,
			userTwo: this.props.post.userTo,
			users: this.props.post.tags,
			userType: inRoles ? _user.type : this.props.userType
		};
		const _that = this;

		FakeData.post(
			"/likeContent.php?auth0",
			dataTo,
			{
				success: res => {
					FakeData.alert("Done!");
				},
				error: err => { }
			},
			true,
			"",
			() => { }
		);
	}

	editPost() {
		const _that = this;
		const dataTo = {
			postId: this.props.post.id,
			content: this.state.content,
			rawContent: this.state.rawEditContent,
			userId: FakeData.getData("yoo").id
		};

		if(this.state.isError){
			alert('Please check your content before you submit...')
			return;
		}

		FakeData.post(
			"/editPost.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						isEditting: false,
						isError: false,
						postEditToken: Date.now() + "-edit"
					});
					FakeData.alert("Done!");
				},
				error: err => { }
			},
			true,
			"",
			() => { }
		);
	}

	deletePost() {
		const _that = this;
		const dataTo = {
			postId: this.props.post.id,
			media: this.props.post.media
		};

		FakeData.post(
			"/deletePost.php?auth0",
			dataTo,
			{
				success: res => {
					FakeData.alert("Done!");
					_that.setState({ isDeleting: false, error: true });
				},
				error: err => { }
			},
			true,
			"",
			() => { }
		);
	}

	onEnter(e, id, text = false, rawText = false) {
		if (e.keyCode === 13 || e.which === 13) {
			const item = this.state.post;
			const inRoles = this.inRoleIds((item.user.roles ? item.user.roles : []), (!item.user.roles ? false : item.user));
			const _user = inRoles ? item.user : this.props.user;
			const dataTo = {
				user: _user,
				postId: id,
				content: (!text) ? this.state.value : text,
				rawContent: !rawText ? this.state.rawContent : rawText,
				type: "post",
				media: this.state.media,
				userOne: this.props.post.user,
				userTwo: this.props.post.userTo,
				users: this.props.post.tags,
				userType: inRoles ? _user.type : this.props.userType
			};

			const _that = this;

			if(this.state.isError){
				alert('Please check your content before you submit...')
				return;
			}

			FakeData.post(
				"/createComment.php?auth0",
				dataTo,
				{
					success: res => {
						_that.setState({
							value: "",
							isError: false,
							rawContent: "",
							postToken: Date.now(),
							media: {},
							file: {}
						});
						FakeData.alert("Comment was posted!");
					},
					error: err => { }
				},
				true,
				"",
				() => { }
			);
		}
	}

	onSendMedia(media) {
		const item = this.state.post;
		const inRoles = this.inRoleIds((item.user.roles ? item.user.roles : []), (!item.user.roles ? false : item.user));
		const _user = inRoles ? item.user : this.props.user;
		const dataTo = {
			user: _user,
			postId: this.props.post.id,
			content: "",
			rawContent: "",
			type: "post",
			media: media,
			userOne: this.props.post.user,
			userTwo: this.props.post.userTo,
			users: this.props.post.tags,
			userType: inRoles ? _user.type : this.props.userType
		};

		const _that = this;

		FakeData.post(
			"/createComment.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						media: {},
						file: {}
					});
					FakeData.alert("Comment was posted!");
				},
				error: err => { }
			},
			true,
			"",
			() => { }
		);
	}

	onFilePicked(file) {
		const _that = this;
		let reader = new FileReader();
		reader.onloadend = () => {
			const newFile = {
				file: file,
				progress: 0,
				url: reader.result
			};

			_that.setState({
				file: newFile
			});

			_that.uploadFile(newFile);
		};
		reader.readAsDataURL(file);
	}

	uploadFile(file) {
		var formdata = new FormData();
		//var index =
		const _that = this;
		formdata.append("file", file.file);
		formdata.append("location", "");
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("toId", FakeData.getData("yoo").id);
		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.file.progress = percent;
				_that.setState({
					file: _that.state.file
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				if (data.id) {
					data.oldUrl = file.url;
					_that.onSendMedia(data);
				} else {
					_that.setState({ media: {}, file: {} });
					alert("Error uploading file...");
				}
			},
			false
		);
		ajax.open(
			"POST",
			FakeData.URL +
			"/uploadMedia.php?auth0&userId=" +
			FakeData.getData("yoo").id
		);
		ajax.send(formdata);
	}

	deleteMedia() {
		const file = this.state.media;
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			img: file,
			tags: this.state.tags
		};

		FakeData.post(
			"/removeMedia.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						media: {},
						file: {}
					});
				},
				error: err => { }
			},
			true,
			"File Was Removed",
			res => { }
		);
	}

	shareNow = () => {
		this.refs.share.blur();
		const _that = this;
		const data = {
			user: {
				id: FakeData.getData("yoo").id,
				type: "F"
			},
			userTo: {
				id: FakeData.getData("yoo").id,
				type: "F"
			},
			content: "",
			coord: { lat: 0, lng: 0 },
			audience: "friends",
			type: "POST",
			post: this.props.post,
			postType: "normal",
			place: { name: "" },
			tagged: []
		};

		FakeData.post(
			"/sharePost.php?auth0",
			data,
			{
				success(res) {
					FakeData.alert("Post shared on your timeline!");
				},
				error(err) { }
			},
			true,
			"",
			() => { }
		);
	};

	initSystem = () => {
		if (EventSource) {
			this.system = new EventSource(
				FakeData.fetchURL +
				"/getPost.php?auth0&isPost&userId=" +
				FakeData.getData("yoo").id +
				"&userType=F&type=post&id=" +
				this.props.post.id
			);
			const _that = this;
			if (this.system !== null) {
				//this.system.addEventListener()
				this.system.onmessage = function (e) {
					if (_that._isMounted) {
						this.setState({
							_that: JSON.parse(e.data)
						});
					}
				};

				this.system.addEventListener(
					"open",
					function (e) {
						// Connection was opened.
						//console.log(e)
					},
					false
				);

				this.system.addEventListener(
					"post_update",
					function (e) {
						// Connection was opened.
						if (_that._isMounted || !_that.state.isBlocked || !_that.state.removed) {
							const res = JSON.parse(e.data);
							if (res === null || _that.state.isBlocked) {
								_that.setState({ error: true, isLoading: false, hasContent: true, });
								_that.system.close();
							} else if ((res.user.isBlocked || res.userTo.isBlocked || _that.state.isBlocked) && _that.props.isView) {
								_that.setState({ error: true, isLoading: false, hasContent: true, });
								_that.system.close();
							} else {
								_that.setState({
									post: res,
									hasContent: true,
									content: (_that.state.content === "") ? res.content : _that.state.content, rawEditContent: (_that.state.rawEditContent !== "") ? _that.state.rawEditContent : res.rawContent
								});
								setTimeout(() => {
									if ((res.user.isBlocked || res.userTo.isBlocked || _that.state.isBlocked) && _that.props.isView) {
										_that.system.close();
									} else {

									}
								}, 1000);
							}
						}
					},
					false
				);

				this.system.addEventListener(
					"error",
					function (e) {
						if (e.readyState == EventSource.CLOSED) {
							// Connection was closed.
						}
					},
					false
				);
			}
		} else {
			console.warn("EventSource Streams not supoorted by browser");
			this.getPost();
		}
	};

	getPost = () => {
		const _that = this;
		const data = {
			type: "post",
			id: this.props.post.id,
			user: {
				id: FakeData.getData("yoo").id,
				type: "F"
			}
		};

		//console.log(data)

		FakeData.post("/getPost.php?auth0", data, {
			success(res) {
				if (!_that._isMounted || _that.state.isBlocked || _that.state.removed) {
					return;
				}

				if (res === null || _that.state.isBlocked) {
					_that.setState({ error: true, isLoading: false, hasContent: true, });
				} else if ((res.user.isBlocked || res.userTo.isBlocked || _that.state.isBlocked) && _that.props.isView) {
					_that.setState({ error: true, isLoading: false, hasContent: true, });
				} else {
					_that.setState({ post: res, hasContent: true, content: (_that.state.content === "") ? res.content : _that.state.content, rawEditContent: (_that.state.rawEditContent !== "") ? _that.state.rawEditContent : res.rawContent });
					setTimeout(() => {
						if ((res.user.isBlocked || res.userTo.isBlocked || _that.state.isBlocked) && _that.props.isView) {

						} else {
							_that.getPost();
						}
					}, 1000);
				}
			},
			error(e) {
				_that.setState({ error: true, isLoading: false, hasContent: true, });
			}
		});
	};

	inRoleIds = (arr = [], user = false) => {
		let _c = arr.filter((item, i) => {
			return item.user.id = FakeData.getData("yoo").id;
		});

		return _c.length > 0 ? true : false;
	}

	render() {
		const item = this.state.post;
		const { isDeleting, isSharing, hasContent, postToken, postEditToken, error, removed, settings } = this.state;
		const User = FakeData.getData("yoo");
		const { style, hideSportLabel, shimmerStyle } = this.props;
		const inRoles = this.inRoleIds((item.user.roles ? item.user.roles : []), (!item.user.roles ? false : item.user));
		let showPostOwner = (item.user.id === this.props.user.id && item.user.type === this.props.userType && item.user.type !== "F") ? true : false
		showPostOwner = inRoles ? inRoles : showPostOwner;
		const _canComment = settings.filter((item) => {
			return item.sub === 'can_comment'
		})

		let can_comment = _canComment.length === 0 ? true : _canComment[0]['value'];
		can_comment = FakeData.you().id === item.user.id || FakeData.you().id === item.userTo.id ? true : can_comment;

		const _canCommentLinks = settings.filter((item) => {
			return item.sub === 'can_comment_link'
		})

		const can_comment_link = _canCommentLinks.length === 0 ? true : _canCommentLinks[0]['value'];

		if (removed) {
			return null;
		}

		if (removed && this.props.isView) {
			return <EmptyState icon="block" style={{
				background: "#fff"
			}} text={"Content user was blocked!"} isShown={true} />;
		}

		if (!hasContent) {
			return <ShimmerView style={shimmerStyle} isTopMarginNull={this.props.isView ? true : false} />;
		}
		if ((error || this.state.isBlocked) && !this.props.isView) {
			return null;
		}

		if ((error || this.state.isBlocked) && this.props.isView) {
			return <EmptyState icon="block" style={{
				background: "#fff"
			}} text={"Content user was blocked!"} isShown={true} />;
		}

		return (
			<View className="post" style={{ ...style }}>
				<div className="post-header" style={{
					position: "relative"
				}}>
					<img
						src={item.user.image}
						className="post-avatar"
						alt="Commentor Avatar"
					/>
					<div className="post-author">
						<h1>
							<Link
								to={{
									pathname:
										item.user.type === "F" || item.user.type === "P"
											? "/profile/" + item.user.user
											: item.user.type === "L"
												? "/tournament/" + item.user.user
												: item.user.type === "C"
													? "/club/" + item.user.user
													: item.user.type === "I"
														? "/institution/" + item.user.user
														: "/team/" + item.user.user,
									search: "?sInit=about"
								}}
							>
								{item.user.name}
							</Link>
						</h1>
						<p>
							<span dangerouslySetInnerHTML={{ __html: (showPostOwner ? `Posted by <a href="/profile/${item.owner.user}">${item.owner.name}</a> · ` : ((item.userTo.id !== item.user.id && item.userTo.type !== item.user.type)) ? `Posted on <a>${item.owner.name}</a>'s Timeline · ` : "") + FakeData.moment(item.timeAgo).fromNow() }}></span>
							{item.place!=="" &&
								<span> · <span style={{color:"#4ac"}}>{item.place}</span> </span>
							}
							{/*item.isTagged &&
                <span><a>remove tag</a></span>*/}
							{((item.user.id === this.props.user.id && item.user.type === this.props.userType) || (item.user.id === FakeData.getData("yoo").id && item.user.type === "F")) && (
								<span>
									<a>
										<i
											className="material-icons"
											style={{
												fontSize: "12px",
												cursor: "pointer",
												margin: "0px 5px 0px 10px"
											}}
											onClick={() =>
												this.setState({
													isEditting: this.state.isEditting ? false : true
												})
											}
										>
											edit
                    </i>
									</a>
									<a onClick={() => this.setState({ isDeleting: true })}>
										<i
											className="material-icons"
											style={{ fontSize: "12px", cursor: "pointer" }}
										>
											delete
                    </i>
									</a>
								</span>
							)}
							
						</p>
						
					</div>
					<FeedBackPopUp user={{
						id: item.id,
						type: item.commentType
					}}
						object={{
							id: item.id,
							type: item.commentType,
							content: item.content,
							image: false
						}}
						userTo={(item.user.id === FakeData.getData("yoo").id && item.user.type === "F") ? FakeData.getData("yoo") : this.props.user} style={{
							position: "absolute",
							right: 0,
							top: 0,
							marginTop: 10
						}} owner={item.user} icon={"more_horiz"} menus={(item.user.id === this.props.user.id && item.user.type === this.props.userType) ?
							{
								/*Block:{label:"Hide Post", cb : () => {
								  this.setState({ error: true, isBlocked: true, removed: true });
								  this._isMounted = false;
								  FakeData.alert("Post hidden!")
								}},*/
								MasterBlock: {
									label: "Remove Post", data: {}, cb: () => {
										this.setState({ error: true, isBlocked: true, removed: true });
										this._isMounted = false;
										FakeData.alert("Post removed!")
									}
								}
							} : (item.user.id === FakeData.getData("yoo").id && item.user.type === "F") ?
								{
									MasterBlock: {
										label: "Hide Post", icon: "block", cb: () => {
											this.setState({ error: true, isBlocked: true, removed: true });
											this._isMounted = false;
											FakeData.alert("Post hidden!")
										}
									}
								} :
								{
									FeedBack: { label: "Give Feedback?", cb: () => { } },
									Unfollow: {
										label: `Unfollow ${(item.user.id === this.props.user.id && item.user.type === this.props.userType && item.user.type !== "F") ? item.user.name : item.user.name}`, cb: () => {
											this.setState({ error: true, isBlocked: true, removed: true });
											this._isMounted = false;
											FakeData.alert("Posts from this user won't show again!")
										}
									},
									Block: {
										label: "Hide Post", cb: () => {
											this.setState({ error: true, isBlocked: true, removed: true });
											this._isMounted = false;
											FakeData.alert("Post hidden!")
										}
									}
								}} />
					{item.sport && item.sport.id !== null &&
						!hideSportLabel &&
						!item.is_live &&
						!item.isShared && (
							<div
								className="post-label"
								style={{ background: item.sport.color }}
							>
								<a title="Selected Sport">
									<div className="selected_btn rugby">
										<img src={item.sport.image.toLowerCase()} />
									</div>
								</a>
								<div className="selected_sport">
									<a title="Selected Sport">{item.sport.name}</a>
								</div>
							</div>
						)}
				</div>
				<div className="post-body photo-container">
					{!this.state.isEditting && (
						<div
							className={((!item.isShared || item.media.length == 0) && item.content.length <= 100) ? "post-caption rich-text-content small" : "post-caption rich-text-content"}
							dangerouslySetInnerHTML={{ __html: FakeData.getRichText(this.state.post.rawContent, this.state.post.contentUsers) }}
						/>
					)}
					{this.state.isEditting && (
						<div>
							<RichTextInputField noEmoji={true} noStyle={true} onRawTextChange={(text, rawText, isError) => {
								this.setState({ content: text, rawEditContent: rawText, isError });
							}} placeholder={"Write something..."} key={postEditToken} value={this.state.content} onTextChange={e => this.setState({ content: e.target.value })} textAreaStyle={{
								outline: "none",
								display: "block",
								resize: "none",
								marginLeft: "2%",
								marginRight: "2%",
								width: "96%",
								marginBottom: "8px",
								overflow: "hidden"
							}} />
							{this.is && <textarea
								onChange={e => this.setState({ content: e.target.value })}
								style={{
									outline: "none",
									display: "block",
									resize: "none",
									marginLeft: "2%",
									marginRight: "2%",
									width: "96%",
									marginBottom: "8px",
									overflow: "hidden"
								}}
								value={this.state.content}
							/>}
							<button
								onClick={() => this.editPost()}
								style={{
									display: "block",
									marginLeft: "2%",
									border: "none",
									lineHeight: "18pt",
									marginBottom: "8px",
									color: "#fff",
									background: " #4ea3c9",
									fontSize: "11px"
								}}
							>
								Save
              </button>
						</div>
					)}
					{item.media.length === 0 &&
						!item.isShared &&
						item.hasLink &&
						!item.is_live && (
							<LinkView
								user={this.props.user}
								key={"link-" + item.id}
								hasImages={
									FakeData.listify(item.linkImages).length > 0 ? true : false
								}
								userType={this.props.userType}
								links={item.links}
								images={item.linkImages}
							/>
						)}
					{item.media.length > 0 &&
						!item.isShared &&
						!item.is_live && (
							<MediaList
								user={this.props.user}
								userType={this.props.userType}
								media={item.media}
								profile={this.props.profile}
								post={item}
								onLike={() => this.like()}
							/>
						)}
					{item.isShared &&
						item.shareType === "POST" &&
						!item.is_live && (
							<div className={"share-content-body-obj"}>
								<div className={"posts"}>
									<SharedPostItem
										hideSportLabel={hideSportLabel ? hideSportLabel : false}
										style={style}
										profile={this.props.profile}
										user={this.props.user}
										userType={this.props.userType}
										post={item.sharedObject}
									/>
								</div>
							</div>
						)}
					{item.isShared &&
						item.shareType === "SESSIONFILE" &&
						!item.is_live && (
							<div className={"share-content-body-obj"}>
								<EmbedMaterial isFile={true} file={item.sharedObject} profile={this.props.profile} />
							</div>
						)}
					{item.isShared &&
						item.shareType === "SESSION" &&
						!item.is_live && (
							<div className={"share-content-body-obj"}>
								<EmbedMaterial isFile={false} session={item.sharedObject} profile={this.props.profile} />
							</div>
						)}
					{item.is_live && (
						<VideoItemOffline
							id={item.video_id}
							profile={this.props.profile}
							onVideoLoaded={video => {
								this.setState({ videoOf: video });
							}}
							key={item.video_id}
						/>
					)}
				</div>
				<div className="post-actions">
					<div className="post-action like" onClick={() => this.like()}>
						<i className="material-icons">thumb_up</i>
						<span className="action-label">
							{FakeData.shortDigit(item.likes.length, "Like").data}
						</span>
					</div>
					<div
						className="post-action comment"
						onClick={() =>
							this.setState({
								isShowingComments: this.state.isShowingComments ? false : true
							})
						}
					>
						<i className="material-icons">chat_bubble</i>
						<span className="action-label">
							{FakeData.shortDigit(item.comments.length, "Comment").data}
						</span>
					</div>
					<div
						className="post-action share share-ctx"
						ref={"share"}
						tabIndex={0}
					>
						<i
							className="material-icons"
							style={{ transform: "rotateY(-180deg)" }}
						>
							reply
            </i>
						<span className="action-label">
							{FakeData.shortDigit(item.shares.length, "Share").data}
						</span>
						<div className="share-ctx-menu">
							<span onClick={this.shareNow.bind(this)}>Share Now</span>
							<span
								onClick={() => {
									this.setState({ isSharing: true });
									this.refs.share.blur();
								}}
							>
								Share With...
              </span>
						</div>
					</div>
				</div>
				{this.state.isShowingComments && (
					<div className="body-comments">
						<CommentCollection
							user={inRoles ? item.user : this.props.user}
							profile={this.props.profile}
							userType={inRoles ? item.user.type : this.props.userType}
							comments={item.comments}
						/>
						{this.state.file.url && (
							<div className="img-preload">
								<img src={this.state.file.url} />
								{this.state.file.progress <= 99 && (
									<div className="img-preload-spinner" />
								)}
								{this.state.file.progress >= 99 && (
									<i
										className="img-preload-delete material-icons"
										onClick={() => this.deleteMedia()}
									>
										delete
                  </i>
								)}
							</div>
						)}
						{can_comment &&
							<div className="body-comment-input">
								<img src={inRoles ? item.user.image : this.props.user.image} />
								<RichTextInputField noEmoji={true} onRawTextChange={(text, rawText,isError) => {
									this.setState({ value: text, rawContent: rawText,isError });
								}} disabled={can_comment ? false : true} placeholder={"Write something..."} onKeyPress={e => {
									if (e.keyCode === 13 || e.which === 13) {
										e.preventDefault();
									}
								}} key={postToken} onKeyUp={(e, text, rawText) => this.onEnter(e, item.id, text, rawText)} value={this.state.value} onTextChange={e =>
									this.setState({
										value: e.target.value
									})} />

								{this.is && <textarea
									placeholder="Write something.."
									onKeyPress={e => {
										if (e.keyCode === 13 || e.which === 13) {
											e.preventDefault();
										}
									}}
									onKeyUp={e => this.onEnter(e, item.id)}
									value={this.state.value}
									onChange={e =>
										this.setState({
											value: e.target.value
										})
									}
								/>}
								<i className="material-icons">
									camera_alt<input
										type="file"
										accept="image/*"
										onChange={e => this.onFilePicked(e.target.files[0])}
										multiple="false"
										style={{
											position: "absolute",
											margin: "-35px 0px 0px -10px",
											height: "30px",
											width: "30px",
											opacity: 0
										}}
									/>
								</i>
							</div>
						}
					</div>
				)}
				{isDeleting && (
					<ConfirmModal
						message="Are you sure you want to remove this post?<br/>"
						isOpen={isDeleting}
						data={""}
						onOkay={data => {
							this.deletePost();
						}}
						onCancel={() => {
							this.setState({
								isDeleting: false
							});
						}}
					/>
				)}
				{isSharing &&
					!item.is_live && !item.isShared && (
						<ShareContent
							hideSportLabel={hideSportLabel ? hideSportLabel : false}
							style={style}
							post={item}
							type={"POST"}
							user={this.props.user}
							profile={this.props.profile}
							userType={this.props.userType}
							isOpen={isSharing}
							onClose={() => {
								this.setState({ isSharing: false });
							}}
						/>
					)}
				{item.isShared &&
					item.shareType === "SESSION" &&
					!item.is_live &&
					<ShareContent hideSportLabel={true} profile={this.props.profile} style={null} post={item.sharedObject} type={"SESSION"} user={this.props.user} userType={this.props.userType} isOpen={isSharing} onClose={() => {
						this.setState({ isSharing: false })
					}}>
						<EmbedMaterial isFile={false} session={item.sharedObject} profile={this.props.profile} />
					</ShareContent>
				}
				{item.isShared &&
					item.shareType === "SESSIONFILE" &&
					!item.is_live &&
					<ShareContent hideSportLabel={true} profile={this.props.profile} style={null} post={item.sharedObject} type={"SESSIONFILE"} user={this.props.user} userType={this.props.userType} isOpen={isSharing} onClose={() => {
						this.setState({ isSharing: false })
					}}>
						<EmbedMaterial isFile={true} file={item.sharedObject} profile={this.props.profile} />
					</ShareContent>
				}
				{item.is_live &&
					isSharing && (
						<ShareContent
							hideSportLabel={true}
							profile={this.props.profile}
							style={null}
							post={{ _id: item.video_id }}
							type={"VIDEO"}
							user={this.props.user}
							userType={this.props.userType}
							isOpen={isSharing}
							onClose={() => {
								this.setState({ isSharing: false });
							}}
						>
							<VideoItemOffline id={item.video_id} key={item.video_id} profile={this.props.profile} />
						</ShareContent>
					)}
			</View>
		);
	}
}

var _blockDataHolder = { reasons: [], object: false, owner_email: "", is_forever: false, user_type: "F", user_id: "0", user_to_id: "0", user_to_type: "F", contents: [], username: "", date: false, owner_type: "F", owner_id: FakeData.getData("yoo").id, type: "block" }
var _reportDataHolder = {
	reasons: [],
	owner_email: "",
	user_type: "F",
	user_id: "0",
	user_to_id: "0",
	user_to_type: "F",
	contents: [],
	object: false,
	username: "",
	date: false,
	owner_type: "F",
	owner_id: FakeData.getData("yoo").id,
	stripe: "first"
}

export class FeedBackPopUp extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isReporting: false
		}

		this.feedBack = this.feedBack.bind(this);
		const _that = this;
		this.actions = {
			FeedBack: {
				icon: "error_outline",
				label: "Feedback",
				action: _that.feedBack,
				sendReport: (_data) => {
					console.log(_data)
					var url = FakeData.apiURL+"/admin/report";
					const hasUsers = _that.props.owner.roles ? true : false;
					const emails = hasUsers ? _that.props.owner.roles.map((role, i) => {
						return role.user.email;
					}) : []; emails.push(_that.props.owner.email)

					let data = _reportDataHolder;
					data.object = _that.props.object;
					data.owner_obj = {
						id: _that.props.owner.id,
						type: _that.props.owner.type,
						content: _that.props.owner.name,
						image: _that.props.owner.image
					};
					data.reasons = _data.selected;
					data.contents.push(_data.text);
					data.user_id = _that.props.user.id;
					data.user_type = _that.props.user.type;
					data.user_to_id = _that.props.userTo.id;
					data.user_to_type = _that.props.userTo.type;

					data.owner_id = _that.props.owner.id;
					data.owner_type = _that.props.owner.type;
					data.owner_email = emails.toString();

					data.username = _that.props.owner.user;

					FakeData.post(url, data, {
						headers: {
							'Content-Type': 'application/json'
						},
						method: 'POST',
						success(res) {
							if (res.error) {
								FakeData.alert("Failed to to report content");
								//cb();
							} else {
								//cb();
								console.log(res)
							}
						}
					}, true, "", null);
				}
			},
			Block: {
				icon: "block",
				label: "Block",
				action: (cb) => {
					var url = FakeData.apiURL+"/admin/block";
					let data = _blockDataHolder;

					const hasUsers = _that.props.owner.roles ? true : false;
					const emails = hasUsers ? _that.props.owner.roles.map((role, i) => {
						return role.user.email;
					}) : []; emails.push(_that.props.owner.email)

					data.reasons.push("Don't want to see this");
					data.user_id = _that.props.user.id;
					data.object = _that.props.object;
					data.user_type = _that.props.user.type;
					data.user_to_id = _that.props.userTo.id;
					data.is_forever = true;
					data.user_to_type = _that.props.userTo.type;

					data.owner_id = _that.props.owner.id;
					data.owner_type = _that.props.owner.type;
					data.owner_email = emails.toString();

					data.type = "hide";
					data.username = FakeData.inArray(_that.props.user.type, ["game-post", "post", "gmc-post"]) ? _that.props.user.type.replace("-", "_") + _that.props.user.id : _that.props.owner.user;
					FakeData.post(url, data, {
						headers: {
							'Content-Type': 'application/json'
						},
						method: 'POST',
						success(res) {
							if (res.error) {
								FakeData.alert("Failed to to block this content");
								//cb();
							} else {
								cb();
							}
						}
					}, true, "", null);
				}
			},
			Unfollow: {
				icon: "do_not_disturb_on",
				label: "Unfollow",
				action: (cb) => {
					var url = FakeData.apiURL+"/admin/block";
					let data = _blockDataHolder;

					const hasUsers = _that.props.owner.roles ? true : false;
					const emails = hasUsers ? _that.props.owner.roles.map((role, i) => {
						return role.user.email;
					}) : []; emails.push(_that.props.owner.email)

					data.reasons.push("Don't want to see this", "Unfollowed");
					data.user_id = _that.props.owner.id;

					data.object = {
						id: _that.props.owner.id,
						type: _that.props.owner.type,
						content: _that.props.owner.name,
						image: _that.props.owner.image
					}

					data.user_type = _that.props.owner.type;
					data.user_to_id = _that.props.userTo.id;
					data.is_forever = true;
					data.user_to_type = _that.props.userTo.type;

					data.owner_id = _that.props.owner.id;
					data.owner_type = _that.props.owner.type;
					data.owner_email = emails.toString();

					data.username = _that.props.owner.user;
					data.type = "unfollow";
					FakeData.post(url, data, {
						headers: {
							'Content-Type': 'application/json'
						},
						method: 'POST',
						success(res) {
							if (res.error) {
								FakeData.alert("Failed to to unfollow user");
								//cb();
							} else {
								cb();
							}
						}
					}, true, "", null);
				}
			},
			MasterBlock: {
				icon: "delete",
				label: "Remove",
				action: (cb) => {
					var url = FakeData.apiURL+"/admin/block";

					const hasUsers = _that.props.owner.roles ? true : false;
					const emails = hasUsers ? _that.props.owner.roles.map((role, i) => {
						return role.user.email;
					}) : []; emails.push(_that.props.owner.email)

					let data = _blockDataHolder;
					data.reasons.push("Don't want to see this", "Removed by user");
					data.contents.push("Don't unblock");
					data.user_id = _that.props.user.id;
					data.object = _that.props.object;
					data.user_type = _that.props.user.type;
					data.user_to_id = "0";
					data.user_to_type = "F";
					data.type = "block";
					data.is_forever = true;

					data.owner_id = _that.props.owner.id;
					data.owner_type = _that.props.owner.type;
					data.owner_email = emails.toString();

					data.username = FakeData.inArray(_that.props.user.type, ["game-post", "post", "gmc-post"]) ? _that.props.user.type.replace("-", "_") + _that.props.user.id : _that.props.owner.user;
					FakeData.post(url, data, {
						headers: {
							'Content-Type': 'application/json'
						},
						method: 'POST',
						success(res) {
							if (res.error) {
								FakeData.alert("Failed to to block this content");
								//cb();
							} else {
								cb();
							}
						}
					}, true, "", null);
				}
			},
			Setting: {
				icon: "settings",
				label: "Settings",
				action: (cb) => {
					cb();
				}
			}
		}
	}

	componentDidMount() {
		this._isMounted = true;
	}

	feedBack = (cb) => {
		this.setState({ isReporting: true });
		this.cb = cb;
		//console.log(cb)
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	render() {
		const { icon, style, iconStyle, text, isBanner, noIcon } = this.props;
		const { } = this.state;

		const _menus = Object.keys(this.actions);

		return (
			<div className={isBanner ? "feed-back-pop banner" : "feed-back-pop"} ref="feed" tabIndex={1} style={{
				position: "relative",
				...style
			}}>
				{text}
				{!noIcon && <i className="material-icons" style={{
					cursor: "pointer",
					margin: "0px 10px",
					...iconStyle
				}}>{icon}</i>}

				<div className={isBanner ? "feed-back-pop-actions banner" : "feed-back-pop-actions"} style={{
					backgroundColor: noIcon ? "#ddd" : ""
				}}>
					{
						_menus.map((item, i) => {
							if (!this.props.menus[item]) {
								return null;
							}

							return (
								<div key={item} className={"feed-back-pop-action"} onClick={() => {
									this.actions[item].action(this.props.menus[item].cb)
									this.refs.feed.blur();
								}}>
									<i className="material-icons">{this.props.menus[item].icon ? this.props.menus[item].icon : this.actions[item].icon}</i>
									<span>{this.props.menus[item].label ? this.props.menus[item].label : this.actions[item].label}</span>
								</div>
							)
						})
					}
				</div>
				{this.state.isReporting &&
					<ReportModal isOpen={this.state.isReporting} onClose={(data) => {
						this.setState({ isReporting: false });
						if (!data) {
							return;
						}
						this.actions.FeedBack.sendReport(data)
					}} />
				}
			</div>
		)
	}
}

export class ReportModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			crimes: {
				"tag_nudity": {
					"title": "Nudity",
					"value": "tag_nudity",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				},
				"tag_violence": {
					"title": "Violence",
					"value": "tag_violence",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				},
				"tag_harassment": {
					"title": "Harassment",
					"value": "tag_harassment",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				},
				"tag_suicide": {
					"title": "Suicide or Self-Injury",
					"value": "tag_suicide",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				},
				"tag_false_news": {
					"title": "False News",
					"value": "tag_false_news",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				},
				"tag_spam": {
					"title": "Spam",
					"value": "tag_spam",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				},
				"tag_unauthorized_sales": {
					"title": "Unauthorized Sales",
					"value": "tag_unauthorized_sales",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				},
				"tag_hate_speech": {
					"title": "Hate Speech",
					"value": "tag_hate_speech",
					"selected": false,
					"followupInput": null,
					"isTerminal": true
				}
			},
			text: ""
		}
	}

	getSelected = (_crimes = []) => {
		const { crimes } = this.state;
		const _data = [];
		_crimes.forEach((item, i) => {
			const _c = crimes[item];
			if (_c.selected) {
				_data.push(_c);
			}
		});

		return _data;
	}

	render() {
		const { crimes, text } = this.state;
		const _crimes = Object.keys(crimes);
		const _selected = this.getSelected(_crimes);
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => {
				this.props.onClose(false);
			}}>
				<div className={"add-place"} style={{
					width: "40vw",
					maxHeight: "40vw",
					display: "flex",
					flexDirection: "column"
				}}>
					<h2 style={{
						margin: 0
					}}>Report to us</h2>
					<div style={{
						flex: 1,
						width: "100%",
						border: "1px solid #eee",
						margin: "10px 0px 10px 0px",
						display: "flex",
						flexWrap: "wrap",
						padding: "10px 0px 0px 10px",
						justifyContent: "center"
					}}>
						{
							_crimes.sort((a, b) => {
								return b - a;
							}).map((item, i) => {
								const crime = crimes[item]
								return (
									<div style={{
										display: "flex",
										flexWrap: "wrap",
										padding: "0px 10px",
										lineHeight: "30px",
										margin: "0px 10px 10px 0px",
										cursor: "pointer",
										marginBottom: "10px",
										height: "30px",
										alignItems: "center",
										justifyContent: 'center',
										color: crime.selected ? "#fff" : "#000",
										background: crime.selected ? "#6ac" : "#eee",
										border: crime.selected ? "1px solid #4ac" : "1px solid #ddd",
										borderRadius: "10px"
									}} key={item} onClick={() => {
										crime.selected = !crime.selected;
										crimes[item] = crime;
										this.setState({ crimes });
									}}>
										{crime.title}
									</div>
								)
							})
						}
					</div>
					<div className={_selected.length === 0 ? "disabled" : ""} style={{
						display: "flex",
						alignItems: "center",
						border: "1px solid #ccc"
					}}>
						<i className="material-icons" style={{
							margin: "0px 5px 0px",
							fontSize: 36,
							color: "#aaa"
						}}>info</i>
						<textarea placeholder={"Write something... \nAt least 50 characters"} disabled={_selected.length === 0} style={{
							flex: 1,
							resize: "none",
							border: "none",
							borderLeft: "1px solid #ccc",
							padding: "5px 10px"
						}} onChange={(e) => {
							this.setState({ text: e.target.value });
						}} />
					</div>
					<button disabled={_selected.length === 0 || text.length < 50} onClick={() => {
						const data = {
							selected: _selected,
							text
						}
						this.props.onClose(data)
					}} className="button">Submit</button>
				</div>
			</Modal>
		)
	}
}

export const ShimmerView = props => {
	return (
		<div
			className="post-link-view"
			style={{
				padding: "10px",
				background: "#fff",
				margin: "0px",
				marginTop: "10px",
				marginBottom: "5px",
				width: "100%",
				...props.style
			}}
		>
			<div className="post-link-view-img animated-background" />
			<div className="post-link-view-body" style={{ padding: "0px 10px" }}>
				<div
					className="post-linkview-body-item hd animated-background"
					style={{ width: "70%" }}
				/>
				<div
					className="post-linkview-body-item desc animated-background"
					style={{ width: "95%", margin: "10px 0px", height: "40px" }}
				/>
				<div
					className="post-linkview-body-item url animated-background"
					style={{ width: "60%" }}
				/>
			</div>
		</div>
	);
};

export const BannerShimmer = props => {
	return (
		<div className="tabs game row main_content sp-flex-width" style={{
			position: "fixed",
			width: "100%",
			overflow: "hidden"
		}}>
			<div
				className="game-banner"
				style={{
					background: "#fff",
					padding: "20px"
				}}
			>
				<div
					className="post-link-view"
					style={{
						background: "#fff",
						margin: "0px",
						marginBottom: "20px",
						width: "100%",
						height: "100%",
						border: "none"
					}}
				>
					<div
						className="post-link-view-img animated-background"
						style={{
							width: "320px",
							height: "320px",
							borderRadius: "100%"
						}}
					/>
					<div className="post-link-view-body" style={{ padding: "0px 10px" }}>
						<div
							className="post-linkview-body-item hd animated-background"
							style={{ width: "70%" }}
						/>
						<div
							className="post-linkview-body-item desc animated-background"
							style={{ width: "95%", margin: "10px 0px", height: "100px" }}
						/>
						<div
							className="post-linkview-body-item url animated-background"
							style={{ width: "60%", height: "200px" }}
						/>
					</div>
				</div>
			</div>

			<div
				className="game-views animated-background"
				style={{
					background: "#fff",
					padding: "20px",
					marginTop: 10
				}}
			>
				<div
					className="animated-background"
					style={{
						width: "100%",
						height: "100%"
					}}
				/>
			</div>

			<div
				className="game-banner"
				style={{
					background: "#fff",
					padding: "20px",
					marginTop: 10
				}}
			>
				<div
					className="post-link-view"
					style={{
						background: "#fff",
						margin: "0px",
						marginBottom: "20px",
						width: "100%",
						height: "100%",
						border: "none"
					}}
				>
					<div
						className="post-link-view-img animated-background"
						style={{
							width: "320px",
							height: "320px",
						}}
					/>
					<div className="post-link-view-body" style={{ padding: "0px 10px" }}>
						<div
							className="post-linkview-body-item hd animated-background"
							style={{ width: "100%", height: "320px" }}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export class LinkView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
			isLoading: true,
			hasPreview: true,
			imageError: false,
			activeImage: false,
			data: {
				url: this.props.links[0],
				title: null,
				links: [],
				meta_tags: [],
				img: null,
				subtext: null
			}
		};
	}

	componentDidMount() {
		this._isMounted = true;
		this.getData();
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	getData = () => {
		const _that = this;
		const _data = {
			url: this.props.links[0]
		};

		if (!this._isMounted) {
			return;
		}

		FakeData.post("/getUrlContent.php", _data, {
			success(res) {
				if (!_that._isMounted) {
					return;
				}
				_that.setState({
					error: false,
					isLoading: false,
					data: res
				});
			},
			error(r) {
				if (!_that._isMounted) {
					return;
				}
				_that.setState({
					error: true,
					isLoading: false
				});
			}
		});
	};

	getMeta = meta => {
		const { data } = this.state;
		let string = "";
		for (let index = 0; index < data.meta_tags.length; index++) {
			const element = data.meta_tags[index];
			const _meta = FakeData.listify(element);
			if (_meta[0] === meta) {
				string = _meta[1];
				break;
			}
		}

		return string;
	};

	render = () => {
		const {
			data,
			isLoading,
			error,
			hasPreview,
			imageError,
			activeImage
		} = this.state;
		const { images, hasImages, beforPost, setPicAdd } = this.props;
		const _activeIndex = !activeImage ? 0 : activeImage;
		const _isPrev = _activeIndex === 0 ? false : true;
		const _isNext =
			_activeIndex === FakeData.listify(images).length - 1 ? false : true;

		if (error) {
			return null;
		}

		if (isLoading) {
			return (
				<div className="post-link-view">
					<div className="post-link-view-img animated-background" />
					<div className="post-link-view-body">
						<div
							className="post-linkview-body-item hd animated-background"
							style={{ width: "70%" }}
						/>
						<div
							className="post-linkview-body-item desc animated-background"
							style={{ width: "95%", margin: "10px 0px" }}
						/>
						<div
							className="post-linkview-body-item url animated-background"
							style={{ width: "60%" }}
						/>
					</div>
				</div>
			);
		}

		if (hasImages) {
			return (
				<div
					className="post-link-view-with-images"
					style={{
						height: "auto"
					}}
				>
					{_isPrev && (
						<div
							className={"post-link-view-with-images-control prev"}
							onClick={() => {
								if (_activeIndex === 0) {
									return;
								}
								this.setState({ activeImage: _activeIndex - 1 });
							}}
						>
							<i className="material-icons">keyboard_arrow_left</i>
						</div>
					)}
					{FakeData.listify(images).map((img, i) => {
						return (
							<div
								key={img}
								className={
									_activeIndex === i
										? "post-link-view-with-image current"
										: _isNext && _activeIndex + 1 === i
											? "post-link-view-with-image next"
											: _isPrev && _activeIndex - 1 === i
												? "post-link-view-with-image prev"
												: "post-link-view-with-image"
								}
							>
								<div className="post-link-view-with-image-img">
									<img src={img} />
								</div>
								<div className="post-link-view-with-image-ctx">
									<div className="post-link-view-body">
										<div
											className="post-linkview-body-item hd"
											dangerouslySetInnerHTML={{
												__html:
													this.getMeta("og:site_name") !== ""
														? this.getMeta("og:site_name")
														: data.title !== ""
															? data.title
															: "Title Not Found"
											}}
										/>
										{this.getMeta("description") !== "" && (
											<div className="post-linkview-body-item desc">
												{this.getMeta("description")}
											</div>
										)}
										<div className="post-linkview-body-item url">
											{data.url}
										</div>
									</div>
								</div>
							</div>
						);
					})}
					{_isNext && (
						<div
							className={"post-link-view-with-images-control next"}
							onClick={() => {
								if (_activeIndex === FakeData.listify(images).length - 1) {
									return;
								}
								this.setState({ activeImage: _activeIndex + 1 });
							}}
						>
							<i className="material-icons">keyboard_arrow_right</i>
						</div>
					)}
				</div>
			);
		}

		return (
			<div className="post-link-view" style={{ position: "relative" }}>
				{hasPreview && (
					<div className="post-link-view-img">
						<img
							onError={err => {
								if (setPicAdd) {
									setPicAdd(true);
								}
								this.setState({ hasPreview: false, imageError: true });
							}}
							src={
								this.getMeta("og:image") !== ""
									? this.getMeta("og:image")
									: data.images[0]
										? data.images[0]
										: "images/error_for_this.png"
							}
						/>
					</div>
				)}
				<div className="post-link-view-body">
					<div
						className="post-linkview-body-item hd"
						dangerouslySetInnerHTML={{
							__html:
								this.getMeta("og:site_name") !== ""
									? this.getMeta("og:site_name")
									: data.title !== ""
										? data.title
										: "Title Not Found"
						}}
					/>
					{this.getMeta("description") !== "" && (
						<div className="post-linkview-body-item desc">
							{this.getMeta("description")}
						</div>
					)}
					<div className="post-linkview-body-item url">{data.url}</div>
				</div>
				{beforPost &&
					!imageError && (
						<div
							style={{
								position: "absolute",
								background: "#4ac",
								fontSize: "11px",
								color: "#fff",
								margin: "10px",
								zIndex: 1,
								right: 0,
								cursor: "pointer",
								lineHeight: "25px",
								padding: "0px 5px",
								borderRadius: "5px"
							}}
							onClick={() => {
								if (setPicAdd) {
									setPicAdd(hasPreview);
									this.setState({ hasPreview: !hasPreview });
								}
							}}
						>
							toogle picture
            </div>
					)}
			</div>
		);
	};
}

export class SharedPostItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShowingComments: false,
			isEditting: false,
			content: this.props.post.content,
			value: "",
			media: {},
			file: {},
			isDeleting: false,
			isSharing: false
		};
	}

	like() {
		const dataTo = {
			user: this.props.user,
			type: "post",
			contentId: this.props.post.id,
			userOne: this.props.post.user,
			userTwo: this.props.post.userTo,
			users: this.props.post.tags,
			userType: this.props.userType
		};
		const _that = this;

		FakeData.post(
			"/likeContent.php?auth0",
			dataTo,
			{
				success: res => {
					FakeData.alert("Done!");
				},
				error: err => { }
			},
			true,
			"",
			() => { }
		);
	}

	render() {
		const item = this.props.post;
		const { isDeleting, isSharing } = this.state;
		const User = FakeData.getData("yoo");
		const { style, hideSportLabel } = this.props;
		return (
			<div className="post" style={{ ...style }}>
				<div className="post-header">
					<img
						src={item.user.image}
						className="post-avatar"
						alt="Commentor Avatar"
					/>
					<div className="post-author">
						<h1>
							<Link
								to={{
									pathname:
										item.user.type === "F" || item.user.type === "P"
											? "/profile/" + item.user.user
											: item.user.type === "L"
												? "/tournament/" + item.user.user
												: item.user.type === "C"
													? "/club/" + item.user.user
													: item.user.type === "I"
														? "/institution/" + item.user.user
														: "/team/" + item.user.id,
									search: "?sInit=about"
								}}
							>
								{item.user.name}
							</Link>
						</h1>
						<p>
							<span>{FakeData.moment(item.timeAgo).fromNow()}</span>
							{/*item.isTagged &&
                <span><a>remove tag</a></span>*/}
						</p>
					</div>

					{(item.sport.image !== "images/" || !hideSportLabel) && (
						<div
							className="post-label"
							style={{ background: item.sport.color }}
						>
							<a title="Selected Sport">
								<div
									className="selected_btn rugby"
									style={{ borderRight: "none" }}
								>
									<img src={item.sport.image.toLowerCase()} />
								</div>
							</a>
						</div>
					)}
				</div>
				<div className="post-body photo-container">
					<div
						className="post-caption"
						dangerouslySetInnerHTML={{ __html: this.props.post.content }}
					/>
					{item.media.length > 0 && (
						<div
							className={"post-media one"}
							style={{ width: "100%", minHeight: "250px" }}
						>
							<MediaItem
								key={"media-item-" + 0}
								file={item.media[0]}
								onMediaClick={this.like.bind(this)}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export class ShareContent extends Component {
	state = {
		activeShare:
			this.props.type !== "POST"
				? {
					key: "F",
					tag: "Friend",
					val: "Share on a Friend's timeline",
					img: ".././images/who_sees_friends.svg",
					bg: ""
				}
				: {
					key: "Y",
					tag: "You",
					val: "Share on your timeline",
					img: ".././images/user-picture.svg",
					bg: "#58CC66",
					withPadding: true
				},
		tabs: [
			{
				key: "Y",
				tag: "You",
				val: "Share on your timeline",
				img: ".././images/user-picture.svg",
				bg: "#58CC66",
				withPadding: true
			},
			{
				key: "F",
				tag: "Friend",
				val: "Share on a Friend's timeline",
				img: ".././images/who_sees_friends.svg",
				bg: ""
			},
			{
				key: "Q",
				tag: "Group",
				val: "Share in a Group",
				img: ".././images/facebook-group.svg",
				bg: "#58CC66",
				withPadding: true
			},
			{
				key: "T",
				tag: "Team",
				val: "Share on a Team's timeline",
				img: ".././images/who_sees_game.svg",
				bg: ""
			},
			{
				key: "C",
				tag: "Club",
				val: "Share on a Club's timeline",
				img: ".././images/club.svg",
				bg: "#f43",
				withPadding: true
			},
			{
				key: "L",
				tag: "Tournament",
				val: "Share on a Tournament's timeline",
				img: ".././images/who_sees_league.svg",
				bg: ""
			},
			{
				key: "I",
				tag: "Institution",
				val: "Share on an Institution's timeline",
				img: ".././images/institution_icon.svg",
				bg: "#888",
				withPadding: true
			}
		],
		tagged: [],
		filter: "",
		content: "",
		isTagging: false,
		isCheckingIn: false,
		canAlsoPost: false,
		isPosting: false,
		users: [],
		location: "",
		coord: { lat: 0, lng: 0 },
		index: 0,
		total: 1,
		posts: [],
		files: []
	};

	getUsers = key => {
		let List = [];
		switch (key) {
			case "F":
				List = FakeData.listify(FakeData.getData("yoo").friends).filter((item, i) => {
					const block = FakeData.getBlocked({ props: {} }, false, [key]);
					return !FakeData.inArray(item.id, block)
				});
				List.forEach((item, i) => {
					item.type = "F";
				});
				break;
			case "T":
				List = FakeData.listify(FakeData.getData("yoo").myTeams).filter((item, i) => {
					const block = FakeData.getBlocked({ props: {} }, false, [key]);
					return !FakeData.inArray(item.id, block)
				});
				List.forEach((item, i) => {
					item.type = "T";
				});
				break;
			case "C":
				List = FakeData.listify(FakeData.getData("yoo").clubs).filter((item, i) => {
					const block = FakeData.getBlocked({ props: {} }, false, [key]);
					return !FakeData.inArray(item.id, block)
				});
				List.forEach((item, i) => {
					item.type = "C";
				});
				break;
			case "I":
				List = FakeData.listify(FakeData.getData("yoo").institutions).filter((item, i) => {
					const block = FakeData.getBlocked({ props: {} }, false, [key]);
					return !FakeData.inArray(item.id, block)
				});
				List.forEach((item, i) => {
					item.type = "I";
				});
				break;
			case "L":
				List = FakeData.listify(FakeData.getData("yoo").leagues).filter((item, i) => {
					const block = FakeData.getBlocked({ props: {} }, false, [key]);
					return !FakeData.inArray(item.id, block)
				});
				List.forEach((item, i) => {
					item.type = "L";
				});
				break;
			case "Q":
				List = FakeData.listify(FakeData.getData("yoo").groups).filter((item, i) => {
					const block = FakeData.getBlocked({ props: {} }, false, [key]);
					return !FakeData.inArray(item.id, block)
				});
				List.forEach((item, i) => {
					item.type = "Q";
				});
				break;
			default:
				List = [];
				break;
		}

		return List;
	};

	inArray = (item = { id: 0, type: "" }, tagged = []) => {
		const list = tagged.filter(_item => {
			return _item.id === item.id && _item.type === item.type;
		});

		return list.length > 0 ? true : false;
	};

	post = () => {
		const _that = this;

		const { content, coord, tagged, users, canAlsoPost, location } = this.state;
		const { type, post } = this.props;
		if (tagged.length > 0) {
			const _data = {
				user: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				userTo: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				content,
				coord,
				audience: "friends",
				type,
				post,
				postType: "normal",
				place: { name: location },
				tagged: users
			};

			const posts = [];
			tagged.forEach((item, i) => {
				const __data = {
					user: {
						id: FakeData.getData("yoo").id,
						type: "F"
					},
					userTo: {
						id: item.id,
						type: item.type
					},
					content,
					coord,
					audience: "friends",
					type,
					post,
					postType: "normal",
					place: { name: location },
					tagged: users
				};

				if (!FakeData.inArray(__data, posts)) {
					posts.push(__data);
				}
			});

			if (canAlsoPost) {
				posts.unshift(_data);
			}

			this.sendPosts(posts, false);
		} else {
			this.setState({ isPosting: true });
			const data = {
				user: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				userTo: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				content,
				coord,
				audience: "friends",
				type,
				post,
				postType: "normal",
				place: { name: location },
				tagged: users
			};

			FakeData.post(
				"/sharePost.php?auth0",
				data,
				{
					success(res) {
						FakeData.alert("Post shared on your timeline!");
						_that.setState({ isPosting: false });
						_that.props.onClose();
					},
					error(err) { }
				},
				true,
				"",
				() => { }
			);
		}
	};

	postVid = () => {
		const _that = this;
		console.log("video");
		const { content, coord, tagged, users, canAlsoPost, location } = this.state;
		const { type, post } = this.props;
		if (tagged.length > 0) {
			const _data = {
				user: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				userTo: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				type: 2,
				postType: "live",
				is_live: "yes",
				vid_id: this.props.post._id,
				isEvent: false,
				content,
				media: [],
				timeAgo: new Date(),
				isLiked: false,
				likes: [],
				links: [],
				coord,
				linkImages: [],
				place: { name: location },
				shares: [],
				commentType: "post",
				audience: "friends",
				tagged: users,
				tagsLen: 0,
				comments: []
			};

			const posts = [];
			tagged.forEach((item, i) => {
				const __data = {
					user: {
						id: FakeData.getData("yoo").id,
						type: "F"
					},
					userTo: {
						id: item.id,
						type: item.type
					},
					type: 2,
					postType: "live",
					is_live: "yes",
					vid_id: this.props.post._id,
					isEvent: false,
					content,
					media: [],
					timeAgo: new Date(),
					isLiked: false,
					likes: [],
					links: [],
					coord,
					linkImages: [],
					place: { name: location },
					shares: [],
					commentType: "post",
					audience: "friends",
					tagged: users,
					tagsLen: 0,
					comments: []
				};

				if (!FakeData.inArray(__data, posts)) {
					posts.push(__data);
				}
			});

			if (canAlsoPost) {
				posts.unshift(_data);
			}

			this.sendPosts(posts, true);
		} else {
			this.setState({ isPosting: true });
			const data = {
				user: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				userTo: {
					id: FakeData.getData("yoo").id,
					type: "F"
				},
				type: 2,
				postType: "live",
				is_live: "yes",
				vid_id: this.props.post._id,
				isEvent: false,
				content,
				media: [],
				timeAgo: new Date(),
				isLiked: false,
				likes: [],
				links: [],
				coord,
				linkImages: [],
				place: { name: location },
				shares: [],
				commentType: "post",
				audience: "friends",
				tagged: users,
				tagsLen: 0,
				comments: []
			};

			FakeData.post(
				"/sharePost.php?auth0",
				data,
				{
					success(res) {
						FakeData.alert("Post shared on your timeline!");
						_that.setState({ isPosting: false });
						_that.props.onClose();
					},
					error(err) { }
				},
				true,
				"",
				() => { }
			);
		}
	};

	sendPosts = (posts = [], isVid = false) => {
		const _that = this;
		this.setState({ total: posts.length, index: 0, isPosting: true, posts });
		setTimeout(() => {
			if (isVid) {
				_that.postThisVid(0)
			} else {
				_that.postThis(0);
			}
		}, 1500);
	};

	postThis = _post => {
		const _that = this;
		const isLast = _post + 1 === this.state.total ? true : false;
		FakeData.post(
			"/sharePost.php?auth0",
			this.state.posts[_post],
			{
				success(res) {
					const next = _post + 1;
					_that.setState({ isPosting: !isLast, index: next });
					if (isLast) {
						FakeData.alert("Post shared to timelines!");
						_that.props.onClose();
					} else {
						setTimeout(() => {
							_that.postThis(next);
						}, 1500);
					}
				},
				error(err) { }
			},
			isLast,
			"",
			() => { }
		);
	};

	postThisVid = _post => {
		const _that = this;
		const isLast = _post + 1 === this.state.total ? true : false;
		FakeData.post(
			"/sharePost.php?auth0",
			this.state.posts[_post],
			{
				success(res) {
					const next = _post + 1;
					_that.setState({ isPosting: !isLast, index: next });
					if (isLast) {
						FakeData.alert("Post shared to timelines!");
						_that.props.onClose();
					} else {
						setTimeout(() => {
							_that.postThisVid(next);
						}, 1500);
					}
				},
				error(err) { }
			},
			isLast,
			"",
			() => { }
		);
	};

	onAddTag = tags => {
		this.setState({
			users: tags
		});
	};

	shareContent = _type => {
		const _that = this;

		const { content, coord, tagged, users, canAlsoPost, location } = this.state;
		const { type, post } = this.props;
		if (tagged.length > 0) {
			const files = [];
			const posts = [];
			tagged.forEach((item, i) => {
				const __data = {
					user: {
						id: FakeData.getData("yoo").id,
						type: "F"
					},
					userTo: {
						id: item.id,
						type: item.type
					},
					suggest: {
						id: post.id,
						type: _type
					}
				};

				if (!FakeData.inArray(__data, files)) {
					files.push(__data);
				}
			});

			if (canAlsoPost) {
				tagged.forEach((item, i) => {
					const __data_ = {
						user: {
							id: FakeData.getData("yoo").id,
							type: "F"
						},
						userTo: {
							id: item.id,
							type: item.type
						},
						content,
						coord,
						audience: "friends",
						type,
						post,
						postType: "normal",
						place: { name: location },
						tagged: users
					};

					if (!FakeData.inArray(__data_, posts)) {
						posts.push(__data_);
					}
				});
			}

			this.sendTrainingFiles(files, posts);
		} else {
			return;
		}
	};

	sendTrainingFiles = (files = [], posts = []) => {
		const _that = this;
		this.setState({
			total: files.length,
			index: 0,
			isPosting: true,
			posts,
			files
		});
		setTimeout(() => {
			_that.postSessionFile(0);
		}, 1500);
	};

	postSessionFile = (_post = 0) => {
		const _that = this;
		const isLast = _post + 1 === this.state.total ? true : false;
		FakeData.post(
			"/suggestMaterial.php?auth0",
			this.state.files[_post],
			{
				success(res) {
					if (_that.state.canAlsoPost) {
						let isPosted = _that.postForFile(_post, isLast);
						const next = _post + 1;
						_that.setState({ isPosting: !isLast, index: next });
						if (isLast) {
							FakeData.alert("Post shared to timelines!");
							_that.props.onClose();
						} else {
							setTimeout(() => {
								_that.postSessionFile(next);
							}, 1500);
						}
					} else {
						const next = _post + 1;
						_that.setState({ isPosting: !isLast, index: next });
						if (isLast) {
							FakeData.alert("Post shared to timelines!");
							_that.props.onClose();
						} else {
							setTimeout(() => {
								_that.postSessionFile(next);
							}, 1500);
						}
					}
				},
				error(err) { }
			},
			isLast,
			"",
			() => { }
		);
	};

	postForFile = (_post, isLast) => {
		const _that = this;
		let bool = true;
		FakeData.post(
			"/sharePost.php?auth0",
			this.state.posts[_post],
			{
				success(res) {
					bool = true;
					return bool;
				},
				error(err) {
					bool = true;
					return bool;
				}
			},
			isLast,
			"",
			() => { }
		);
	};

	render = () => {
		if (!this.props.isOpen) {
			return null;
		}

		const { type, post, hideSportLabel, style, isVideo } = this.props;
		const {
			activeShare,
			tabs,
			filter,
			content,
			tagged,
			canAlsoPost,
			isTagging,
			isCheckingIn,
			isPosting,
			index,
			total
		} = this.state;
		const list = this.getUsers(activeShare.key).filter(item => {
			return (
				FakeData.nullify(item.name)
					.toLowerCase()
					.indexOf(filter.toLowerCase()) > -1
			);
		});

		return (
			<Modal onClose={this.props.onClose} isOpen={this.props.isOpen} style={{
				borderRadius: isVideo ? "1.3em" : ""
			}}>
				<div
					className={"share-content"}
					style={{ width: "75vw", maxHeight: "55vw", background: "#fff", borderRadius: isVideo ? "1.3em" : "" }}
				>
					{this.is &&
						<div className={"share-content-head"}>
							<div
								className="share-content-head-drop"
								tabIndex={0}
								ref="shareCTX"
							>
								<div className="share-content-head-drop-btn">
									<img
										src={activeShare.img}
										style={{
											background: activeShare.bg,
											borderRadius: "100px",
											padding: activeShare.withPadding ? "2px" : ""
										}}
									/>
									<span>{activeShare.val}</span>
								</div>
								<div className="share-content-head-drop-menu">
									{tabs.map((item, i) => {
										if (activeShare.key === item.key) {
											return null;
										}

										if (
											FakeData.inArray(type, ["SESSIONFILE", "SESSION"]) &&
											!FakeData.inArray(item.key, ["F", "T", "Q"])
										) {
											return null;
										}

										return (
											<div
												className="share-content-head-drop-menu-btn"
												key={i}
												onClick={() => {
													this.setState({ activeShare: item });
													this.refs.shareCTX.blur();
												}}
											>
												<img
													src={item.img}
													style={{
														background: item.bg,
														borderRadius: "100px",
														padding: item.withPadding ? "2px" : ""
													}}
												/>
												<span>{item.val}</span>
											</div>
										);
									})}
								</div>
							</div>
							{!FakeData.inArray(type, ["SESSIONFILE", "SESSION"]) && (
								<div className="header-for share-content-head-actions">
									<div
										className="share-btn"
										onClick={() =>
											this.setState({
												isCheckingIn: !isCheckingIn,
												isTagging: false
											})
										}
									>
										<img
											src=".././images/checkin_gry.svg"
											alt="Where were you?"
										/>Check in
                  </div>
									<div
										className="share-btn"
										onClick={() =>
											this.setState({
												isTagging: this.state.isTagging ? false : true,
												isCheckingIn: false
											})
										}
									>
										<img
											src=".././images/tag_icon_gry.svg"
											alt="Who were you with?"
										/>Tag
                  </div>
								</div>
							)}
						</div>
					}

					<div className="who-to-see-tabs">
						<div style={{
							background: "#fff",
							height: "100%",
							flex: 3,
							color: "#345",
							fontSize: "18px",
							padding: "0px 0px 0px 20px",
							alignItems: "flex-start"
						}}>Share on timeline</div>
						{this.state.tabs.map((item, i) => {
							return (
								<div
									key={i}
									className={
										item.key === this.state.activeShare.key
											? isVideo
												? "active-video"
												: "active"
											: ""
									}
									onClick={() => {
										this.setState({
											activeShare: item,
											canRecieveActiveTab: false
										});
									}}
									style={{
										background: isVideo
											? item.key === this.state.activeShare.key
												? "#4ea3c9"
												: "#fff"
											: "",
										color: isVideo
											? item.key === this.state.activeShare.key
												? "#fff"
												: "#000"
											: ""
									}}
								>
									<img
										src={item.img}
										style={{
											background: item.bg,
											borderRadius: "100px",
											padding: item.withPadding ? "2px" : "",
											marginBottom: "5px"
										}}
									/>
									<span>{item.tag}</span>
								</div>
							);
						})}
					</div>

					{activeShare.key !== "Y" && (
						<div className={"share-content-picker"}>
							<div className={"share-content-picker-filter"}>
								<span>{activeShare.tag}</span>
								<input
									value={filter}
									placeholder={"Search " + activeShare.tag}
									onChange={e => {
										this.setState({ filter: e.target.value });
									}}
								/>
							</div>
							{list.length > 0 && (
								<div
									className="who-to-see-view to-friends-picker"
									style={{
										padding: "0px 10px",
										margin: "10px -10px 0px -10px"
									}}
								>
									{list
										.filter(item => {
											return this.inArray(item, tagged);
										})
										.map((item, i) => {
											if (i > 9) {
												return null;
											}
											return (
												<div
													key={i}
													className={"selected"}
													onClick={() => {
														const _i = tagged.indexOf(item);
														if (_i > -1) {
															tagged.splice(_i, 1);
															this.setState({ tagged });
														}
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											);
										})}
									{list
										.filter(item => {
											return !this.inArray(item, tagged);
										})
										.map((item, i) => {
											if (i > 9) {
												return null;
											}
											return (
												<div
													key={i}
													className={""}
													onClick={() => {
														item.type = activeShare.key;
														tagged.push(item);
														this.setState({ tagged });
													}}
												>
													<img src={item.image} />
													<span>{item.name}</span>
												</div>
											);
										})}
								</div>
							)}
							{list.length === 0 && (
								<div style={{ padding: "10px 0px", textAlign: "center" }}>
									No results found
                </div>
							)}
						</div>
					)}
					<div className={"share-content-body"}>
						<div className={"share-content-body-caption"}>
							<textarea
								value={content}
								placeholder="Write something..."
								onChange={e => {
									this.setState({ content: e.target.value });
								}}
							/>
						</div>
						{isVideo &&
							<div style={{
								background: "#ccc",
								height: "1px",
								margin: "0px -10px 10px"
							}} />
						}
						<div className={"share-content-body-obj"} style={{
							border: isVideo ? "none" : ""
						}}>
							{type === "POST" && (
								<div className={"posts"}>
									<SharedPostItem
										hideSportLabel={hideSportLabel ? hideSportLabel : false}
										style={style}
										user={this.props.user}
										userType={this.props.userType}
										post={post}
									/>
								</div>
							)}
							{type === "SESSIONFILE" && this.props.children}
							{type === "SESSION" && this.props.children}
							{type === "VIDEO" && this.props.children}
						</div>
					</div>
					<div className={"share-content-foot"}>
						{isTagging && (
							<div className={"share-content-foot-form"}>
								<span>With</span>
								<div>
									<TagView
										style={{ margin: "0px 5px 0px 4px;" }}
										user={FakeData.getData("yoo")}
										onAddTag={this.onAddTag.bind(this)}
										isShown="true"
										isLabel={false}
									/>
								</div>
							</div>
						)}
						{isCheckingIn && (
							<div className={"share-content-foot-form"}>
								<span>Place</span>
								<div>
									<Geosuggest
										ref={ref => (this.placeElem = ref)}
										highlightMatch={true}
										onSuggestSelect={item => {
											console.log(item);
											this.setState({
												location: item.label,
												coord: item.location
											});
											if (this.placeElem !== null) {
												this.placeElem.blur();
											}
										}}
									/>
								</div>
							</div>
						)}
						<div className={"share-content-foot-ctx"}>
							{!FakeData.inArray(type, ["SESSIONFILE", "SESSION"]) && (
								<div className="new-form-actions">
									<div
										className={"new-form-action"}
										onClick={() => {
											this.setState({
												isCheckingIn: !isCheckingIn,
												isTagging: false
											});
										}}
									>
										<i className={"material-icons"} style={{ color: "#ff006b" }}>
											location_on
                  </i>
										<span>Check in</span>
									</div>
									<div
										className={"new-form-action"}
										onClick={() => {
											this.setState({
												isTagging: this.state.isTagging ? false : true,
												isCheckingIn: false
											});
										}}
									>
										<i className={"material-icons"} style={{ color: "#4ac" }}>
											person_add
                  </i>
										<span>Tag</span>
									</div>
								</div>)
							}
							<div className={"share-content-foot-ctx-menu"}>
								{tagged.length > 0 &&
									!FakeData.inArray(type, [
										"SESSIONFILE",
										"SESSION",
										"VIDEO"
									]) && (
										<span
											onClick={() => {
												this.setState({ canAlsoPost: !canAlsoPost });
											}}
										>
											Also post on your timeline?{" "}
											<i
												className="material-icons"
												style={{ marginLeft: "5px" }}
											>
												{canAlsoPost
													? "radio_button_checked"
													: "radio_button_unchecked"}
											</i>
										</span>
									)}
								{FakeData.inArray(type, ["SESSIONFILE", "SESSION"]) && (
									<span
										onClick={() => {
											this.setState({ canAlsoPost: !canAlsoPost });
										}}
									>
										Also post to timeline?{" "}
										<i className="material-icons" style={{ marginLeft: "5px" }}>
											{canAlsoPost
												? "radio_button_checked"
												: "radio_button_unchecked"}
										</i>
									</span>
								)}
								{FakeData.inArray(type, ["VIDEO"]) && (
									<span
										onClick={() => {
											this.setState({ canAlsoPost: !canAlsoPost });
										}}
									>
										Also post to timeline?{" "}
										<i className="material-icons" style={{ marginLeft: "5px" }}>
											{canAlsoPost
												? "radio_button_checked"
												: "radio_button_unchecked"}
										</i>
									</span>
								)}
							</div>
							<div className={"share-content-foot-ctx-actions"}>
								<button
									style={{
										background: "transparent",
										color: "#4ac",
										border: "none"
									}}
									onClick={this.props.onClose}
								>
									Cancel
                </button>
								{type === "POST" && (
									<button
										style={{ background: "#4ac", color: "#fff" }}
										onClick={() => this.post()}
									>
										Post
                  </button>
								)}
								{type === "SESSIONFILE" && (
									<button
										style={{ background: "#4ac", color: "#fff" }}
										onClick={() => this.shareContent("material")}
									>
										Post
                  </button>
								)}
								{type === "SESSION" && (
									<button
										style={{ background: "#4ac", color: "#fff" }}
										onClick={() => this.shareContent("session")}
									>
										Post
                  </button>
								)}
								{type === "VIDEO" && (
									<button
										style={{ background: "#4ac", color: "#fff" }}
										onClick={() => this.postVid()}
									>
										Post
                  </button>
								)}
							</div>
						</div>
					</div>
					{isPosting && (
						<div className="share-content-posting-ov">
							<div className="share-content-posting-ov-spinner" />
							{index + 1 + " of " + total}
						</div>
					)}
				</div>
			</Modal>
		);
	};
}

export class CommentInputBox extends Component {
	constructor(p) {
		super(p);
		this.state = {
			value: "",
			isEditting: false,
			placeholder: "Write something..."
		};
	}

	componentDidMount() {
		this.europa = new Europa();
	}

	componentWillUnmount() {
		this.europa.release();
	}

	componentWillReceiveProps(nextProps) { }

	format(command, args) {
		document.execCommand(command, false, args);
	}

	insertEmoji(emoji) {
		document.execCommand("insertHTML", false, emoji);
	}

	onSave() {
		const htmlString = this.elem.innerHTML;
		const markdown = this.europa.convert(htmlString);
		//console.log(htmlString)
		//console.log(markdown)
		this.props.onSave(markdown);
	}

	deleteAll() {
		this.elem.innerHTML = "";
	}

	render() {
		//window.emojify.run(this.elem);
		return (
			<div className="comment-input-box">
				<div
					data-placeholder={this.state.placeholder}
					ref={ref => (this.elem = ref === null ? this.elem : ref)}
					className="textarea"
					contentEditable={true}
					onFocus={() => {
						this.setState({ placeholder: "" });
					}}
					tabIndex={0}
					onBlur={() => {
						this.setState({
							placeholder: this.state.value === "" ? "Write something..." : ""
						});
					}}
					onInput={e => {
						this.setState({ value: e.target.innerHTML });
						this.props.onChange(this.europa.convert(e.target.innerHTML));
					}}
					onKeyPress={e => {
						//console.log(e.keyCode)
						const _that = this;
						var code = e.keyCode || e.which;
						if (code === 13) {
							e.preventDefault();
						}
					}}
					onKeyUp={e => {
						//console.log(e.keyCode)
						const _that = this;
						var code = e.keyCode || e.which;
						if (code === 13) {
							e.preventDefault();
							this.props.onKeyUp(this.state.value, () => {
								_that.setState({ value: "" });
								_that.deleteAll();
								_that.elem.blur();
							});
						}
					}}
				/>
				{!this.props.hideEmojiKeyboard && (
					<EmojiPicker
						className={"bottom"}
						onEmojiSelect={e => this.insertEmoji(e)}
					/>
				)}
			</div>
		);
	}
}

class MediaList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isViewingMedia: false,
			position: 0
		};

		this.onMediaClick = this.onMediaClick.bind(this);
	}

	onMediaClick(item) {
		const pos = this.props.media.indexOf(item);
		this.setState({
			isViewingMedia: true,
			position: pos
		});
	}

	render() {
		return (
			<div
				className={
					this.props.media.length === 1
						? "post-media one"
						: this.props.media.length % 2
							? this.props.media.length > 3
								? "post-media overflow"
								: "post-media odd"
							: this.props.media.length > 3
								? "post-media overflow"
								: "post-media even"
				}
				style={{ width: "100%", minHeight: "250px" }}
			>
				<MediaItem
					key={"main-file-" + 0}
					file={this.props.media[0]}
					onMediaClick={this.onMediaClick}
				/>
				{this.props.media.length > 1 && (
					<div className="post-media-more">
						{this.props.media.length > 1 && (
							<div className="view">
								{this.props.media.map((item, i) => {
									if (i !== 1) {
										return null;
									} else {
										return (
											<MediaItem
												file={item}
												key={"view-file-" + i}
												onMediaClick={this.onMediaClick}
											/>
										);
									}
								})}
							</div>
						)}
						{this.props.media.length > 2 && (
							<div className="view">
								{this.props.media.length > 2 && (
									<div className="sub-view">
										{this.props.media.map((item, i) => {
											if (i !== 2) {
												return null;
											} else {
												return (
													<MediaItem
														key={"sub" + i}
														file={item}
														key={i}
														onMediaClick={this.onMediaClick}
													/>
												);
											}
										})}
									</div>
								)}
								{this.props.media.length > 3 && (
									<div className="sub-view">
										{this.props.media.map((item, i) => {
											if (i !== 3) {
												return null;
											} else {
												return (
													<MediaItem
														key={"file-" + i}
														file={item}
														key={i}
														onMediaClick={this.onMediaClick}
													/>
												);
											}
										})}
									</div>
								)}
								{this.props.media.length > 4 && (
									<div
										className="sub-view overlay"
										onClick={() => this.onMediaClick(this.props.media[4])}
									>
										<span>{"+" + (this.props.media.length - 4)}</span>
									</div>
								)}
							</div>
						)}
					</div>
				)}
				<FilePostViewer
					user={this.props.user}
					userType={this.props.userType}
					onLike={() => this.props.onLike()}
					pos={this.state.position}
					post={this.props.post}
					isOpen={this.state.isViewingMedia}
					onClose={() => {
						this.setState({
							isViewingMedia: false
						});
					}}
				/>
			</div>
		);
	}
}

export class FilePostViewer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShowingComments: true,
			isEditting: false,
			content: this.props.post.content,
			value: "",
			media: {},
			file: {}
		};
	}

	onEnter(e, id) {
		if (e.keyCode === 13 || e.which === 13) {
			const dataTo = {
				user: this.props.user,
				postId: id,
				content: this.state.value,
				type: "post",
				media: this.state.media,
				userOne: this.props.post.user,
				userTwo: this.props.post.userTo,
				users: this.props.post.tags,
				userType: this.props.userType
			};

			const _that = this;

			FakeData.post("/createComment.php?auth0", dataTo, {
				success: res => {
					_that.setState({
						value: "",
						media: {},
						file: {}
					});
				},
				error: err => { }
			});
		}
	}

	onFilePicked(file) {
		const _that = this;
		let reader = new FileReader();
		reader.onloadend = () => {
			const newFile = {
				file: file,
				progress: 0,
				url: reader.result
			};

			_that.setState({
				file: newFile
			});

			_that.uploadFile(newFile);
		};
		reader.readAsDataURL(file);
	}

	uploadFile(file) {
		var formdata = new FormData();
		const _that = this;
		formdata.append("file", file.file);
		formdata.append("location", "");
		formdata.append("albumId", 0);
		formdata.append("tags", "");
		formdata.append("userId", FakeData.getData("yoo").id);
		var ajax = new XMLHttpRequest();
		ajax.upload.addEventListener(
			"progress",
			e => {
				let percent = Math.round(e.loaded / e.total * 100);
				_that.state.file.progress = percent;
				_that.setState({
					file: _that.state.file
				});
			},
			false
		);
		ajax.addEventListener(
			"load",
			e => {
				let data = JSON.parse(e.target.responseText);
				if (data.id) {
					data.oldUrl = file.url;
					_that.setState({
						media: data
					});
				} else {
					_that.setState({ media: {}, file: {} });
					alert("Error uploading file...");
				}
			},
			false
		);
		ajax.open(
			"POST",
			FakeData.URL +
			"/uploadMedia.php?auth0&userId=" +
			FakeData.getData("yoo").id
		);
		ajax.send(formdata);
	}

	deleteMedia() {
		const file = this.state.media;
		const _that = this;
		const dataTo = {
			userId: FakeData.getData("yoo").id,
			img: file,
			tags: this.state.tags
		};

		FakeData.post(
			"/removeMedia.php?auth0",
			dataTo,
			{
				success: res => {
					_that.setState({
						media: {},
						file: {}
					});
				},
				error: err => { }
			},
			true,
			"File Was Removed",
			res => { }
		);
	}

	onClose() {
		this.props.onClose();
	}

	render() {
		const items = this.props.post.media;
		const post = this.props.post;
		const User = FakeData.getData("yoo");
		return (
			<Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
				<div data-photo-slider="">
					<div data-photos="">
						{items.map((item, i) => {
							return (
								<div
									data-photo=""
									key={i}
									className={this.props.pos === i ? "active" : ""}
								>
									<MediaItem key={i} file={item} />
								</div>
							);
						})}
						<div data-photo-info>
							<div className="content">
								<div className="header">
									<img src={post.user.image} className="avatar" />
									<div className="author">
										<h1>{post.user.name}</h1>
										<span>{post.timeAgo}</span>
									</div>
								</div>
								<div className="body">{post.content}</div>
								<div className="actions">
									<div className="action" onClick={() => this.props.onLike()}>
										<i className="material-icons">thumb_up</i>
										<span>
											{post.likes.length / 6 > 1000000
												? post.likes.length / 6 + "m likes"
												: post.likes.length / 3 > 1000
													? post.likes.length / 3 + "k likes"
													: post.likes.length === 1
														? post.likes.length + " like"
														: post.likes.length === 0
															? "Like"
															: post.likes.length + " likes"}
										</span>
									</div>
									<div
										className="action"
										onClick={() => {
											this.setState({
												isShowingComments: this.state.isShowingComments
													? false
													: true
											});
										}}
									>
										<i className="material-icons">chat_bubble</i>
										<span>
											{post.comments.length / 6 > 1000000
												? post.comments.length / 6 + "m likes"
												: post.comments.length / 3 > 1000
													? post.comments.length / 3 + "k comments"
													: post.comments.length === 1
														? post.comments.length + " comment"
														: post.comments.length === 0
															? "Comment"
															: post.comments.length + " comments"}
										</span>
									</div>
									<div className="action">
										<i
											className="material-icons"
											style={{ transform: "rotateY(-180deg)" }}
										>
											reply
                    </i>
										<span>
											{post.shares.length / 6 > 1000000
												? post.shares.length / 6 + "m likes"
												: post.shares.length / 3 > 1000
													? post.shares.length / 3 + "k shares"
													: post.shares.length === 1
														? post.shares.length + " share"
														: post.shares.length === 0
															? "Share"
															: post.shares.length + " shares"}
										</span>
									</div>
								</div>
								{this.state.isShowingComments && (
									<div className="body-comments">
										<CommentCollection
											user={this.props.user}
											userType={this.props.userType}
											comments={post.comments}
										/>
										{this.state.file.url && (
											<div className="img-preload">
												<img src={this.state.file.url} />
												{this.state.file.progress <= 99 && (
													<div className="img-preload-spinner" />
												)}
												{this.state.file.progress >= 99 && (
													<i
														className="img-preload-delete material-icons"
														onClick={() => this.deleteMedia()}
													>
														delete
                          </i>
												)}
											</div>
										)}
										<div className="body-comment-input">
											<img src={User.image} />
											<textarea
												placeholder="Write something.."
												onKeyPress={e => {
													if (e.keyCode === 13 || e.which === 13) {
														e.preventDefault();
													}
												}}
												onKeyUp={e => this.onEnter(e, post.id)}
												value={this.state.value}
												onChange={e =>
													this.setState({
														value: e.target.value
													})
												}
											/>
											<i className="material-icons">
												camera_alt<input
													type="file"
													accept="image/*"
													onChange={e => this.onFilePicked(e.target.files[0])}
													multiple="false"
													style={{
														position: "absolute",
														margin: "-35px 0px 0px -10px",
														height: "30px",
														width: "30px",
														opacity: 0
													}}
												/>
											</i>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export const AngularTemplateView = () => { };

export class MediaItem extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this._isMounted = true;
		if (this.props.file.type === "video") {
			this.player = null;
			const { video, useClapper } = this.props;
			const opts = {
				width: "100%",
				watermark: FakeData.baseURL + "/images/supotsu_logo.svg",
				position: "top-left",
				watermarkLink: FakeData.baseURL
			};

			const _that = this;
			const arr = this.props.file.url.split("/");
			let path = arr[arr.length - 1];
			path = "http://supotsu.com:2017/video/" + path;
			console.log(Clappr)
			try {
				this.player = new Clappr.Player({
					source: path,
					mimeType: "video/flv",
					plugins: [FLVJSPlayback],
					playback: {
						flvjsConfig: {}
					},
					...opts
				});

				this.player.attachTo(this.refs["video_holder"]);
			} catch (error) {

			}

		}
	}

	componentWillUnmount() {
		this._isMounted = !true;
	}

	render() {
		if (this.props.file.isLink) {
			return (
				<EmbedVideo
					src={this.props.file.link}
					width={"100%"}
					height={"100%"}
					type={this.props.file.source}
					id={this.props.file.id}
				/>
			);
		} else if (this.props.file.type === "image") {
			return (
				<img
					style={{ width: this.props.width, height: this.props.height }}
					src={this.props.file.url}
					onClick={() => {
						if (this.props.onMediaClick) {
							this.props.onMediaClick(this.props.file);
						}
					}}
				/>
			);
		} else if (this.props.file.type === "video") {
			return (
				<div
					className="media-item-video"
					ref={"video_holder"}
					style={{
						width: "100%",
						height: !this.props.onMediaClick ? "100%" : "",
						background: "#000"
					}}
					onClick={() => {
						if (this.props.onMediaClick) {
							this.props.onMediaClick(this.props.file);
						}
					}}
				/>
			);
		} else if (this.props.file.type === "doc") {
			return (
				<iframe
					src={
						"https://view.officeapps.live.com/op/embed.aspx?src=" +
						FakeData.URL.replace("server", "") +
						this.props.file.url
					}
					width={"100%"}
					height={"100%"}
					frameBorder="0"
					allowFullScreen={true}
				/>
			);
		}
	}
}

export class Img extends Component {
	constructor(props) {
		super(props);
		this.state = {
			state: "preload"
		};

		this.onLoad = this.onLoad.bind(this);
	}

	onLoad(e) {
		const elem = e.target;
		this.setState({ state: "complete" });
	}

	render() {
		const { state } = this.state;
		return (
			<img
				data-state={state}
				alt=""
				onLoad={this.onLoad}
				ref={ref => (this.elem = ref === null ? this.elem : ref)}
				{...this.props}
			/>
		);
	}
}

export class RawMediaItem extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.type.indexOf("image") > -1) {
			return <img src={this.props.url} />;
		} else {
			return <video src={this.props.url} controls preload="none" />;
		}
	}
}

export const ClubItem = props => {
	return (
		<div className={props.isPast ? "club-item past" : "club-item"}>
			<div className="club-item-header">
				<img src={props.team.image} />
				<div className="club-item-header-info">
					<h2>{props.team.name}</h2>
					<span>{props.team.sport}</span>
				</div>
			</div>
			<div className="club-item-body">
				<div className="club-item-body-info">
					<div>
						<span>Appearances</span>
						<span>{props.team.appearances}</span>
					</div>
					<div>
						<span>Goals</span>
						<span>{props.team.goals}</span>
					</div>
				</div>
				<Link
					to={{
						pathname: "/team/" + (props.team.username ? props.team.username : props.team.id),
						search: "?squad_id=" + props.team.squadId
					}}
				>
					View Club
        </Link>
			</div>
		</div>
	);
};

export class PastClubsView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: this.props.teams[0],
			filter: ""
		};
	}

	filterTeams(val) {
		this.setState({
			filter: val
		});

		const arr = [];
		this.state.activeTab.teams.forEach((item, i) => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
				arr.push(item);
				this.state.activeTab.data = arr;
				this.setState({
					activeTab: this.state.activeTab
				});
			}
		});
	}

	render() {
		const items = this.props.teams;
		return (
			<div className="past-clubs-view">
				<div
					style={{ width: "250px", marginRight: "20px", marginLeft: "-20px" }}
				>
					{items.map((item, i) => (
						<div
							className={this.state.activeTab.id === item.id ? "active" : ""}
							key={i}
							onClick={() => {
								this.setState({
									activeTab: item
								});
							}}
						>
							{item.name}
						</div>
					))}

					<div className="past-clubs-view-search">
						<input
							onChange={e => this.filterTeams(e.target.value)}
							value={this.state.filter}
						/>
						<img src=".././images/search_friend.svg" />
					</div>
				</div>
				<div className="club-list" style={{ flex: 1 }}>
					{this.state.activeTab.data.map((item, i) => (
						<ClubItem team={item} key={i} isPast="true" />
					))}
				</div>
			</div>
		);
	}
}

export class IntroOverlayTarget extends Component {
	constructor(props) {
		super(props);
		this.state = {
			views: this.props.views,
			index: this.props.index
		};
	}
	render() {
		return (
			<div className="intro-overlay">
				<div className="target" />
				<div className="content" />
			</div>
		);
	}
}

IntroOverlayTarget.propTypes = {
	index: PropTypes.number,
	views: PropTypes.array
};

export class InfiniteScrollView extends Component {
	constructor(props) {
		super(props);
		this.scroll = this.scroll.bind(this);
	}

	componentDidMount() {
		if (document.querySelectorAll("#root")[0]) {
			document
				.querySelectorAll("#root")[0]
				.addEventListener("scroll", this.scroll);
		}
	}

	componentWillUnmount() {
		try {
			if (document.querySelectorAll("#root")[0]) {
				document.querySelectorAll("#root")[0].removeEventListener("scroll");
			}
		} catch (error) { }
	}

	scroll = e => {
		if (this.props.onScrollCallBack) {
			this.props.onScrollCallBack(e);
		}

		if (e.target.offsetHeight + e.target.scrollTop == e.target.scrollHeight) {
			if (this.props.onScrollEndCallBack) {
				this.props.onScrollEndCallBack(e);
			}
		}
	};

	render = () => {
		return this.props.children;
	};
}

InfiniteScrollView.propTypes = {
	onScrollCallBack: PropTypes.func.isRequired,
	onScrollEndCallBack: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Common.js